export default {
    common: {
        response_400: '错误请求',
        response_401: '登录状态已过期，请重新登录',
        response_403: '服务器拒绝响应，你可能没有权限',
        response_404: '请求错误，未找到该资源',
        response_405: '请求方法未允许',
        response_408: '请求超时',
        response_429: '操作过于频繁，请稍后再试',
        response_500: '服务器端出错',
        response_501: '网络未实现',
        response_502: '网络错误',
        response_503: '服务不可用',
        response_504: '网络超时',
        response_505: 'http版本不支持该请求',
        response_59574: '项目中包含未预翻译完成的文件不可下载',
        response_default: '连接错误，CODE：{code}',
        network_error: '处理失败，请检查网络',
        notice_title: '提醒',
        notice_message_1: '缓存失效，请刷新页面后重试。',
        notice_message_2: '任务已失效',
        notice_button_1: '刷新页面',
        notice_button_2: '返回任务列表',
        notice_button_3: '确定',
        exception_message_1: 'url没有传入！',
        country_code_list: [
            {name: '阿尔巴尼亚', code: '355'},
            // {name: '阿根廷', code: '54'},
            // {name: '阿拉伯联合酋长国', code: '971'},
            // {name: '阿鲁巴', code: '297'},
            // {name: '爱尔兰', code: '353'},
            {name: '爱沙尼亚', code: '372'},
            // {name: '安道尔', code: '376'},
            // {name: '安哥拉', code: '244'},
            // {name: '安圭拉', code: '1264'},
            // {name: '安提瓜和巴布达', code: '1268'},
            // {name: '奥地利', code: '43'},
            {name: '澳大利亚', code: '61'},
            // {name: '巴巴多斯', code: '1246'},
            // {name: '巴布亚新几内亚', code: '675'},
            // {name: '巴哈马', code: '1242'},
            // {name: '巴拉圭', code: '595'},
            // {name: '巴林', code: '973'},
            // {name: '巴拿马', code: '507'},
            // {name: '巴西', code: '55'},
            // {name: '百慕大群岛', code: '1441'},
            {name: '保加利亚', code: '359'},
            // {name: '比利时', code: '32'},
            // {name: '冰岛', code: '354'},
            // {name: '波多黎各', code: '1787'},
            {name: '波兰', code: '48'},
            // {name: '波斯尼亚和黑塞哥维那', code: '387'},
            // {name: '伯利兹', code: '501'},
            // {name: '博茨瓦纳', code: '267'},
            // {name: '布基纳法索', code: '226'},
            // {name: '布隆迪', code: '257'},
            // {name: '朝鲜', code: '850'},
            // {name: '赤道几内亚', code: '240'},
            {name: '丹麦', code: '45'},
            // {name: '东帝汶', code: '670'},
            // {name: '多哥', code: '228'},
            // {name: '多米尼加共和国', code: '1809'},
            // {name: '多米尼克', code: '1767'},
            // {name: '厄立特里亚', code: '291'},
            {name: '法国', code: '33'},
            // {name: '法罗群岛', code: '298'},
            // {name: '斐济', code: '679'},
            {name: '芬兰', code: '358'},
            // {name: '佛得角', code: '238'},
            // {name: '冈比亚', code: '220'},
            // {name: '刚果共和国', code: '242'},
            // {name: '刚果民主共和国（扎伊尔）', code: '243'},
            // {name: '哥伦比亚', code: '57'},
            // {name: '哥斯达黎加', code: '506'},
            // {name: '格林纳达', code: '1473'},
            // {name: '格陵兰岛', code: '299'},
            // {name: '古巴', code: '53'},
            // {name: '关岛', code: '1671'},
            // {name: '圭亚那', code: '592'},
            // {name: '哈萨克斯坦', code: '997'},
            // {name: '海地', code: '509'},
            {name: '韩国', code: '82'},
            {name: '荷兰', code: '31'},
            // {name: '黑山', code: '382'},
            // {name: '洪都拉斯', code: '504'},
            // {name: '基里巴斯', code: '686'},
            // {name: '吉布提', code: '253'},
            // {name: '几内亚', code: '224'},
            // {name: '几内亚比绍共和国', code: '245'},
            {name: '加拿大', code: '1'},
            // {name: '加蓬', code: '241'},
            {name: '捷克', code: '420'},
            // {name: '津巴布韦', code: '263'},
            // {name: '喀麦隆', code: '237'},
            // {name: '卡塔尔', code: '974'},
            // {name: '开曼群岛', code: '1345'},
            // {name: '科摩罗', code: '269'},
            // {name: '科特迪瓦', code: '225'},
            {name: '克罗地亚', code: '385'},
            // {name: '肯尼亚', code: '254'},
            // {name: '拉脱维亚', code: '371'},
            // {name: '莱索托', code: '266'},
            {name: '老挝', code: '856'},
            {name: '立陶宛', code: '370'},
            // {name: '利比里亚', code: '231'},
            // {name: '列支敦士登', code: '423'},
            // {name: '卢森堡', code: '352'},
            // {name: '卢旺达', code: '250'},
            {name: '罗马尼亚', code: '40'},
            // {name: '马达加斯加', code: '261'},
            // {name: '马尔代夫', code: '960'},
            // {name: '马耳他', code: '356'},
            {name: '马来西亚', code: '60'},
            // {name: '马里亚纳群岛', code: '1670'},
            {name: '马其顿', code: '389'},
            // {name: '马约特', code: '262'},
            // {name: '毛里求斯', code: '230'},
            {name: '美国', code: '1'},
            // {name: '美属萨摩亚', code: '1684'},
            // {name: '美属维尔京群岛', code: '1340'},
            // {name: '蒙特塞拉特岛', code: '1664'},
            // {name: '秘鲁', code: '51'},
            // {name: '密克罗尼西亚', code: '691'},
            // {name: '摩尔多瓦', code: '373'},
            // {name: '摩洛哥', code: '212'},
            // {name: '摩纳哥', code: '377'},
            // {name: '莫桑比克', code: '258'},
            // {name: '墨西哥', code: '52'},
            // {name: '纳米比亚', code: '264'},
            // {name: '南非', code: '27'},
            // {name: '南苏丹', code: '211'},
            // {name: '尼加拉瓜', code: '505'},
            // {name: '尼日尔', code: '227'},
            // {name: '挪威', code: '47'},
            // {name: '诺福克岛', code: '6723'},
            // {name: '帕劳', code: '680'},
            {name: '葡萄牙', code: '351'},
            {name: '日本', code: '81'},
            {name: '瑞典', code: '46'},
            // {name: '瑞士', code: '41'},
            // {name: '萨尔瓦多', code: '503'},
            // {name: '萨摩亚', code: '685'},
            // {name: '塞尔维亚', code: '381'},
            {name: '塞拉利昂', code: '232'},
            // {name: '塞浦路斯', code: '357'},
            // {name: '塞舌尔', code: '248'},
            // {name: '沙特阿拉伯', code: '966'},
            // {name: '圣彼埃尔和密克隆岛', code: '508'},
            // {name: '圣多美和普林西比', code: '239'},
            // {name: '圣基茨和尼维斯', code: '1869'},
            // {name: '圣卢西亚', code: '1758'},
            // {name: '圣马丁岛（荷兰部分）', code: '1721'},
            // {name: '圣马力诺', code: '378'},
            // {name: '圣文森特和格林纳丁斯', code: '1784'},
            {name: '斯洛伐克', code: '421'},
            // {name: '斯洛文尼亚', code: '386'},
            // {name: '斯威士兰', code: '268'},
            // {name: '苏里南', code: '597'},
            // {name: '所罗门群岛', code: '677'},
            {name: '泰国', code: '66'},
            // {name: '坦桑尼亚', code: '255'},
            // {name: '汤加', code: '676'},
            // {name: '特克斯和凯科斯群岛', code: '1649'},
            // {name: '特立尼达和多巴哥', code: '1868'},
            {name: '土耳其', code: '90'},
            // {name: '瓦努阿图', code: '678'},
            // {name: '危地马拉', code: '502'},
            // {name: '委内瑞拉', code: '58'},
            // {name: '文莱', code: '673'},
            // {name: '乌拉圭', code: '598'},
            {name: '西班牙', code: '34'},
            {name: '希腊', code: '30'},
            {name: '新加坡', code: '65'},
            // {name: '新喀里多尼亚', code: '687'},
            {name: '匈牙利', code: '36'},
            // {name: '牙买加', code: '1876'},
            {name: '意大利', code: '39'},
            {name: '印度', code: '91'},
            {name: '英国', code: '44'},
            // {name: '英属维尔京群岛', code: '1284'},
            {name: '越南', code: '84'},
            // {name: '赞比亚', code: '260'},
            // {name: '直布罗陀', code: '350'},
            // {name: '智利', code: '56'},
            // {name: '中非共和国', code: '236'},
            {name: '中国澳门', code: '853'},
            {name: '中国大陆', code: '86'},
            {name: '中国台湾', code: '886'},
            {name: '中国香港', code: '852'},
        ],
        notfind_page_btn_1: '返回首页',
    },
    component: {
        LanguageSelector_autoLang_result: '检测到{name}',
        LanguageSelector_autoLang_label: '自动检测',
        LanguageSelector_button_exchang: '点击切换',
        LanguageSelector_source_language_name: '中文',
        LanguageSelector_source_language_short_name: '中',
        LanguageSelector_target_language_name: '英语',
        LanguageSelector_target_language_short_name: '英',
        LanguageSelector_search_input_placeholder: '查找语言',

        LanguageSelect_button_exchang: '点击切换',

        PageHeader_vip_name: '套餐',
        PageHeader_help_item_1: '帮助文档',
        PageHeader_help_item_2: '使用反馈',
        PageHeader_help_item_3: '用户社区',
        PageHeader_help_item_4: '申请开票',
        PageHeader_version_title: '版本升级',
        PageHeader_version_label_new: '新',

        PageHeaderTabs_tab_memory: '记忆库',
        PageHeaderTabs_tab_term: '术语库',
        PageHeaderTabs_tab_polish: 'AI润色',
        PageHeaderTabs_tab_translationScore: 'AI翻译评分',
        PageHeaderTabs_tab_align: '语料对齐',
        PageHeaderTabs_tab_termExtraction: '术语提取',
        PageHeaderTabs_tab_qa: 'QA检查',
        PageHeaderTabs_tab_detector: '机翻检测',
        PageHeaderTabs_tab_videoTranslate: 'AI译配',
        PageHeaderTabs_tab_gptTranslate: '文档智能体',
        PageHeaderTabs_tab_ragCreate: '定制RAG模型',
        PageHeaderTabs_tab_engineCreate: '深度训练',
        PageHeaderTabs_tab_myTasks: '我的任务',
        PageHeaderTabs_tab_taskStatistics: '任务统计',
        PageHeaderTabs_tab_projectIndex: '我的项目',
        PageHeaderTabs_tab_projectTemplate: '项目模板',

        DownloadNotices_drag_tips: '按下鼠标移动位置',
        DownloadNotices_status_name_1: '导出中，请耐心等待',
        DownloadNotices_status_name_2: '导出成功',
        DownloadNotices_status_name_3: '导出失败',
        DownloadNotices_button_download: '点击下载',
        DownloadNotices_download_link_fail_message: '获取下载地址失败，请重试',
        DownloadNotices_download_delete_remote_file_success: '删除远程下载资源成功',

        DragDialog_title: '提示',

        MessageCenter_title: '消息中心',
        MessageCenter_button_read_all: '全部已读',
        MessageCenter_tab_label_all: '全部',
        MessageCenter_tab_label_unread: '未读',
        MessageCenter_tab_label_read: '已读',
        MessageCenter_message_createTime_format: 'MM月DD日 HH:mm',
        MessageCenter_button_join: '加入',
        MessageCenter_button_go_review: '去审核',
        MessageCenter_no_message_tips: '暂无消息',

        UserAvatarMenu_expireTime_format: 'YYYY-MM-DD',
        UserAvatarMenu_expireTime_label: '到期',
        UserAvatarMenu_expireTime_label_expired: '已过期',
        UserAvatarMenu_upgrade_to_pro: '升级PRO版',
        UserAvatarMenu_info_label_1: '成员数：',
        UserAvatarMenu_info_label_2: '总字符：',
        UserAvatarMenu_info_label_3: 'Token数：',
        UserAvatarMenu_button_switch_org: '切换组织',
        UserAvatarMenu_button_user_center: '个人中心',
        UserAvatarMenu_button_org_center: '企业中心',
        UserAvatarMenu_button_logout: '退出登录',
        UserAvatarMenu_message_switching_org: '正在切换组织...',

        LeftAside_slogan: '多模态多智能体平台',
        LeftAside_menu_item_help: '帮助',
        LeftAside_menu_item_help_child_1: '帮助文档',
        LeftAside_menu_item_help_child_2: '使用反馈',
        LeftAside_menu_item_help_child_3: '用户社区',
        LeftAside_menu_item_help_child_4: '申请开票',
        LeftAside_menu_item_engine: '模型',
        LeftAside_menu_item_project: '项目',
        LeftAside_menu_item_task: '任务',
        LeftAside_menu_item_asset: '资产',
        LeftAside_menu_item_tools: 'Y魔方',
        LeftAside_menu_item_history: '历史',
        LeftAside_menu_item_agent: '智能体',
        LeftAside_menu_item_team: '团队',

        AlertDialog_title: '提示',
        AlertDialog_button_confirm: '确定',
        AlertDialog_button_cancel: '取消',

        BindWechat_title: '绑定微信',
        BindWechat_scan_qrcode_title: '微信扫码',
        BindWechat_button_refresh: '点击刷新',
        BindWechat_qrcode_overdue_tips: '二维码已过期',
        BindWechat_tips_1: '扫码并关注【LanguageX】公众号，',
        BindWechat_tips_2: '我们的信息不会太多，但对你很重要~',
        BindWechat_bind_success_message: '绑定成功', 

        FullLoading_title: '查询中...',

        JargonDialog_title: '术语定制（项目术语库）',
        JargonDialog_tips: '你新建项目上传或挂载的术语已生效，此处新增的术语将继续写入当前项目指定的术语库中',
        JargonDialog_tooltip_content: '支持xlsx/xls/tbx格式',
        JargonDialog_button_upload_title: '上传术语库',
        JargonDialog_button_download_template: '下载模板',
        JargonDialog_input_search_placeholder: '搜索术语',
        JargonDialog_table_column_index_label: '序号',
        JargonDialog_table_column_source_label: '原文',
        JargonDialog_table_column_target_label: '译文',
        JargonDialog_table_column_remark_label: '备注',
        JargonDialog_table_column_action_label: '操作',
        JargonDialog_input_source_placeholder: '输入术语原文',
        JargonDialog_input_target_placeholder: '输入术语译文',
        JargonDialog_input_remark_placeholder: '输入备注',
        JargonDialog_button_save: '保存',
        JargonDialog_button_cancel: '取消',
        JargonDialog_button_edit: '编辑',
        JargonDialog_button_delete: '删除',
        JargonDialog_button_reTranslate: '重译',
        JargonDialog_button_delete_confirm_title: '确定删除吗？',
        JargonDialog_downloading_template_message: '下载中...',
        JargonDialog_download_fail_message: '获取下载地址失败',
        JargonDialog_term_upload_verification_message: '请确认已上传文件并上传成功',
        JargonDialog_term_upload_success_message: '上传成功',
        JargonDialog_term_source_verification_message: '术语原文不能为空',
        JargonDialog_term_target_verification_message: '术语译文不能为空',
        JargonDialog_save_success_message: '保存成功',
        JargonDialog_delete_success_message: '已删除',

        NextCollapse_title: '标题',

        NextDrawer_button_close: '关闭',
        NextDrawer_button_confirm: '确认',

        PageTitle_input_title_placeholder: '输入标题，回车保存',
        PageTitle_edit_title_tooltip_content: '点击编辑，回车保存',
        PageTitle_save_title_verification_message: '名称不能为空',

        PayErpDialog_title: '购买企业版',
        PayErpDialog_success_message_1: '企业版订阅成功',
        PayErpDialog_success_message_2: '感谢您的信任，欢迎加入用户交流群~',
        PayErpDialog_success_message_3: '扫码加入官方交流群',
        PayErpDialog_button_apply_invoice: '申请开票',
        PayErpDialog_form_startTime_label: '服务开始时间',
        PayErpDialog_form_startTime_placeholder: '选择服务开始时间',
        PayErpDialog_form_endTime_label: '服务结束时间',
        PayErpDialog_form_endTime_placeholder: '选择服务结束时间',
        PayErpDialog_form_orgName_label: '企业全称',
        PayErpDialog_form_orgName_placeholder: '企业全称，必填',
        PayErpDialog_form_button_cofirm: '确认并生成协议',
        PayErpDialog_form_orgName_tips_1: '如果企业全称显示为LXO开头的内容，',
        PayErpDialog_form_orgName_tips_2: '请修改',
        PayErpDialog_form_orderNo_label: '订单编号',
        PayErpDialog_form_amount_label: '付款金额',
        PayErpDialog_form_scan_label: '扫码支付',
        PayErpDialog_form_scan_platform_wechat: '微信',
        PayErpDialog_currency_symbol: '￥',
        PayErpDialog_form_org_benefits_tips: '了解企业版本更多权益',
        PayErpDialog_form_cofirm_tips_1: '点击“确认并生成协议”按钮',
        PayErpDialog_form_cofirm_tips_2: '在新页面确认合同后返回此页面付款',
        PayErpDialog_bottom_tips_1: '订阅LanguageX服务，即表示同意我们的',
        PayErpDialog_bottom_tips_2: '《服务协议》',
        PayErpDialog_bottom_tips_3: '和',
        PayErpDialog_bottom_tips_4: '《隐私政策》',
        PayErpDialog_pay_fail_message: '支付失败!',
        PayErpDialog_orgName_verification_message: '请填写企业全称!',
        PayErpDialog_orgName_LOX_verification_message: '请联系当前企业管理员修改企业名称后再试',

        PayProDialog_title: '购买PRO版',
        PayProDialog_success_message_1: '会员订阅成功',
        PayProDialog_success_message_2: '感谢您的信任，欢迎加入用户交流群~',
        PayProDialog_success_message_3: '扫码加入官方交流群',
        PayProDialog_button_apply_invoice: '申请开票',
        PayProDialog_currency_symbol: '￥',
        PayProDialog_label_time_limit: '限时买1得1',
        PayProDialog_form_orderNo_label: '订单编号',
        PayProDialog_form_amount_label: '付款金额',
        PayProDialog_form_scan_label: '扫码支付',
        PayProDialog_form_scan_platform_wechat: '微信',
        PayProDialog_form_org_benefits_tips: '了解PRO版本更多权益',
        PayProDialog_bottom_tips_1: '订阅LanguageX服务，即表示同意我们的',
        PayProDialog_bottom_tips_2: '《服务协议》',
        PayProDialog_bottom_tips_3: '和',
        PayProDialog_bottom_tips_4: '《隐私政策》',
        PayProDialog_pay_fail_message: '支付失败!',

        QaSetting_title: 'QA设置',
        QaSetting_type_title_1: '规则QA设置',
        QaSetting_type_title_2: '智能QA设置',
        QaSetting_type_title_3: 'QA处理流程设置',
        QaSetting_tips_1: '处理完QA才允许提交任务',
        QaSetting_tips_2: '如需修改QA检查项配置，请前往 项目详情 > QA设置',
        QaSetting_support_tooltip_content: '智能QA只对Pro版开放，Free用户QA只提供规则QA',
        QaSetting_fluency_tips: '英文流利度（包括用词搭配、时态、单复数、句首大小、代词/冠词、英文流利度检查）',
        QaSetting_button_cancel: '取消',
        QaSetting_button_submit: '确定',
        QaSetting_success_message: 'QA配置已更新',

        UpgradePro_message_1: '请先完成账户升级',
        UpgradePro_pro_limited_label: '已到期',
        UpgradePro_message_2: '当前正在使用的版本，暂无法使用该功能。升级账户解锁更多高级功能',
        UpgradePro_button_upgrade: '升级到PRO',

        UploadFiles_file_upload_status_fail: '失败',
        UploadFiles_file_upload_status_success: '成功',
        UploadFiles_file_accept_message: '支持{accept}格式的文件',
        UploadFiles_file_limit_message: '最多只能上传{limit}个文件',
        UploadFiles_file_size_message: '{name}大于{size}MB',
        UploadFiles_file_exist_message: '{name}已存在',
        UploadFiles_login_expired_message: '登录状态已过期，请重新登录',
        UploadFiles_file_upload_fail_message: '{name}上传失败，请重试',

        UploadOss_title: '上传文件',
        UploadOss_file_accept_message: '支持{accept}格式的文件',
        UploadOss_file_limit_message: '最多只能上传{limit}个文件',
        UploadOss_file_empty_message: '不支持上传空文件',
        UploadOss_file_size_message: '{name}大于{size}MB',
        UploadOss_file_exist_message: '{name}已存在',
        UploadOss_file_upload_fail_message: '文件上传失败，请重试',

        UserSelect_select_placeholder: '请选择',

        UserSelector_search_input_placeholder: '输入关键字搜索',
        UserSelector_empty_description: '暂无内容',

        UserSelectorDialog_title: '分配译员',
        UserSelectorDialog_form_name_label: '译员名称',
        UserSelectorDialog_form_name_placeholder: '请选择',
        UserSelectorDialog_button_cancel: '取消',
        UserSelectorDialog_button_submit: '确定',

        PayCharsDialog_title: '字符包',
        PayCharsDialog_tips_1: '购买成功',
        PayCharsDialog_tips_2: '感谢您的信任，欢迎加入用户交流群~',
        PayCharsDialog_tips_3: '扫码加入官方交流群',
        PayCharsDialog_tips_4: '{number}万字符',
        PayCharsDialog_tips_5: '{price}元/万字符',
        PayCharsDialog_tips_6: '￥{price}',
        PayCharsDialog_tips_7: '订单编号',
        PayCharsDialog_tips_8: '付款金额',
        PayCharsDialog_tips_9: '扫码支付',
        PayCharsDialog_tips_10: '了解PRO版本更多权益',
        PayCharsDialog_tips_11: '订阅LanguageX服务，即表示同意我们的',
        PayCharsDialog_tips_12: '《服务协议》',
        PayCharsDialog_tips_13: '和',
        PayCharsDialog_tips_14: '《隐私政策》',
        PayCharsDialog_tips_15: '微信',
        PayCharsDialog_method_pollingOrderStatus_message_1: '支付失败!',

        PayTokenDialog_title: '智能体Token',
        PayTokenDialog_tips_1: '购买成功',
        PayTokenDialog_tips_2: '感谢您的信任，欢迎关注公众号和我们保持联系~',
        PayTokenDialog_tips_3: '扫码关注公众号',
        PayTokenDialog_tips_4: '微信',
        PayTokenDialog_tips_6: '￥{price}',
        PayTokenDialog_tips_7: '订单编号',
        PayTokenDialog_tips_8: '付款金额',
        PayTokenDialog_tips_9: '扫码支付',
        PayTokenDialog_tips_10: '订阅LanguageX服务，即表示同意我们的',
        PayTokenDialog_tips_11: '《服务协议》',
        PayTokenDialog_tips_12: '和',
        PayTokenDialog_tips_13: '《隐私政策》',
        PayTokenDialog_method_pollingOrderStatus_message_1: '支付失败!',









    },
    engine: {
        config_page_title: '翻译模型',
        config_page_button_term_setting: '术语定制',
        config_page_source_input_placeholder: '粘贴一段文字，快速对比不同模型翻译结果，每次最多2000字',
        config_page_button_change: '换一换',
        config_page_button_try: '试一试样例',
        config_page_button_upload: '上传文件',
        config_page_tooltip_engine_detail: '查看模型详情',
        config_page_tooltip_engine_create: '新建模型',
        config_page_message_1: '除了通用模型，你还可以',
        config_page_message_2: '训练自己的个性模型',
        config_page_message_3: '当前语言方向没有个性模型，试试自己新建一个',
        config_page_message_4: '你的PRO版账号已过期，创建的个性模型已暂停服务，续费后恢复服务，',
        config_page_message_5: '去续费',
        config_page_message_6: '翻译中，请稍等',
        config_page_message_7: '个性模型因会员到期已下架，续订后会恢复服务~',
        config_page_message_8: 'Pro版专属模型，升级为Pro版可用。',
        config_page_message_9: '去升级',
        config_page_message_10: '已复制到剪切板',
        config_page_message_11: '复制到剪切板失败，请重试',
        config_page_message_12: '请选择源语言',
        config_page_message_13: '术语定制已开启',
        config_page_message_14: '术语定制已关闭',
        config_page_message_15: '当前语言方向下无此术语',
        config_page_message_16: '原文：',
        config_page_message_17: '最多润色{count}次',
        config_page_message_18: 'DeepSeek 翻译速度较慢，如需快速翻译请选用其他模型',
        
        config_page_button_copy: '复制',
        config_page_button_edit: '编辑',
        config_page_button_show_difference: '显示差异',
        config_page_button_clear_history: '清空历史',
        config_page_button_polish: '润色',
        config_page_button_polish_again: '再次润色',

        config_page_term_title: '术语定制',
        config_page_term_descoption: '添加术语试一试，每个语言方向最多20个。如需批量添加术语和翻译文件，点击上传文件去新建项目。',
        config_page_term_table_label_1: '序号',
        config_page_term_table_label_2: '原文（{name}）',
        config_page_term_table_label_3: '译文（{name}）',
        config_page_term_table_label_4: '操作',
        config_page_term_table_input_1: '输入术语原文',
        config_page_term_table_input_2: '输入术语译文',
        config_page_term_table_button_1: '保存（Enter）',
        config_page_term_table_button_2: '删除',
        config_page_term_table_button_3: '编辑',
        config_page_term_verification_message_1: '术语原文不能为空',
        config_page_term_verification_message_2: '术语译文不能为空',
        config_page_term_message_1: '保存术语成功',
        config_page_term_message_2: '术语已删除',
        
        ragCreate_page_title: '定制RAG模型',
        ragCreate_page_alert_1_part1: '{type}最多能创建{size}个个性模型，你的账户创建数量已达到上限，如需新建个性模型，',
        ragCreate_page_alert_1_part2: '请联系我们',
        ragCreate_page_alert_2: 'RAG（检索增强式生成）可以让大语言模型结合记忆库/术语库和特殊要求，更专业地翻译垂直领域内容',
        ragCreate_page_form_model_label: '模型名称',
        ragCreate_page_form_model_placeholder: '给自己翻译模型起个名字，不超过10个字符',
        ragCreate_page_form_language_label: '语言方向',
        ragCreate_page_form_language_source_placeholder: '源语言',
        ragCreate_page_form_language_target_placeholder: '目标语言',
        ragCreate_page_form_term_label: '指定术语翻译',
        ragCreate_page_form_term_tips: '在未上传术语库的情况下，指定少数项目特定的核心术语（如果术语量大请上传术语库）',
        ragCreate_page_form_term_source_placeholder: '输入术语原文',
        ragCreate_page_form_term_target_placeholder: '输入术语译文',
        ragCreate_page_form_demand_label: '其他要求',
        ragCreate_page_form_demand_tooltip_content: '如:请使用简短精炼的语言描述特定翻译要求，以下是一些例子：<br>1. 百分号直接使用%，无需翻译成percent。<br>2. 不要翻译文本中出现的公司名称，保留公司名原文。<br>3. 如果文中涉及序号，将“一、”译为“I.”。',
        ragCreate_page_form_demand_placeholder: '如：请使用简短精炼的语言描述特定翻译要求，以下是一些例子：\n1. 百分号直接使用%，无需翻译成percent。\n2. 不要翻译文本中出现的公司名称，保留公司名原文。\n3. 如果文中涉及序号，将“一、”译为“I.”。',
        ragCreate_page_form_description_label: '模型简介',
        ragCreate_page_form_description_placeholder: '请输入简介，100字以内例：国际工程领域，语料主要来自工程技术文件',
        ragCreate_page_form_memoryFile_label: '上传记忆库',
        ragCreate_page_form_memoryFile_tips: '语言方向需和模型的语言方向一致',
        ragCreate_page_form_memoryFile_message: '上传xlsx/xls/tmx格式记忆库<br>每批最多50个文件，单个最大{size}MB',
        ragCreate_page_form_termFile_label: '上传术语',
        ragCreate_page_form_termFile_tips: '语言方向需和模型的语言方向一致',
        ragCreate_page_form_termFile_message: '上传xlsx/xls/tbx格式术语库<br>每批最多50个文件，单个最大{size}MB',
        ragCreate_page_button_submit: '生成模型',
        ragCreate_page_button_submit_message: '预计1分钟以内',
        ragCreate_page_success_dialog_title: '生成成功',
        ragCreate_page_success_dialog_content_1: '{name}模型已生成成功',
        ragCreate_page_success_dialog_content_2: '可以到【模型】>【个性模型】下使用',
        ragCreate_page_success_dialog_content_3: '使用前先选择正确的语言方向',
        ragCreate_page_success_dialog_button: '去使用',
        ragCreate_page_language_zh_name: '中文',
        ragCreate_page_language_zh_shortName: '中',
        ragCreate_page_language_en_name: '英语',
        ragCreate_page_language_en_shortName: '英',
        ragCreate_page_language_ko_name: '韩语',
        ragCreate_page_language_ko_shortName: '韩',
        ragCreate_page_form_verification_message_1: '请输入模型名称',
        ragCreate_page_form_verification_message_2: '请上传记忆库',
        ragCreate_page_form_verification_message_3: '最多添加20个术语',

        create_page_title: '深度训练',
        create_page_tips_1: '{type}最多能创建{count}个个性模型，你的账户创建数量已达到上限，如需新建个性模型，',
        create_page_tips_2: '请联系我们',
        create_page_tips_3: '上传5000-100000句语料进行深度训练，适用于长期固定领域，训练周期1-2个工作日。模型训练后默认共享。',

        Detail_page_tips_1: '快速训练',
        Detail_page_tips_2: '深度训练',
        Detail_page_tips_3: '删除模型',
        Detail_page_tips_4: '暂无描述',
        Detail_page_tips_5: '共享',
        Detail_page_tips_6: '关闭共享后，模型仅对自己可见，其他人不可参与训练和下载测试集。',
        Detail_page_tips_7: '开启',
        Detail_page_tips_8: '拿到链接的人可获得使用和查看模型、参与共同训练、下载测试集权限。建议链接和密码点对点发送，不要发到群',
        Detail_page_tips_9: '语言对',
        Detail_page_tips_10: '模型标签',
        Detail_page_tips_11: '训练语料',
        Detail_page_tips_12: '条',
        Detail_page_tips_13: 'Bleu值评分',
        Detail_page_tips_14: 'Bleu值即机翻质量自动评分，仅供参考',
        Detail_page_tips_15: '精选样例',
        Detail_page_tips_16: '添加精心挑选的记忆库样例，代表想要的翻译领域和风格，原文译文总字符数不超过4000个',
        Detail_page_tips_17: '查看样例格式',
        Detail_page_tips_18: '训练记录',
        Detail_page_tips_19: '参与共同训练',
        Detail_page_tips_20: '只需两步：1.上传语料(xlsx,xls,tmx格式)、2.语料自动清洗和训练',
        Detail_page_tips_21: '上传语料',
        Detail_page_tips_22: '上传语料的领域、语言方向需与模型保持一致',
        Detail_page_tips_23: '重新训练会暂时下线模型，预计2-3分钟训练完成',


        Detail_page_btn_1: '编辑',
        Detail_page_btn_2: '复制链接和密码',
        Detail_page_btn_3: '分享',
        Detail_page_btn_4: '下载测试集',
        Detail_page_btn_5: '重新训练',
        Detail_page_btn_6: '提交语料',

        Detail_page_placeholder_1: '请输入内容',
        Detail_page_placeholder_2: '选择风格类型',
        Detail_page_placeholder_3: '选择翻译类型',
        Detail_page_placeholder_4: '自定义风格描述，比如“多用长句”',
        Detail_page_placeholder_5: '粘贴样例到此，段段对照（原文在上、译文在下），或直接复制excel原文和译文列',


        Detail_page_form_item_1: '翻译风格',

        Detail_page_table_column_1: '贡献者',
        Detail_page_table_column_2: '状态',
        Detail_page_table_column_3: '新增数据量',
        Detail_page_table_column_4: 'Bleu值评分',
        Detail_page_table_column_5: '参与时间',

        Detail_page_descriptions_column_1: '上传句对数',
        Detail_page_descriptions_column_2: '疑似低质量句对数',
        Detail_page_descriptions_column_3: '去重后句对数',
        Detail_page_descriptions_column_4: '清洗后句对数',

        Detail_page_dialog_1_title: '修改模型信息',
        Detail_page_dialog_1_form_item_label_1: '模型名称',
        Detail_page_dialog_1_form_item_label_2: '模型描述',

        Detail_page_dialog_1_placeholder_1: '给自己翻译模型起个名字，不超过10个字符',
        Detail_page_dialog_1_placeholder_2: '输入简介，100字以内。\n例：国际工程领域，语料主要来自工程技术文件、施工文件、合同等文件。',
        Detail_page_dialog_1_tips_1: '模型标签',
        Detail_page_dialog_1_tips_2: '选择1-3个标签',
        Detail_page_dialog_1_btn_1: '取消',
        Detail_page_dialog_1_btn_2: '确定',

        Detail_page_created_alertInfo_message: '确定要删除模型吗？删除不可恢复',
        Detail_page_created_alertInfo_buttonName: '确认删除',
        Detail_page_method_initPage_message_1: '密码：',
        Detail_page_method_initPage_message_2: '训练中，请稍后刷新页面查看。',
        Detail_page_method_submitBtnEvent_message_1: '请上传语料',
        Detail_page_method_submitRetrainGpt_message_1: '训练中，请稍后刷新页面查看。',
        Detail_page_method_getTaskStatus_message_1: '句段数不足{number}条，请继续上传语料',
        Detail_page_method_deleteEngineEvent_message_1: '模型已删除',
        Detail_page_method_saveEditBtnEvent_message_1: '请输入模型名称',
        Detail_page_method_saveEditBtnEvent_message_2: '请选择模型标签',
        Detail_page_method_saveEditBtnEvent_message_3: '请输入模型描述',
        Detail_page_method_saveEditBtnEvent_message_4: '修改成功',
        Detail_page_method_downloadTestSetBtnEvent_message_1: '下载中...',
        Detail_page_method_downloadTestSetBtnEvent_message_2: '测试集',
        Detail_page_method_shareSettingEvent_message_1: '模型共享已开启',
        Detail_page_method_shareSettingEvent_message_2: '模型共享已关闭',
        Detail_page_method_copyShareLink_message_1: '{name}邀请你使用他/她的专属个性模型{engine}，接受邀请后，你的翻译模型阵列中就可以看到了~\n{link}',
        Detail_page_method_copyShareLink_message_2: '已复制到剪贴板',
        Detail_page_method_copyShareLink_message_3: '复制到剪切板失败，请重试',


        QuickCreate_page_tips_1: '{type}最多能创建{count}个个性模型，你的账户创建数量已达到上限，如需新建个性模型，',
        QuickCreate_page_tips_2: '请联系我们',
        QuickCreate_page_tips_3: '只需要少量典型样例，即可定制自己的个性模型，立等可取',
        QuickCreate_page_tips_4: '选择1-3个标签',
        QuickCreate_page_tips_5: '添加精心挑选的记忆库样例，代表想要的翻译领域和风格，原文译文总字符数不超过4000个',
        QuickCreate_page_tips_6: '查看样例格式',
        QuickCreate_page_tips_7: '精选样例原文译文顺序需和语言方向一致',
        QuickCreate_page_form_item_label_1: '模型名称',
        QuickCreate_page_form_item_label_2: '语言方向',
        QuickCreate_page_form_item_label_3: '模型标签',
        QuickCreate_page_form_item_label_4: '模型描述',
        QuickCreate_page_form_item_label_5: '翻译风格',
        QuickCreate_page_form_item_label_6: '精选样例',
        QuickCreate_page_placeholder_1: '给自己翻译模型起个名字，不超过10个字符',
        QuickCreate_page_placeholder_2: '基于LanguageX快速训练的个性模型，Amazing！',
        QuickCreate_page_placeholder_3: '选择风格类型',
        QuickCreate_page_placeholder_4: '选择翻译类型',
        QuickCreate_page_placeholder_5: '自定义风格描述，比如“多用长句”',
        QuickCreate_page_placeholder_6: '粘贴样例到此，段段对照（原文在上、译文在下），或直接复制excel原文和译文列',
        QuickCreate_page_btn_1: '开始训练',
        QuickCreate_page_dialog_1_title: '创建成功',
        QuickCreate_page_dialog_1_tips_1: '{name}模型已成功创建',
        QuickCreate_page_dialog_1_tips_2: '可以在模型列表中直接使用',
        QuickCreate_page_dialog_1_btn_1: '去使用',
        QuickCreate_page_data_languageList_name_1: '中文',
        QuickCreate_page_data_languageList_shortName_1: '中',
        QuickCreate_page_data_languageList_name_2: '英语',
        QuickCreate_page_data_languageList_shortName_2: '英',
        QuickCreate_page_method_submitEvent_message_1: '请输入模型名称',
        QuickCreate_page_method_submitEvent_message_2: '请选择1-3个模型标签',
        QuickCreate_page_method_submitEvent_message_3: '请填写精选案例',

        Share_page_tips_1: '{name}邀请你成为模型的协作者',
        Share_page_tips_2: '请输入密码访问模型',
        Share_page_tips_3: '暂无描述',
        Share_page_placeholder_1: '请输入密码',
        Share_page_btn_1: '确认',
        Share_page_method_submitJoinEvent_message_1: '请输入密码',
        Share_page_method_submitJoinEvent_message_2: '加入模型成功',

    },
    project: {
        project_index_page_btn_1: '新建项目',
        project_index_page_btn_2: '刷新',
        project_index_page_btn_3: '项目任务统计',
        project_index_page_search_input_placeholder: '输入项目名称',
        project_index_page_search_select_placeholder_1: '源语言',
        project_index_page_search_select_placeholder_2: '目标语言',
        project_index_page_search_select_placeholder_3: '所属团队' ,
        project_index_page_search_select_placeholder_4: '项目状态',
        project_index_page_search_select_placeholder_5: '项目创建人',
        project_index_page_search_select_placeholder_6: '项目模板',
        project_index_page_search_select_placeholder_7: '项目流程',
        project_index_page_search_dropdown_item_1: '下载译文',
        project_index_page_search_dropdown_item_2: '原/译对照',
        project_index_page_search_dropdown_item_3: '下载原文',
        project_index_page_search_dropdown_item_4: '下载TMX',
        project_index_page_search_dropdown_item_5: '译/原对照',
        project_index_page_search_tips_1: '批量删除',
        project_index_page_search_changeView_tips_1: '切换',
        project_index_page_search_changeView_tips_2: '卡片',
        project_index_page_search_changeView_tips_3: '列表',
        project_index_page_search_changeView_tips_4: '视图',
        project_index_page_empty_tips_1: '没有找到项目～',
        project_index_page_empty_tips_2: '还没有项目，去新建一个吧～',
        project_index_page_dialog_1_title: '验收/归档项目',
        project_index_page_dialog_1_message: '是否确认项目已完成，向智云发送任务信息？',
        project_index_page_dialog_1_message_1: '是否确认项目已完成？',
        project_index_page_dialog_1_btn_1: '取消',
        project_index_page_dialog_1_btn_2: '确定',
        project_index_page_data_alertInfo_message: '确定要删除项目吗？',
        project_index_page_data_alertInfo_buttonName: '确认删除',
        project_index_page_data_statusOptions_1_text: '进行中',
        project_index_page_data_statusOptions_2_text: '已验收/归档',
        project_index_page_data_orderOptions_1_text: '按项目名排序',
        project_index_page_data_orderOptions_2_text: '按创建时间排序',
        project_index_page_methods_batchDownloadBtnEvent_message_1: '请先选择要下载的项目',
        project_index_page_methods_batchDownloadBtnEvent_message_2: '项目导出{size}个',
        project_index_page_methods_batchDeleteBtnEvent_message_1: '请先选择要删除的项目',
        project_index_page_methods_deleteProject_message_1: '项目已删除',
        project_index_page_methods_retryTask_message_1: '重试成功',
        project_index_page_methods_confirmCheck_message_1: '验收成功，请前往智云核对任务信息。',
        project_index_page_methods_confirmCheck_message_2: '验收/归档成功',
        project_index_page_methods_executeAction_message_1: '暂无权限',
        project_index_page_methods_saveSetting2Template_message_1: '保存为模版成功',

        task_page_tab_label_1: '全部',
        task_page_tab_label_2: '待接受',
        task_page_tab_label_3: '进行中',
        task_page_tab_label_4: '已提交',
        task_page_tab_label_5: '已失效',
        task_page_search_kw_placeholder: '输入任务名称',
        task_page_search_source_placeholder: '源语言',
        task_page_search_target_placeholder: '目标语言',
        task_page_search_taskType_placeholder: '任务类型',
        task_page_search_order_placeholder: '排序',
        task_page_search_button_text_1: '批量接受',
        task_page_search_button_text_2: '批量拒绝',
        task_page_search_button_text_3: '刷新',
        task_page_search_button_text_4: '批量提交',
        task_page_search_button_text_5: '批量导出离线包',
        task_page_search_switch_button_text_1: '切换',
        task_page_search_switch_button_text_2: '列表',
        task_page_search_switch_button_text_3: '卡片',
        task_page_search_switch_button_text_4: '视图',
        task_page_card_item_label_1: '文件名：',
        task_page_card_item_label_2: '启动：',
        task_page_card_item_label_3: '字',
        task_page_card_item_label_4: '截止：',
        task_page_card_item_label_5: '拒绝',
        task_page_card_item_label_6: '接受',
        task_page_card_item_label_7: '%',
        task_page_card_item_label_8: '导出',
        task_page_card_item_label_9: '导入',
        task_page_card_item_dropdown_item_1: '导入',
        task_page_card_item_dropdown_item_2: '导出',
        task_page_card_item_dropdown_item_3: '查看报价',
        task_page_table_colum_label_1: '任务名',
        task_page_table_colum_label_2: '任务类型',
        task_page_table_colum_label_3: '句段',
        task_page_table_colum_label_4: '项目名',
        task_page_table_colum_label_5: '语言方向',
        task_page_table_colum_label_6: '计价字数',
        task_page_table_colum_label_7: '截止时间',
        task_page_table_colum_label_8: '操作',
        task_page_table_colum_label_9: '单价',
        task_page_table_colum_label_10: '总价',
        task_page_table_colum_label_11: '状态',
        task_page_table_colum_label_12: '查看报价',

        task_page_table_colum_tips_1: '查看报价',
        task_page_table_colum_tips_2: '-退回',
        task_page_table_colum_tips_3: '导入失败：',

        task_page_empty_label_1: '没有任务～',
        task_page_dialog_title_1: '接受任务',
        task_page_dialog_message_1: '确定接受选中的 {count} 条任务吗？',
        task_page_dialog_btn_label_1: '取消',
        task_page_dialog_btn_label_2: '确定',
        task_page_dialog_title_2: '拒绝任务',
        task_page_dialog_message_2: '确定拒绝选中的 {count} 条任务吗？',
        task_page_dialog_input_placeholder_1: '请填写拒绝理由（必填）',
        task_page_dialog_title_3: '导入译文',
        task_page_dialog_message_3: '确定导入以下任务的译文吗？',
        task_page_dialog_title_4: '任务报价',
        task_page_dialog_4_label_1: '总金额：',
        task_page_dialog_4_label_2: '总字数：',
        task_page_dialog_4_label_3: '计价字数：',
        task_page_dialog_4_label_4: '单位价格：',
        task_page_dialog_4_label_5: '额外费用：',
        task_page_dialog_4_label_6: '计费单位：',
        task_page_dialog_4_label_7: '所属项目：',
        task_page_dialog_4_label_8: '分析明细',
        task_page_dialog_4_label_9: '币种：',
        task_page_dialog_4_table_label_1: '非译元素',
        task_page_dialog_4_table_label_2: '跨文件重复',
        task_page_dialog_4_table_label_3: '内部重复',
        task_page_dialog_4_table_label_4: '102%',
        task_page_dialog_4_table_label_5: '101%',
        task_page_dialog_4_table_label_6: '100%',
        task_page_dialog_4_table_label_7: '95%-99%',
        task_page_dialog_4_table_label_8: '85%-94%',
        task_page_dialog_4_table_label_9: '75%-84%',
        task_page_dialog_4_table_label_10: '50%-74%',
        task_page_dialog_4_table_label_11: '新字',
        task_page_dialog_4_table_label_12: '计价字数',
        task_page_dialog_4_table_label_13: '总价',
        task_page_dialog_4_table_btn_1: '关闭',
        task_page_dialog_4_table_btn_2: '下载报价',
        task_page_dialog_title_5: '批量提交',
        task_page_dialog_5_tips_1: '确认要提交选中的 {count} 条任务吗？',
        task_page_dialog_5_tips_2: '以下原因可能导致提交失败：',
        task_page_dialog_5_tips_3: '1. QA未处理完成',
        task_page_dialog_5_btn_1: '取消',
        task_page_dialog_5_btn_2: '确定',
        
        task_page_orderOptions_item_1: '按文件名正序',
        task_page_orderOptions_item_2: '按文件名倒序',
        task_page_orderOptions_item_3: '按启动时间正序',
        task_page_orderOptions_item_4: '按启动时间倒序',
        task_page_orderOptions_item_5: '按截止时间正序',
        task_page_orderOptions_item_6: '按截止时间倒序',

        task_page_validation_message_1: '请先选择任务',
        task_page_validation_message_2: '已拒绝任务',
        task_page_validation_message_3: '请先选择任务',
        task_page_validation_message_4: '已接受任务',
        task_page_validation_message_5: '请确认已上传文件并上传成功',
        task_page_validation_message_6: '导入成功，后台处理中，请2-5分钟后刷新查看',
        task_page_validation_message_7: '任务提交成功',
        task_page_validation_message_8: '这是一个退回的任务，最终结算时，只计算一次费用',
        task_page_downloadOfferEvent_title: '{name}-报价单',
        task_page_batchExportBtnEvent_title: '离线包导出{time}',

        task_statistics_page_tab_label_1: '全部',
        task_statistics_page_tab_label_2: '待接受',
        task_statistics_page_tab_label_3: '进行中',
        task_statistics_page_tab_label_4: '已提交',
        task_statistics_page_tab_label_5: '已失效',
        task_statistics_page_search_input_placeholder: '输入任务名称',
        task_statistics_page_search_select_placeholder_1: '源语言',
        task_statistics_page_search_select_placeholder_2: '目标语言',
        task_statistics_page_search_select_placeholder_3: '任务类型',
        task_statistics_page_search_select_placeholder_4: '任务状态',
        task_statistics_page_search_select_placeholder_5: '排序',
        task_statistics_page_search_select_placeholder_6: '开始时间',
        task_statistics_page_search_select_placeholder_7: '结束时间',

        task_statistics_page_search_button_text_1: '刷新',
        task_statistics_page_search_button_text_2: '下载',
        task_statistics_page_orderOptions_item_1: '按文件名正序',
        task_statistics_page_orderOptions_item_2: '按文件名倒序',
        task_statistics_page_orderOptions_item_3: '按启动时间正序',
        task_statistics_page_orderOptions_item_4: '按启动时间倒序',
        task_statistics_page_orderOptions_item_5: '按截止时间正序',
        task_statistics_page_orderOptions_item_6: '按截止时间倒序',
        task_statistics_page_statusOptions_item_1: '待接受',
        task_statistics_page_statusOptions_item_2: '已拒绝',
        task_statistics_page_statusOptions_item_3: '进行中',
        task_statistics_page_statusOptions_item_4: '待提交',
        task_statistics_page_statusOptions_item_5: '已提交',
        task_statistics_page_table_column_lable_1: '序号',
        task_statistics_page_table_column_lable_2: '任务名',
        task_statistics_page_table_column_lable_3: '任务类型',
        task_statistics_page_table_column_lable_4: '项目名',
        task_statistics_page_table_column_lable_5: '语言方向',
        task_statistics_page_table_column_lable_6: '任务时段',
        task_statistics_page_table_column_lable_7: '任务状态',
        task_statistics_page_table_column_lable_8: '任务进度',
        task_statistics_page_table_column_lable_9: '原文字数',
        task_statistics_page_table_column_lable_10: '计价字数',
        task_statistics_page_table_column_lable_11: '单价',
        task_statistics_page_table_column_lable_12: '总价',
        task_statistics_page_table_column_lable_13: '币种',

        task_statistics_page_table_column_tips_label_1: '文件名：',
        task_statistics_page_table_column_tips_label_2: '启动：',
        task_statistics_page_table_column_tips_label_3: '暂无任务开始时间',
        task_statistics_page_table_column_tips_label_4: '暂无任务结束时间',
        task_statistics_page_table_column_tips_label_5: '%',

        task_statistics_methods_downloadBtnEvent_message_1: '当前列表没有可下载任务',

        component_ProjectCardList_popover_label_1: '项目名称：',
        component_ProjectCardList_popover_label_2: '所属团队：',
        component_ProjectCardList_popover_label_3: '创建人：',
        component_ProjectCardList_card_label_1: '文件',
        component_ProjectCardList_card_label_2: '字',
        component_ProjectCardList_card_label_3: '已验收',
        component_ProjectCardList_card_label_4: '查看',
        component_ProjectCardList_card_label_5: '%',
        component_ProjectCardList_card_label_6: '项目进度',
        component_ProjectCardList_card_dropdown_item_1: '查看',
        component_ProjectCardList_card_dropdown_item_2: '验收项目',
        component_ProjectCardList_card_dropdown_item_3: '下载译文',
        component_ProjectCardList_card_dropdown_item_4: '原/译对照',
        component_ProjectCardList_card_dropdown_item_5: '下载原文',
        component_ProjectCardList_card_dropdown_item_6: '下载TMX',
        component_ProjectCardList_card_dropdown_item_7: '删除',
        component_ProjectCardList_card_dropdown_item_8: '保存为模版',
        component_ProjectCardList_card_dropdown_item_9: '译/原对照',
        component_ProjectCardList_card_cover_message_1: '任务失败：检测到流量不足',
        component_ProjectCardList_card_cover_message_2: '购买成功后，回到此页面点击重试',
        component_ProjectCardList_card_cover_btn_1: '购买字符包',
        component_ProjectCardList_card_cover_btn_2: '重试',
        component_ProjectCardList_card_cover_btn_3: '删除',

        component_ProjectTableList_table_column_lable_1: '项目名',
        component_ProjectTableList_table_column_lable_2: '语言方向',
        component_ProjectTableList_table_column_lable_3: '文件',
        component_ProjectTableList_table_column_lable_4: '字数',
        component_ProjectTableList_table_column_lable_5: '字符数',
        component_ProjectTableList_table_column_lable_6: '进度',
        component_ProjectTableList_table_column_lable_7: '模型',
        component_ProjectTableList_table_column_lable_8: '创建时间',
        component_ProjectTableList_table_column_lable_9: '操作',
        component_ProjectTableList_table_column_lable_10: '创建人',
        component_ProjectTableList_table_column_lable_11: '状态',
        component_ProjectTableList_table_column_dropdown_item_1: '查看',
        component_ProjectTableList_table_column_dropdown_item_2: '验收/归档项目',
        component_ProjectTableList_table_column_dropdown_item_3: '下载译文',
        component_ProjectTableList_table_column_dropdown_item_4: '原/译对照',
        component_ProjectTableList_table_column_dropdown_item_5: '下载原文',
        component_ProjectTableList_table_column_dropdown_item_6: '下载TMX',
        component_ProjectTableList_table_column_dropdown_item_7: '删除',
        component_ProjectTableList_table_column_dropdown_item_8: '保存为模版',
        component_ProjectTableList_table_column_dropdown_item_9: '译/原对照',

        
        component_ProjectTableList_table_column_tooltip_label_1: '项目名称：',
        component_ProjectTableList_table_column_tooltip_label_2: '所属团队：',
        component_ProjectTableList_table_column_tooltip_label_3: '创建人：',
        component_ProjectTableList_table_column_label_1: '字符流量不足',
        component_ProjectTableList_table_column_tooltip_1: '购买成功后，回到此页面点击重译',

        component_ProjectTableList_table_column_btn_1: '购买字符包',
        component_ProjectTableList_table_column_btn_2: '重试',

        project_create_page_btn_text_1: '下一步',
        project_create_page_btn_text_2: '新建',
        project_create_page_btn_text_3: '刷新',
        project_create_page_btn_text_4: '新建',
        project_create_page_btn_text_5: '刷新',
        project_create_page_btn_text_6: '添加文件',
        project_create_page_btn_text_7: '上一步',
        project_create_page_btn_text_8: '开始翻译',
        project_create_page_form_label_1: '项目名称',
        project_create_page_form_placeholder_1: '输入项目名称',
        project_create_page_form_label_2: '项目流程',
        project_create_page_form_placeholder_2: '选择项目流程',
        project_create_page_form_label_3: '所属团队',
        project_create_page_form_placeholder_3: '选择团队',
        project_create_page_form_label_4: '截止时间',
        project_create_page_form_placeholder_4: '选择截止时间',
        project_create_page_form_label_5: '源语言',
        project_create_page_form_placeholder_5: '选择源语言',
        project_create_page_form_label_6: '目标语言',
        project_create_page_form_placeholder_6: '选择目标语言',
        project_create_page_form_placeholder_7: '选择预翻译模型',
        project_create_page_form_label_8: '匹配率',
        project_create_page_form_placeholder_8: '匹配率',
        project_create_page_form_label_9: '全选',
        project_create_page_form_label_10: '规则QA设置',
        project_create_page_form_label_11: '智能QA设置',
        project_create_page_form_label_12: 'QA处理流程设置',
        project_create_page_form_label_13: '处理完QA才允许提交任务',
        project_create_page_form_placeholder_12: '选择参考模型',
        project_create_page_form_placeholder_13: '输入项目备注，500字以内',
        project_create_page_form_label_14: '项目模板',
        project_create_page_form_placeholder_14: '选择项目模板',
        project_create_page_form_label_15: '配置语言对应列',


        project_create_page_select_option_label_1: '人工翻译',

        project_create_page_tips_1: '对比模型',
        project_create_page_tips_2: '对于没有记忆库的语向，系统会自动创建默认记忆库并写入项目新产生的翻译记忆',
        project_create_page_tips_3: '项目术语会在编辑器提示，但当前版本不支持术语干预，',
        project_create_page_tips_4: '升级到PRO解锁本功能',
        project_create_page_tips_5: '已支持术语干预',
        project_create_page_tips_6: '对于没有术语库的语向，系统会自动创建默认术语库并写入项目新产生的术语',
        project_create_page_tips_7: '可选择在编辑器增加一个参考翻译模型',
        project_create_page_tips_8: '预览',
        project_create_page_tips_9: '项目模板列表',

        
        project_create_page_memoryTable_column_label_1: '写入',
        project_create_page_memoryTable_column_label_2: '名称',
        project_create_page_memoryTable_column_label_3: '语言方向',
        project_create_page_memoryTable_column_label_4: '条数',
        project_create_page_memoryTable_column_4_label_1: '条',
        project_create_page_memoryTable_column_label_5: '罚分',
        project_create_page_memoryTable_column_label_6: '创建时间',

        project_create_page_termsTable_column_label_1: '写入',
        project_create_page_termsTable_column_label_2: '名称',
        project_create_page_termsTable_column_label_3: '语言方向',
        project_create_page_termsTable_column_label_4: '条数',
        project_create_page_termsTable_column_4_label_1: '条',
        project_create_page_termsTable_column_label_6: '创建时间',

        project_create_page_remarkFileTable_column_label_1: '序号',
        project_create_page_remarkFileTable_column_label_2: '文件名',
        project_create_page_remarkFileTable_column_label_3: '创建时间',
        project_create_page_remarkFileTable_column_label_4: '操作',
        project_create_page_dialog_1_title: '上传风格指南文件',
        project_create_page_dialog_1_tips_1: '当前项目最多可上传',
        project_create_page_dialog_1_tips_2: '10',
        project_create_page_dialog_1_tips_3: '个文件，如有多个文件建议上传压缩包',
        project_create_page_dialog_1_btn_1: '取消',
        project_create_page_dialog_1_btn_2: '确定',

        project_create_page_data_steps_1: '上传文件',
        project_create_page_data_steps_2: '项目设置',
        project_create_page_data_tabData_tabs_1: '记忆库',
        project_create_page_data_tabData_tabs_2: '术语库',
        project_create_page_data_tabData_tabs_3: '文档设置',
        project_create_page_data_tabData_tabs_4: 'QA设置',
        project_create_page_data_tabData_tabs_5: '参考模型',
        project_create_page_data_tabData_tabs_6: '风格指南',
        project_create_page_data_tabData_tabs_7: '高级设置',
        project_create_page_data_tabData_tabs_8: '自动评分',
        project_create_page_data_alertInfo_message_1: '当前上传列表中有上传中或上传失败的文件，是否继续？',
        project_create_page_data_alertInfo_submessage_1: '点击继续按钮，上传中或上传失败的文件不会带到下一步。',
        project_create_page_data_alertInfo_buttonName_1: '继续',

        project_create_page_method_nextBtnEvent_message_1: '请检查文件是否上传成功',
        project_create_page_method_nextBtnEvent_message_2: '请上传文件',
        project_create_page_method_nextBtnEvent_message_3: '请选择模型',
        project_create_page_method_confirmNextEvent_message_1: '请检查文件是否上传成功',
        project_create_page_method_confirmNextEvent_message_2: '请上传文件',
        project_create_page_method_startTransitionBtnEvent_message_1: '请输入项目名称',
        project_create_page_method_startTransitionBtnEvent_message_2: '请选择截止日期',
        project_create_page_method_startTransitionBtnEvent_message_3: '请选择目标语言',
        project_create_page_method_startTransitionBtnEvent_message_4: '请为已选择的语言方向设置预翻译模型',
        project_create_page_method_gotoTermPage_message_1: '请选择目标语言',
        project_create_page_method_gotoMemoryPage_message_2: '请选择目标语言',
        project_create_page_method_beforeRouteLeave_message_1: '确定要离开吗？离开会清空当前配置信息',
        project_create_page_method_beforeRouteLeave_message_2: '提示',
        project_create_page_method_beforeRouteLeave_btn_1: '取消',
        project_create_page_method_beforeRouteLeave_btn_2: '确定',
        project_create_page_method_showMultiColumnExcelParseDialogEvent_message_1: '请选择目标语言',
        project_create_page_method_validateMultiColumnSettings_message_1: '请设置Excel多列解析规则',
        project_create_page_method_validateMultiColumnSettings_message_2: '请设置所有语言对应的列',


        project_new_page_btn_text_1: '下一步',
        project_new_page_btn_text_2: '上一步',
        project_new_page_btn_text_3: '新建',
        project_new_page_btn_text_4: '刷新',
        project_new_page_btn_text_5: '新建',
        project_new_page_btn_text_6: '刷新',
        project_new_page_btn_text_7: '开始翻译',
        project_new_page_form_placeholder_1: '粘贴一段文字，快速对比不同模型翻译结果，每次最多2000字',
        project_new_page_form_label_2: '项目名称',
        project_new_page_form_placeholder_2: '输入项目名称',
        project_new_page_form_label_3: '机翻模型',
        project_new_page_form_label_4: '语言方向',
        project_new_page_form_label_5: '匹配率',
        project_new_page_form_placeholder_5: '匹配率',
        project_new_page_form_label_6: '全选',
        project_new_page_form_label_7: '规则QA设置',
        project_new_page_form_label_8: '智能QA设置',
        project_new_page_form_label_9: '自动评分',
        project_new_page_form_label_10: '评分阈值',

        project_new_page_tips_1: '查看模型详情',
        project_new_page_tips_2: '新建模型',
        project_new_page_tips_3: '部分大模型翻译速度较慢，如需翻译文档，建议优先LanguageX和ChatGPT',
        project_new_page_tips_4: '对于没有记忆库的语向，系统会自动创建默认记忆库并写入项目新产生的翻译记忆',
        project_new_page_tips_5: '项目术语会在编辑器提示，但当前版本不支持术语干预，',
        project_new_page_tips_6: '升级到PRO解锁本功能',
        project_new_page_tips_7: '已支持术语干预',
        project_new_page_tips_8: '对于没有术语库的语向，系统会自动创建默认术语库并写入项目新产生的术语',
        project_new_page_tips_9: '选择编辑器内参考模型',
        project_new_page_tips_10: '预览',
        project_new_page_tips_11: '换一换',
        project_new_page_tips_12: '试一试样例',
        project_new_page_tips_13: '锁定设置',
        project_new_page_tips_14: '计价字数',
        project_new_page_tips_15: '自动替换',
        project_new_page_tips_16: 'AI对预翻译的译文进行评分',
        project_new_page_tips_17: '将此分数以下的译文标记为高风险句段',

        project_new_page_memoryTable_column_label_1: '写入',
        project_new_page_memoryTable_column_label_2: '名称',
        project_new_page_memoryTable_column_label_3: '语言方向',
        project_new_page_memoryTable_column_label_4: '条数',
        project_new_page_memoryTable_column_4_label_1: '条',
        project_new_page_memoryTable_column_label_5: '创建时间',

        project_new_page_termsTable_column_label_1: '写入',
        project_new_page_termsTable_column_label_2: '名称',
        project_new_page_termsTable_column_label_3: '语言方向',
        project_new_page_termsTable_column_label_4: '条数',
        project_new_page_termsTable_column_4_label_1: '条',
        project_new_page_termsTable_column_label_5: '创建时间',

        project_new_page_data_steps_1: '上传文件',
        project_new_page_data_steps_2: '选择机器翻译模型',
        project_new_page_data_steps_3: '项目设置',
        project_new_page_data_tabData_tabs_1: '记忆库',
        project_new_page_data_tabData_tabs_2: '术语库',
        project_new_page_data_tabData_tabs_3: '文档设置',
        project_new_page_data_tabData_tabs_4: 'QA设置',
        project_new_page_data_tabData_tabs_5: '参考模型',
        project_new_page_data_alertInfo_message_1: '当前上传列表中有上传中或上传失败的文件，是否继续？',
        project_new_page_data_alertInfo_submessage_1: '点击继续按钮，上传中或上传失败的文件不会带到下一步。',
        project_new_page_data_alertInfo_buttonName_1: '继续',
        project_new_page_method_nextBtnEvent_message_1: '请检查文件是否上传成功',
        project_new_page_method_nextBtnEvent_message_2: '请上传文件',
        project_new_page_method_nextBtnEvent_message_3: '请选择模型',
        project_new_page_method_confirmNextEvent_message_1: '请检查文件是否上传成功',
        project_new_page_method_confirmNextEvent_message_2: '请上传文件',
        project_new_page_method_changeEngineEvent_message_1: 'Pro版专属模型，升级为Pro版可用。',
        project_new_page_method_changeEngineEvent_message_2: '去升级',
        project_new_page_method_changeEngineEvent_message_3: 'DeepSeek 翻译速度较慢，如需快速翻译请选用其他模型',
        project_new_page_method_beforeRouteLeave_message_1: '确定要离开吗？离开会清空当前配置信息',
        project_new_page_method_beforeRouteLeave_message_2: '提示',
        project_new_page_method_beforeRouteLeave_btn_1: '取消',
        project_new_page_method_beforeRouteLeave_btn_2: '确定',

        component_CreateUpload_tips_1: '最多上传{count}个文件（单个文件最大{size}MB）',
        component_CreateUpload_tips_2: '加密PDF请处理后再上传',
        component_CreateUpload_tips_3: '{count1}文件成功，{count2}文件失败',
        component_CreateUpload_tips_4: '继续上传文件',
        component_CreateUpload_data_uploadFileMessage: '支持{types}格式的文件',
        component_CreateUpload_method_beforeUploadEvent_message_1: '最多只能上传{count}个文件',
        component_CreateUpload_method_beforeUploadEvent_message_2: '不支持上传空文件',
        component_CreateUpload_method_beforeUploadEvent_message_3: '{fileName}超过{size}MB',
        component_CreateUpload_method_beforeUploadEvent_message_4: '{fileName}已存在',
        component_CreateUpload_method_beforeUploadEvent_message_5: '登录状态已过期，请重新登录',
        component_CreateUpload_method_beforeUploadEvent_message_6: '上传失败，请重试',
        component_CreateMemoryMultiLanguage_dialog_title: '新建记忆库',
        component_CreateMemoryMultiLanguage_dialog_form_item_label_1: '名称',
        component_CreateMemoryMultiLanguage_dialog_form_item_placeholder_1: '输入记忆库名称',
        component_CreateMemoryMultiLanguage_dialog_form_item_label_2: '所属团队',
        component_CreateMemoryMultiLanguage_dialog_form_item_placeholder_2: '选择团队',
        component_CreateMemoryMultiLanguage_dialog_form_item_label_3: '上传记忆库',
        component_CreateMemoryMultiLanguage_tips_5: '支持{types}，最大{size}M。点击下载模版：',
        component_CreateMemoryMultiLanguage_tips_6: '选择上传文件',
        component_CreateMemoryMultiLanguage_btn_1: '取消',
        component_CreateMemoryMultiLanguage_btn_2: '保存',
        component_CreateMemoryMultiLanguage_method_downloadTemplateEvent_message_1: '下载中...',
        component_CreateMemoryMultiLanguage_method_downloadTemplateEvent_message_2: '获取下载地址失败',
        component_CreateMemoryMultiLanguage_method_saveBtnEvent_message_1: '记忆库名称必须填写',
        component_CreateMemoryMultiLanguage_method_saveBtnEvent_message_2: '请至少上传1个语种对应的记忆库文件',
        component_CreateMemoryMultiLanguage_method_saveBtnEvent_message_3: '记忆库创建成功',

        component_CreateTermMultiLanguage_dialog_title: '新建术语库',
        component_CreateTermMultiLanguage_dialog_form_item_label_1: '名称',
        component_CreateTermMultiLanguage_dialog_form_item_placeholder_1: '输入术语库名称',
        component_CreateTermMultiLanguage_dialog_form_item_label_2: '所属团队',
        component_CreateTermMultiLanguage_dialog_form_item_placeholder_2: '选择团队',
        component_CreateTermMultiLanguage_dialog_form_item_label_3: '上传术语',
        component_CreateTermMultiLanguage_tips_5: '支持{types}，最大{size}M。点击下载模版：',
        component_CreateTermMultiLanguage_tips_6: '选择上传文件',
        component_CreateTermMultiLanguage_btn_1: '取消',
        component_CreateTermMultiLanguage_btn_2: '保存',
        component_CreateTermMultiLanguage_method_downloadTemplateEvent_message_1: '下载中...',
        component_CreateTermMultiLanguage_method_downloadTemplateEvent_message_2: '获取下载地址失败',
        component_CreateTermMultiLanguage_method_saveBtnEvent_message_1: '术语库名称必须填写',
        component_CreateTermMultiLanguage_method_saveBtnEvent_message_2: '请至少上传1个语种对应的术语库文件',
        component_CreateTermMultiLanguage_method_saveBtnEvent_message_3: '术语库创建成功',
        component_MultiColumnExcelParseDialog_dialog_title: '配置列的属性',
        component_MultiColumnExcelParseDialog_dialog_tips_1: '不导入首行',
        component_MultiColumnExcelParseDialog_dialog_tips_2: '源语言',
        component_MultiColumnExcelParseDialog_dialog_tips_3: '目标语言',
        component_MultiColumnExcelParseDialog_dialog_tips_4: '列',
        component_MultiColumnExcelParseDialog_dialog_tips_5: '输入列编号，仅大写字母',
        component_MultiColumnExcelParseDialog_dialog_tips_6: '*提示：请确认您上传的Excel文档：',
        component_MultiColumnExcelParseDialog_dialog_tips_7: ' ①只有一行表头，并且如包含多个sheet，各sheet之间源语言列、目标语言列语言、位置均保持一致；',
        component_MultiColumnExcelParseDialog_dialog_tips_8: ' ②为该项目唯一文档（如需上传其他普通格式，请另建项目）。',
        component_MultiColumnExcelParseDialog_dialog_tips_9: ' 查看模板',
        component_MultiColumnExcelParseDialog_dialog_btn_1: '关闭',
        component_MultiColumnExcelParseDialog_dialog_btn_2: '保存',
        component_MultiColumnExcelParseDialog_method_saveBtnEvent_message_1: '请设置所有语言对应的列',
        
        project_list_page_tabPane_1_label: '项目文件',
        project_list_page_tabPane_1_btn_1: '添加文件',
        project_list_page_tabPane_1_btn_2: '刷新',
        project_list_page_tabPane_1_tips_1: '总共{total}个，选中{size}个',
        project_list_page_tabPane_1_tips_2: '批量删除',
        project_list_page_tabPane_1_input_placeholder_1: '输入文件名称',
        project_list_page_tabPane_1_dropdownItem_1: '下载译文',
        project_list_page_tabPane_1_dropdownItem_2: '原/译对照',
        project_list_page_tabPane_1_dropdownItem_3: '下载原文',
        project_list_page_tabPane_1_dropdownItem_4: '下载TMX',
        project_list_page_tabPane_1_dropdownItem_5: '下载编辑痕迹',
        project_list_page_tabPane_1_dropdownItem_6: '下载合并报价单',
        project_list_page_tabPane_1_dropdownItem_7: '译/原对照',

        component_FileListInside_table_column_1: '文件名',
        component_FileListInside_table_column_2: '语言方向',
        component_FileListInside_table_column_3: '字数 / 字符',
        component_FileListInside_table_column_4: '进度',
        component_FileListInside_table_column_5: '负责人',
        component_FileListInside_table_column_6: '时间',
        component_FileListInside_table_column_7: '操作',
        component_FileListInside_tips_1: '句段',
        component_FileListInside_tips_2: '字',
        component_FileListInside_tips_3: '拒绝原因：',
        component_FileListInside_tips_4: '退回',
        component_FileListInside_tips_5: '（退回）',
        component_FileListInside_tips_6: '变更负责人',
        component_FileListInside_tips_7: '分配负责人',
        component_FileListInside_tips_8: '等{size}人',
        component_FileListInside_tips_9: '未分配',
        component_FileListInside_tips_10: '未设置',
        component_FileListInside_tips_11: '查看联系方式',
        component_FileListInside_tips_12: '退回至此阶段',
        component_FileListInside_tips_13: '查看报价',
        component_FileListInside_tips_14: '字',
        component_FileListInside_tips_15: '字符',
        component_FileListInside_tips_16: '字符流量不足',
        component_FileListInside_tips_17: '购买成功后，回到此页面点击重译',
        component_FileListInside_tips_18: '拆分',
        component_FileListInside_tips_19: '查看',
        component_FileListInside_tips_20: '下载',
        component_FileListInside_tips_21: '修改流程',
        component_FileListInside_tips_22: '查看历史',
        component_FileListInside_tips_23: '删除文件',
        component_FileListInside_input_placeholder_1: '选择截止时间',
        component_FileListInside_btn_1: '购买字符包',
        component_FileListInside_btn_2: '重译',
        component_FileListInside_dropdownItem_1: '下载译文',
        component_FileListInside_dropdownItem_2: '原/译对照',
        component_FileListInside_dropdownItem_3: '下载原文',
        component_FileListInside_dropdownItem_4: '下载TMX',
        component_FileListInside_dropdownItem_5: '下载编辑痕迹',
        component_FileListInside_dropdownItem_6: '译/原对照',
        component_FileListInside_dialog_1_title: '联系方式',
        component_FileListInside_dialog_2_title: '退回任务',
        component_FileListInside_dialog_2_tips_1: '任务将退回至',
        component_FileListInside_dialog_2_tips_2: '阶段',
        component_FileListInside_dialog_2_formItem_label_1: '退回原因',
        component_FileListInside_dialog_2_formItem_input_placeholder_1: '填写退回原因',
        component_FileListInside_dialog_2_btn_1: '取消',
        component_FileListInside_dialog_2_btn_2: '确定',
        component_FileListInside_dialog_3_title: '历史记录',
        component_FileListInside_dialog_4_title: '拆分',
        component_FileListInside_dialog_4_tips_1: '拆分为',
        component_FileListInside_dialog_4_tips_2: '份',
        component_FileListInside_dialog_4_tips_3: '把选中的拆分一份',
        component_FileListInside_dialog_4_tips_4: '剩下作为另一份',
        component_FileListInside_dialog_4_tips_5: '第{size1}份，第[{range}]段，共{size2}段{size3}句',
        component_FileListInside_dialog_4_table_column_1: '段落编号',
        component_FileListInside_dialog_4_table_column_2: '原文',
        component_FileListInside_dialog_4_table_column_3: '译文',
        component_FileListInside_dialog_4_table_column_4: '所属份数',
        component_FileListInside_dialog_4_btn_1: '取消',
        component_FileListInside_dialog_4_btn_2: '确定',
        component_FileListInside_dialog_4_btn_3: '拆分一份',
        component_FileListInside_dialog_5_title: '任务报价',
        component_FileListInside_dialog_5_tips_1: '总金额：',
        component_FileListInside_dialog_5_tips_2: '总字数：',
        component_FileListInside_dialog_5_tips_3: '计价字数：',
        component_FileListInside_dialog_5_tips_4: '单位价格：',
        component_FileListInside_dialog_5_tips_5: '币种：',
        component_FileListInside_dialog_5_tips_6: '额外费用：',
        component_FileListInside_dialog_5_tips_7: '计费单位：',
        component_FileListInside_dialog_5_tips_8: '所属项目：',
        component_FileListInside_dialog_5_tips_9: '分析明细',
        component_FileListInside_dialog_5_table_column_1: '非译元素',
        component_FileListInside_dialog_5_table_column_2: '跨文件重复',
        component_FileListInside_dialog_5_table_column_3: '内部重复',
        component_FileListInside_dialog_5_table_column_4: '102%',
        component_FileListInside_dialog_5_table_column_5: '101%',
        component_FileListInside_dialog_5_table_column_6: '100%',
        component_FileListInside_dialog_5_table_column_7: '95%-99%',
        component_FileListInside_dialog_5_table_column_8: '85%-94%',
        component_FileListInside_dialog_5_table_column_9: '75%-84%',
        component_FileListInside_dialog_5_table_column_10: '50%-74%',
        component_FileListInside_dialog_5_table_column_11: '新字',
        component_FileListInside_dialog_5_table_column_12: '计价字数',
        component_FileListInside_dialog_5_table_column_13: '总价',
        component_FileListInside_dialog_5_btn_1: '关闭',
        component_FileListInside_dialog_5_btn_2: '下载报价',
        component_FileListInside_data_typeRadioOptions_name_1: '手动拆分',
        component_FileListInside_data_typeRadioOptions_name_2: '自动拆分',
        component_FileListInside_method_showAssignDialog_message_1: '当前任务{status}，不能分配。',
        component_FileListInside_method_setDeadLineTime_message_1: '截止日期不能小于或等于文件上传日期',
        component_FileListInside_method_submitRejectEvent_message_1: '请填写退回原因',
        component_FileListInside_method_copyText_message_1: '已复制到剪切板',
        component_FileListInside_method_copyText_message_2: '复制到剪切板失败，请重试',
        component_FileListInside_method_submitSplitEvent_message_1: '文档拆分成功',
        component_FileListInside_method_submitSplitEvent_message_2: '还有未拆分的句段{range}，请拆分完成后再提交',
        component_FileListInside_method_downloadOfferEvent_message_1: '报价单',
        component_FileListInside_method_splitBtnEvent_message_1: '所有段落已拆分完成',
        component_FileListInside_method_splitBtnEvent_message_2: '请选择要拆分段落',
        component_FileListInside_method_setSplitList_message_1: '剩余段落',
        component_FileListInside_method_setSplitList_message_2: '拆分失败，请选择连续的段落，已选择的段落：{range}，缺少段落：[{numbers}]',
        component_FileListInside_method_splitDialogTableIndexMethod_message_1: '第{number}段',

        component_FileList_table_column_1: '文件名',
        component_FileList_table_column_2: '机翻状态',
        component_FileList_table_column_3: '译后编辑进度',
        component_FileList_table_column_4: '字数 / 字符',
        component_FileList_table_column_5: '上传时间',
        component_FileList_table_column_6: '操作',
        component_FileList_tips_1: '字符流量不足',
        component_FileList_tips_2: '购买成功后，回到此页面点击重译',
        component_FileList_tips_3: '在译后编辑页面中，对需要处理的译文进行编辑后点击右侧的【确认】键，译后编辑进度便会进行更新',
        component_FileList_tips_4: '译后编辑进度',
        component_FileList_tips_5: '字',
        component_FileList_tips_6: '字符',
        component_FileList_tips_7: '删除文件',
        component_FileList_btn_1: '购买字符包',
        component_FileList_btn_2: '重译',
        component_FileList_dropdown_item_1: '下载译文',
        component_FileList_dropdown_item_2: '原/译对照',
        component_FileList_dropdown_item_3: '下载原文',
        component_FileList_dropdown_item_4: '下载TMX',
        component_FileList_dropdown_item_5: '译/原对照',

        project_list_page_tabPane_2_label: '任务规划',

        component_TaskPlanList_btn_1: '刷新',
        component_TaskPlanList_btn_2: '分配',
        component_TaskPlanList_btn_3: '定时',
        component_TaskPlanList_select_placeholder_1: '文件',
        component_TaskPlanList_select_placeholder_2: '任务类型',
        component_TaskPlanList_select_placeholder_3: '目标语言',
        component_TaskPlanList_select_placeholder_4: '负责人',
        component_TaskPlanList_select_placeholder_5: '状态',
        component_TaskPlanList_input_placeholder_1: '选择截止时间',
        component_TaskPlanList_tips_1: '任务规划页面仅展示未接受的任务，可对任务进行批量分配和定时',
        component_TaskPlanList_tips_2: '（退回）',
        component_TaskPlanList_tips_3: '句段',
        component_TaskPlanList_tips_4: '未启动',
        component_TaskPlanList_tips_5: '未设置',
        component_TaskPlanList_tips_6: '变更负责人',
        component_TaskPlanList_tips_7: '分配负责人',
        component_TaskPlanList_tips_8: '等{size}人',
        component_TaskPlanList_tips_9: '未分配',
        component_TaskPlanList_tips_10: '查看联系方式',
        component_TaskPlanList_tips_11: '等',
        component_TaskPlanList_tips_12: '个任务',
        component_TaskPlanList_table_column_1: '任务',
        component_TaskPlanList_table_column_2: '句段',
        component_TaskPlanList_table_column_3: '文件名',
        component_TaskPlanList_table_column_4: '语言方向',
        component_TaskPlanList_table_column_5: '启动时间',
        component_TaskPlanList_table_column_6: '截止时间',
        component_TaskPlanList_table_column_7: '状态',
        component_TaskPlanList_table_column_8: '负责人',
        component_TaskPlanList_table_column_9: '操作',
        component_TaskPlanList_dialog_1_title: '联系方式',
        component_TaskPlanList_dialog_2_title: '任务定时',
        component_TaskPlanList_dialog_2_input_placeholder_1: '选择截止时间',
        component_TaskPlanList_dialog_2_btn_1: '取消',
        component_TaskPlanList_dialog_2_btn_2: '确定',
        component_TaskPlanList_method_batchAssignTask_message_1: '请选择任务',
        component_TaskPlanList_method_batchSetDeadline_message_1: '请选择任务',
        component_TaskPlanList_method_submitDeadlineEvent_message_1: '请选择截止时间',
        component_TaskPlanList_method_copyText_message_1: '已复制到剪切板',
        component_TaskPlanList_method_copyText_message_2: '复制到剪切板失败，请重试',

        project_list_page_tabPane_3_label: '基础设置',
        project_list_page_tabPane_3_tips_1: '项目名称',
        project_list_page_tabPane_3_tips_2: '所属团队',
        project_list_page_tabPane_3_tips_3: '创建人',
        project_list_page_tabPane_3_tips_4: '创建时间',
        project_list_page_tabPane_3_tips_5: '项目流程',
        project_list_page_tabPane_3_tips_6: '语言方向',
        project_list_page_tabPane_3_tips_7: '预翻译模型',
        project_list_page_tabPane_3_tips_8: '参考翻译模型',
        project_list_page_tabPane_3_tips_9: '人工翻译',
        project_list_page_tabPane_3_tips_10: '高级设置',
        project_list_page_tabPane_3_tips_11: '1、锁定项在编辑器优先次序为：非译元素>内部重复>跨文件重复>100%匹配>101%匹配>102%匹配',
        project_list_page_tabPane_3_tips_12: '2、计价字数设置对所有文件生效；锁定设置仅对追加文件生效。',
        project_list_page_tabPane_3_tips_13: '锁定设置',
        project_list_page_tabPane_3_tips_14: '计价字数',
        project_list_page_tabPane_3_tips_15: '自动替换',
        project_list_page_tabPane_3_input_placeholder_1: '输入项目名称',
        project_list_page_tabPane_3_select_placeholder_1: '请选择',
        project_list_page_tabPane_3_btn_1: '确认修改',
        project_list_page_tabPane_3_btn_2: '保存',

        project_list_page_tabPane_4_label: '记忆库',
        project_list_page_tabPane_4_btn_1: '新建',
        project_list_page_tabPane_4_btn_2: '刷新',
        project_list_page_tabPane_4_tips_1: '匹配率',
        project_list_page_tabPane_4_tips_2: '条',
        project_list_page_tabPane_4_select_placeholder_1: '匹配率',
        project_list_page_tabPane_4_table_column_1: '写入',
        project_list_page_tabPane_4_table_column_2: '名称',
        project_list_page_tabPane_4_table_column_3: '语言方向',
        project_list_page_tabPane_4_table_column_4: '条数',
        project_list_page_tabPane_4_table_column_5: '罚分',
        project_list_page_tabPane_4_table_column_6: '创建时间',
        
        project_list_page_tabPane_5_label: '术语库',
        project_list_page_tabPane_5_tips_1: '项目术语会在编辑器提示，但当前版本不支持术语干预，',
        project_list_page_tabPane_5_tips_2: '升级到PRO解锁本功能',
        project_list_page_tabPane_5_tips_3: '{type}已支持术语干预',
        project_list_page_tabPane_5_tips_4: '条',
        project_list_page_tabPane_5_btn_1: '新建',
        project_list_page_tabPane_5_btn_2: '刷新',
        project_list_page_tabPane_5_table_column_1: '写入',
        project_list_page_tabPane_5_table_column_2: '名称',
        project_list_page_tabPane_5_table_column_3: '语言方向',
        project_list_page_tabPane_5_table_column_4: '条数',
        project_list_page_tabPane_5_table_column_5: '创建时间',

        project_list_page_tabPane_6_label: '文档设置',
        project_list_page_tabPane_6_checkbox_label_1: '全选',

        project_list_page_tabPane_7_label: 'QA设置',
        project_list_page_tabPane_7_tips_1: '规则QA设置',
        project_list_page_tabPane_7_tips_2: '智能QA设置',
        project_list_page_tabPane_7_tips_3: 'QA处理流程设置',
        project_list_page_tabPane_7_tips_4: '处理完QA才允许提交任务',

        project_list_page_tabPane_8_label: '风格指南',
        project_list_page_tabPane_8_tips_1: '备注说明',
        project_list_page_tabPane_8_tips_2: '暂无备注说明',
        project_list_page_tabPane_8_input_placeholder_1: '输入项目备注',
        project_list_page_tabPane_8_btn_1: '添加文件',
        project_list_page_tabPane_8_table_column_1: '序号',
        project_list_page_tabPane_8_table_column_2: '文件名',
        project_list_page_tabPane_8_table_column_3: '创建时间',
        project_list_page_tabPane_8_table_column_4: '操作',
        project_list_page_tabPane_8_dialog_1_title: '上传风格指南文件',
        project_list_page_tabPane_8_dialog_1_tips_1: '当前项目最多可上传',
        project_list_page_tabPane_8_dialog_1_tips_2: '个文件，如有多个文件建议上传压缩包',
        project_list_page_tabPane_8_dialog_1_btn_1: '取消',
        project_list_page_tabPane_8_dialog_1_btn_2: '确定',

        project_list_page_tabPane_9_label: '文件分析',
        component_FileAnalysis_tips_1: '统计维度：',
        component_FileAnalysis_tips_2: '总计',
        component_FileAnalysis_tips_3: '50%以下匹配都属于新字',
        component_FileAnalysis_tips_4: '指当前段落100%匹配基础上,前一段落或后一段落匹配。',
        component_FileAnalysis_tips_5: '指的是不仅当前段落与记忆库存储的相同,而且之前和之后的段落也是相同的',
        component_FileAnalysis_tips_6: '百分比结果四舍五入保留整数，仅供参考',
        component_FileAnalysis_tips_7: '%',
        component_FileAnalysis_tips_8: '表示的是字符的个数，一个中文字算作一个字符，一个由5个英文字母组成的英文单词算作5个字符。',
        component_FileAnalysis_tips_9: '字符数',
        component_FileAnalysis_tips_10: '表示的是单词的个数，一个中文字即算一个字；英文一个单词算一个字。',
        component_FileAnalysis_tips_11: '字数',
        component_FileAnalysis_tips_12: '表示是中文字符和朝鲜语单词，一般就是纯中文字数，不包括英文单词和阿拉伯数字。',
        component_FileAnalysis_tips_13: '中朝字数',
        component_FileAnalysis_select_placeholder_1: '请选择',
        component_FileAnalysis_btn_1: '下载文件分析报告',
        component_FileAnalysis_table_column_1: '句段',
        component_FileAnalysis_table_column_2: '中朝字数',
        component_FileAnalysis_method_downloadFileAnalysis_title: '{name}文件分析报告',

        project_list_page_tabPane_10_label: '任务统计',
        component_ProjectTaskStatisticsTableList_btn_1: '下载',

        project_list_page_tabPane_11_label: '自动评分',
        project_list_page_tabPane_11_form_item_label_1: '自动评分',
        project_list_page_tabPane_11_form_item_label_2: '评分阈值',
        project_list_page_tabPane_11_tips_1: 'AI对预翻译的译文进行评分',
        project_list_page_tabPane_11_tips_2: '将此分数以下的译文标记为高风险句段',

        component_ProjectTaskStatisticsTableList_tips_1: '暂无任务开始时间',
        component_ProjectTaskStatisticsTableList_tips_2: '暂无任务结束时间',
        component_ProjectTaskStatisticsTableList_tips_3: '%',
        component_ProjectTaskStatisticsTableList_table_column_1: '负责人',
        component_ProjectTaskStatisticsTableList_table_column_2: '任务名',
        component_ProjectTaskStatisticsTableList_table_column_3: '任务类型',
        component_ProjectTaskStatisticsTableList_table_column_4: '语言方向',
        component_ProjectTaskStatisticsTableList_table_column_5: '任务时段',
        component_ProjectTaskStatisticsTableList_table_column_6: '任务进度',
        component_ProjectTaskStatisticsTableList_table_column_7: '任务字数',
        component_ProjectTaskStatisticsTableList_table_column_8: '计价字数',
        component_ProjectTaskStatisticsTableList_table_column_9: '单价',
        component_ProjectTaskStatisticsTableList_table_column_10: '币种',
        component_ProjectTaskStatisticsTableList_table_column_11: '总价',
        component_ProjectTaskStatisticsTableList_method_handleDownloadBtnEvent_title: '任务统计',

        project_list_page_dialog_1_title: '添加文件',
        project_list_page_dialog_1_tips_1: '当前项目最多可上传',
        project_list_page_dialog_1_tips_2: '个文件，还可上传',
        project_list_page_dialog_1_tips_3: '个文件',
        project_list_page_dialog_1_btn_1: '取消',
        project_list_page_dialog_1_btn_2: '确定',

        project_list_page_dialog_2_title: '提示',
        project_list_page_dialog_2_tips_1: '注意：项目流程修改仅支持对项目中未启动的文档进行重置，后续追加的文档会使用最新的流程。若您需要修改项目中已启动的文档，请在项目文件中对单个文档流程进行修改。',
        project_list_page_dialog_2_tips_2: '是否确认修改项目流程？',
        project_list_page_dialog_2_btn_1: '取消',
        project_list_page_dialog_2_btn_2: '确定',

        project_list_page_dialog_3_title: '提示',
        project_list_page_dialog_3_tips_1: '注意：对已启动的文件修改流程会导致所有内容（负责人、进度、编辑内容等）重置，请谨慎操作！',
        project_list_page_dialog_3_tips_2: '是否确定修改当前文件的翻译流程？',
        project_list_page_dialog_3_btn_1: '取消',
        project_list_page_dialog_3_btn_2: '确定',

        project_list_page_dialog_4_title: '修改文件流程',
        project_list_page_dialog_4_form_item_label_1: '文件流程',
        project_list_page_dialog_4_btn_1: '取消',
        project_list_page_dialog_4_btn_2: '确定',
        project_list_page_data_upload_supportFiles: '支持{type}格式的文件',
        project_list_page_data_alertInfo_message: '确定要删除文件吗？',
        project_list_page_data_alertInfo_buttonName: '确认删除',
        project_list_page_method_deleteDocumentEvent_message_1: '已删除',
        project_list_page_method_batchDeleteBtnEvent_message_1: '请选择要删除的文档',
        project_list_page_method_handleBatchDownloadCommand_message_1: '请选择要下载的文档',
        project_list_page_method_handleBatchDownloadCommand_message_2: '项目文件导出{size}个',
        project_list_page_method_submitAppendFile_message_1: '当前新上传的文件中有 {size} 个同名文件，请修改文件名后上传',
        project_list_page_method_saveProjectName_message_1: '项目名称修改成功',
        project_list_page_method_saveProjectRemark_message_1: '项目备注修改成功',
        project_list_page_method_saveProjectWorkflowEdit_message_1: '项目流程修改成功',
        project_list_page_method_saveFlieWorkflowEdit_message_1: '文件流程修改成功',
        project_list_page_method_setProjectsSetting_message_1: '保存中...',
        project_list_page_method_handleMemoryPenaltyPointsChange_message_1: '保存中...',
        project_list_page_method_qaSettingItemChange_message_1: '保存中...',
        project_list_page_method_updateRemarkFile_message_1: '保存中...',
        project_list_page_method_downloadBatchOfferEvent_title: '{name}-报价单',
        project_list_page_method_submitFileAnalysisSettingDialog_message_1: '保存中...',
        project_list_page_method_submitAutoReplaceOptsDialog_message_1: '保存中...',
        project_list_page_method_saveRatingSettings_message_1: '保存中...',

        component_TaskAssignDialog_dialog_title: '任务分配',
        component_TaskAssignDialog_dialog_tips_1: '{size}句',
        component_TaskAssignDialog_dialog_tips_2: '等',
        component_TaskAssignDialog_dialog_tips_3: '个任务',
        component_TaskAssignDialog_dialog_tips_4: '{size}字',
        component_TaskAssignDialog_dialog_tips_5: '负责人：',
        component_TaskAssignDialog_dialog_tips_6: '等{size}人',
        component_TaskAssignDialog_dialog_tips_7: 'Preferred Vendor List，指资源中心提供的客户精选资源清单',
        component_TaskAssignDialog_dialog_tips_8: '包含',
        component_TaskAssignDialog_dialog_tips_9: '介于',
        component_TaskAssignDialog_dialog_tips_10: '额外费用',
        component_TaskAssignDialog_dialog_tips_11: '总价=任务单价*计价字数+额外费用',
        component_TaskAssignDialog_dialog_tips_12: '句段',
        component_TaskAssignDialog_dialog_tips_13: '如选中多人，则相当于发起认领模式，先接受任务者为任务负责人',
        component_TaskAssignDialog_dialog_tips_14: '支持内部译员在当前任务的双语向查询',
        
        component_TaskAssignDialog_dialog_btn_1: '收起',
        component_TaskAssignDialog_dialog_btn_2: '查询',
        component_TaskAssignDialog_dialog_btn_3: '清空',
        component_TaskAssignDialog_dialog_btn_4: '取消',
        component_TaskAssignDialog_dialog_btn_5: '确定',

        component_TaskAssignDialog_dialog_input_placeholder_1: '输入姓名',
        component_TaskAssignDialog_dialog_input_placeholder_2: '/手机号/邮箱',
        component_TaskAssignDialog_dialog_input_placeholder_3: '/手机尾号',
        component_TaskAssignDialog_dialog_input_placeholder_4: '搜索',
        component_TaskAssignDialog_dialog_input_placeholder_5: '最低价格',
        component_TaskAssignDialog_dialog_input_placeholder_6: '最高价格',
        component_TaskAssignDialog_dialog_checkbox_label_1: '只在PVL表中查找',
        component_TaskAssignDialog_dialog_checkbox_label_2: '只查询内部译员',

        component_TaskAssignDialog_dialog_form_item_1_label: '业务线',
        component_TaskAssignDialog_dialog_form_item_2_label: '客户',
        component_TaskAssignDialog_dialog_form_item_3_label: '任务类型',
        component_TaskAssignDialog_dialog_form_item_4_label: '统计单位',
        component_TaskAssignDialog_dialog_form_item_5_label: '擅长领域',
        component_TaskAssignDialog_dialog_form_item_6_label: '币种',
        component_TaskAssignDialog_dialog_form_item_7_label: 'CAT工具',
        component_TaskAssignDialog_dialog_form_item_8_label: '价格区间',

        component_TaskAssignDialog_dialog_form_item_placeholder_1: '请选择',
        component_TaskAssignDialog_dialog_table_column_1: '姓名',
        component_TaskAssignDialog_dialog_table_column_2: '角色',
        component_TaskAssignDialog_dialog_table_column_3: '任务类型',
        component_TaskAssignDialog_dialog_table_column_4: '擅长领域',
        component_TaskAssignDialog_dialog_table_column_5: '单价',
        component_TaskAssignDialog_dialog_table_column_6: '统计单位',
        component_TaskAssignDialog_dialog_table_column_7: '币种',
        component_TaskAssignDialog_dialog_table_column_8: '角色',
        component_TaskAssignDialog_dialog_table_column_9: '任务类型',
        component_TaskAssignDialog_dialog_table_column_10: '任务单价',
        component_TaskAssignDialog_dialog_table_column_11: '计价字数',
        component_TaskAssignDialog_dialog_table_column_12: '任务总价',
        component_TaskAssignDialog_dialog_table_column_13: '源语言',
        component_TaskAssignDialog_dialog_table_column_14: '目标语言',
        component_TaskAssignDialog_dialog_method_submitAssignEvent_message_1: '请选择负责人',
        component_TaskAssignDialog_dialog_method_rowClickEvent_message_1: '无法分配，请联系用户提供手机号后重试',




        project_task_statistics_page_tab_pane_label_1: '全部',
        project_task_statistics_page_tab_pane_label_2: '待接受',
        project_task_statistics_page_tab_pane_label_3: '进行中',
        project_task_statistics_page_tab_pane_label_4: '已提交',
        project_task_statistics_page_tips_1: '刷新',
        project_task_statistics_page_tips_2: '暂无任务开始时间',
        project_task_statistics_page_tips_3: '暂无任务结束时间',
        project_task_statistics_page_tips_4: '%',
        project_task_statistics_page_form_item_label_1: '所属团队',
        project_task_statistics_page_form_item_label_2: '项目创建人',
        project_task_statistics_page_form_item_label_3: '任务负责人',
        project_task_statistics_page_form_item_label_4: '任务类型',
        project_task_statistics_page_form_item_label_5: '源语言',
        project_task_statistics_page_form_item_label_6: '目标语言',
        project_task_statistics_page_form_item_label_7: '开始时间',
        project_task_statistics_page_form_item_label_8: '结束时间',
        project_task_statistics_page_select_placeholder_1: '所属团队',
        project_task_statistics_page_select_placeholder_2: '项目创建人',
        project_task_statistics_page_select_placeholder_3: '任务负责人',
        project_task_statistics_page_select_placeholder_4: '任务类型',
        project_task_statistics_page_select_placeholder_5: '源语言',
        project_task_statistics_page_select_placeholder_6: '目标语言',
        project_task_statistics_page_select_placeholder_7: '开始时间',
        project_task_statistics_page_select_placeholder_8: '结束时间',
        project_task_statistics_page_input_placeholder_1: '搜索任务',

        project_task_statistics_page_table_column_1: '任务名称',
        project_task_statistics_page_table_column_2: '负责人',
        project_task_statistics_page_table_column_3: '任务类型',
        project_task_statistics_page_table_column_4: '项目名称',
        project_task_statistics_page_table_column_5: '项目创建人',
        project_task_statistics_page_table_column_6: '语言方向',
        project_task_statistics_page_table_column_7: '任务时段',
        project_task_statistics_page_table_column_8: '任务状态',
        project_task_statistics_page_table_column_9: '任务进度',
        project_task_statistics_page_table_column_10: '任务字数',
        project_task_statistics_page_table_column_11: '计价字数',
        project_task_statistics_page_table_column_12: '单价',
        project_task_statistics_page_table_column_13: '币种',
        project_task_statistics_page_table_column_14: '总价',
        project_task_statistics_page_method_downloadBtnEvent_title: '任务统计',

        project_template_page_btn_1: '刷新',
        project_template_page_btn_2: '删除',
        project_template_page_btn_3: '新建',

        project_template_page_input_placeholder_1: '输入模版名称',

        project_template_page_table_column_1: '项目模板名称',
        project_template_page_table_column_2: '语言方向',
        project_template_page_table_column_3: '项目流程',
        project_template_page_table_column_4: '所属团队',
        project_template_page_table_column_5: '创建人',
        project_template_page_table_column_6: '创建时间',
        project_template_page_table_column_7: '操作',
        project_template_page_dropdown_item_1: '重命名',
        project_template_page_dropdown_item_2: '删除',
        project_template_page_dropdown_item_3: '复制',
        project_template_page_dropdown_item_4: '编辑',
        project_template_page_dialog_1_title: '模板重命名',
        project_template_page_dialog_1_input_placeholder_1: '输入模板名称',
        project_template_page_dialog_1_btn_1: '取消',
        project_template_page_dialog_1_btn_2: '确定',
        project_template_page_data_alertInfo_message: '确定要删除该项目模板吗？',
        project_template_page_data_alertInfo_buttonName: '确定',
        project_template_page_method_saveRenameBtnEvent_message_1: '请输入模板名称',
        project_template_page_method_saveRenameBtnEvent_message_2: '重命名成功',
        project_template_page_method_deleteBtnEvent_message_1: '请选择模板',
        project_template_page_method_deleteBtnEvent_message_2: '确认删除选中的项目模板吗？',
        project_template_page_method_deleteTemplateItem_message_1: '确定要删除该项目模板吗？',
        project_template_page_method_deleteConfirmEvent_message_1: '删除成功',
        project_template_page_method_copyTemplate_message_1: '复制成功',

        project_templateDetail_page_btn_1: '保存模版',
        project_templateDetail_page_tab_pane_label_1: '基础设置',
        project_templateDetail_page_tab_pane_label_2: '记忆库',
        project_templateDetail_page_tab_pane_label_3: '术语库',
        project_templateDetail_page_tab_pane_label_4: '文档设置',
        project_templateDetail_page_tab_pane_label_5: 'QA设置',
        project_templateDetail_page_tab_pane_label_6: '风格指南',
        project_templateDetail_page_tab_pane_label_7: '自动评分',


        project_templateDetail_page_tips_1: '基础设置填写完成后即可保存模版，随时保存防止数据丢失，快捷键：',
        project_templateDetail_page_tips_2: '模板名称',
        project_templateDetail_page_tips_3: '所属团队',
        project_templateDetail_page_tips_4: '项目流程',
        project_templateDetail_page_tips_5: '语言方向',
        project_templateDetail_page_tips_6: '预翻译模型',
        project_templateDetail_page_tips_7: '参考翻译模型（非必选）',
        project_templateDetail_page_tips_8: '人工翻译',
        project_templateDetail_page_tips_9: '选择源语言和目标语言后设置翻译模型',
        project_templateDetail_page_tips_10: '高级设置',
        project_templateDetail_page_tips_11: '1、锁定项在编辑器优先次序为：非译元素',
        project_templateDetail_page_tips_12: '2、计价字数设置对所有文件生效；锁定设置仅对追加文件生效。',
        project_templateDetail_page_tips_13: '自动替换',
        project_templateDetail_page_tips_14: '锁定设置',
        project_templateDetail_page_tips_15: '计价字数',
        project_templateDetail_page_tips_16: '创建人',
        project_templateDetail_page_tips_17: '创建时间',
        project_templateDetail_page_tips_18: '修改时间',
        project_templateDetail_page_tips_19: '匹配率',
        project_templateDetail_page_tips_20: '条',
        project_templateDetail_page_tips_21: '全选',
        project_templateDetail_page_tips_22: '规则QA设置',
        project_templateDetail_page_tips_23: '智能QA设置',
        project_templateDetail_page_tips_24: 'QA处理流程设置',
        project_templateDetail_page_tips_25: '处理完QA才允许提交任务',
        project_templateDetail_page_tips_26: '备注说明',
        project_templateDetail_page_tips_27: '自动评分',
        project_templateDetail_page_tips_28: 'AI对预翻译的译文进行评分',
        project_templateDetail_page_tips_29: '评分阈值',
        project_templateDetail_page_tips_30: '将此分数以下的译文标记为高风险句段',

        project_templateDetail_page_placeholder_1: '输入模版名称',
        project_templateDetail_page_placeholder_2: '选择所属团队',
        project_templateDetail_page_placeholder_3: '选择项目流程',
        project_templateDetail_page_placeholder_4: '选择源语言',
        project_templateDetail_page_placeholder_5: '选择目标语言',
        project_templateDetail_page_placeholder_6: '选择预翻译模型',
        project_templateDetail_page_placeholder_7: '选择参考翻译模型',
        project_templateDetail_page_placeholder_8: '匹配率',
        project_templateDetail_page_placeholder_9: '输入备注说明',

        project_templateDetail_page_table_column_1: '写入',
        project_templateDetail_page_table_column_2: '名称',
        project_templateDetail_page_table_column_3: '语言方向',
        project_templateDetail_page_table_column_4: '条数',
        project_templateDetail_page_table_column_5: '罚分',
        project_templateDetail_page_table_column_6: '创建时间',
        project_templateDetail_page_table_column_7: '序号',
        project_templateDetail_page_table_column_8: '文件名',
        project_templateDetail_page_table_column_9: '创建时间',
        project_templateDetail_page_table_column_10: '操作',

        project_templateDetail_page_btn_1: '新建',
        project_templateDetail_page_btn_2: '刷新',
        project_templateDetail_page_btn_3: '添加文件',
        project_templateDetail_page_btn_4: '取消',
        project_templateDetail_page_btn_5: '确定',
        project_templateDetail_page_btn_6: '保存模板',

        project_templateDetail_page_dialog_1_title: '上传风格指南文件',
        project_templateDetail_page_dialog_1_tips_1: '当前项目最多可上传',
        project_templateDetail_page_dialog_1_tips_2: '个文件，如有多个文件建议上传压缩包',

        project_templateDetail_page_method_settingTabChange_message_1: '请先选择源语言和目标语言',
        project_templateDetail_page_method_saveTemplateBtnEvent_message_1: '修改模板成功',
        project_templateDetail_page_method_saveTemplateBtnEvent_message_2: '新建模板成功',
        project_templateDetail_page_method_saveTemplateBtnEvent_message_3: '请填写模版名称',
        project_templateDetail_page_method_saveTemplateBtnEvent_message_4: '请选择所属团队',
        project_templateDetail_page_method_saveTemplateBtnEvent_message_5: '请选择源语言',
        project_templateDetail_page_method_saveTemplateBtnEvent_message_6: '请选择目标语言',


    },
    asset: {
        memory_index_page_button_text_1: '新建记忆库',
        memory_index_page_button_text_2: '合并记忆库',
        memory_index_page_button_text_3: '删除记忆库',
        memory_index_page_tab_label_1: '全部',
        memory_index_page_tab_label_2: '自建库',
        memory_index_page_tab_label_3: '默认库',
        memory_index_page_tab_label_4: '我的库',

        memory_index_page_search_input_placeholder: '全量搜索',
        memory_index_page_search_select_placeholder_1: '源语言',
        memory_index_page_search_select_placeholder_2: '目标语言',
        memory_index_page_search_select_placeholder_3: '所属团队',
        memory_index_page_search_select_placeholder_4: '创建人',
        memory_index_page_search_select_placeholder_5: '创建时间',
        memory_index_page_search_select_placeholder_6: '是否合并',
        memory_index_page_tips_1: '切换',
        memory_index_page_tips_2: '列表',
        memory_index_page_tips_3: '卡片',
        memory_index_page_tips_4: '视图',
        memory_index_page_card_item_label_1: '记忆库名称：',
        memory_index_page_card_item_label_2: '所属团队：',
        memory_index_page_card_item_label_3: '创建人：',
        memory_index_page_card_item_label_4: '条',
        memory_index_page_card_item_label_5: '创建时间：',
        memory_index_page_card_item_label_6: '最近更新人：',
        memory_index_page_card_item_label_7: '最近更新时间：',
        memory_index_page_card_item_dropdown_label_1: '查看',
        memory_index_page_card_item_dropdown_label_2: '下载Excel',
        memory_index_page_card_item_dropdown_label_3: '下载TMX',
        memory_index_page_card_item_dropdown_label_4: '重命名',
        memory_index_page_card_item_dropdown_label_5: '删除',

        memory_index_page_table_column_item_label_1: '记忆库名称',
        memory_index_page_table_column_item_label_2: '语言方向',
        memory_index_page_table_column_item_label_3: '条数',
        memory_index_page_table_column_item_label_4: '创建人',
        memory_index_page_table_column_item_label_5: '创建时间',
        memory_index_page_table_column_item_label_6: '操作',

        memory_index_page_empty_label_1: '没有找到记忆库～',
        memory_index_page_empty_label_2: '还没有记忆库，去新建一个记忆库吧～',
        memory_index_page_dialog_1_title: '重命名记忆库',
        memory_index_page_dialog_1_form_item_label_1: '名称',
        memory_index_page_dialog_1_form_item_placeholder_1: '输入记忆库名称',
        memory_index_page_dialog_1_btn_label_1: '取消',
        memory_index_page_dialog_1_btn_label_2: '保存',
        memory_index_page_dialog_2_title: '合并记忆库',
        memory_index_page_dialog_2_form_item_label_1: '记忆库名称',
        memory_index_page_dialog_2_form_item_placeholder_1: '输入记忆库名称',
        memory_index_page_dialog_2_form_item_checkbox_label_2: '合并后删除原记忆库',
        memory_index_page_dialog_2_form_item_label_2: '设置',
        memory_index_page_dialog_2_form_item_radio_label_1: '合并匹配上下文的翻译记忆',
        memory_index_page_dialog_2_form_item_radio_label_2: '覆盖现有的翻译记忆',
        memory_index_page_dialog_2_form_item_radio_label_3: '保留新旧翻译记忆',
        memory_index_page_dialog_2_tips_1: '对于原文相同译文不同的翻译记忆：',
        memory_index_page_dialog_2_btn_label_1: '取消',
        memory_index_page_dialog_2_btn_label_2: '合并',
        memory_index_page_alert_info_message_1: '确定要删除记忆库吗？',
        memory_index_page_alert_info_buttonName_1: '确认删除',
        memory_index_page_mergeOptions_name_1: '未合并',
        memory_index_page_mergeOptions_name_2: '已合并',
        memory_index_page_validation_message_1: '暂无权限',
        memory_index_page_validation_message_2: '记忆库名称必须填写',
        memory_index_page_validation_message_3: '重命名记忆库成功',
        memory_index_page_validation_message_4: '先选中两个或多个同语言方向的记忆库再合并',
        memory_index_page_validation_message_5: '请选择语言方向相同的记忆库进行合并',
        memory_index_page_validation_message_6: '记忆库名称不能为空',
        memory_index_page_validation_message_7: '记忆库已合并',
        memory_index_page_validation_message_8: '记忆库已删除',
        memory_index_page_validation_message_9: '请选择记忆库',

        memory_detail_page_fullLoading_message: '查询中...',
        memory_detail_page_more_info_form_item_label_1: '语言方向',
        memory_detail_page_more_info_form_item_label_2: '条数',
        memory_detail_page_more_info_form_item_label_2_1: '条',
        memory_detail_page_more_info_form_item_label_3: '创建时间',
        memory_detail_page_search_input_placeholder: '输入翻译记忆原文或译文',
        memory_detail_page_search_btn_label_1: '删除',
        memory_detail_page_search_btn_label_2: '上传记忆库',
        memory_detail_page_search_btn_label_3: '下载',
        memory_detail_page_search_btn_label_4: '下载Excel',
        memory_detail_page_search_btn_label_5: '下载TMX',
        memory_detail_page_table_colum_label_1: '序号',
        memory_detail_page_table_colum_label_2: '原文（{value}）',
        memory_detail_page_table_colum_label_3: '译文（{value}）',
        memory_detail_page_table_colum_label_4: '操作',
        memory_detail_page_table_colum_input_placeholder_1: '输入翻译记忆原文',
        memory_detail_page_table_colum_input_placeholder_2: '输入翻译记忆译文',
        memory_detail_page_table_colum_btn_tips_1: '保存',
        memory_detail_page_table_colum_btn_tips_2: '删除',
        memory_detail_page_table_colum_btn_tips_3: '编辑',
        memory_detail_page_table_colum_tips_1: '创建时间：',
        memory_detail_page_table_colum_tips_2: '创建人：',
        memory_detail_page_table_colum_tips_3: '最近更新时间：',
        memory_detail_page_table_colum_tips_4: '最近更新人：',
        memory_detail_page_table_colum_tips_5: '来源文件名：',
        memory_detail_page_table_colum_tips_6: '来源项目名：',
        memory_detail_page_dialog_title_1: '上传记忆库',
        memory_detail_page_dialog_message_1: '支持{value}，点击下载模版：',
        memory_detail_page_dialog_1_btn_1: '取消',
        memory_detail_page_dialog_1_btn_2: '确定',
        memory_detail_page_alertInfo_message: '确定要删除这些翻译记忆吗？',
        memory_detail_page_alertInfo_buttonName: '确认删除',
        memory_detail_page_downloadTemplate_message: '下载中...',
        memory_detail_page_validation_message_1: '获取下载地址失败',
        memory_detail_page_validation_message_2: '翻译记忆原文不能为空',
        memory_detail_page_validation_message_3: '翻译记忆译文不能为空',
        memory_detail_page_validation_message_4: '保存翻译记忆成功',
        memory_detail_page_validation_message_5: '翻译记忆原文不能为空',
        memory_detail_page_validation_message_6: '翻译记忆译文不能为空',
        memory_detail_page_validation_message_7: '保存翻译记忆成功',
        memory_detail_page_validation_message_8: '记忆库名称必须填写',
        memory_detail_page_validation_message_9: '重命名记忆库成功',
        memory_detail_page_validation_message_10: '翻译记忆已删除',
        memory_detail_page_validation_message_11: '请确认已上传文件并上传成功',
        memory_detail_page_validation_message_12: '上传成功，共发现 {totalCount} 条记录，成功导入 {successCount} 条，丢弃 {errorCount} 条（内容为空、原译文相同、重复）。',

        term_index_page_search_btn_label_1: '新建术语库',
        term_index_page_search_btn_label_2: '合并术语库',
        term_index_page_search_btn_label_3: '删除术语库',
        term_index_page_tab_label_1: '全部',
        term_index_page_tab_label_2: '自建库',
        term_index_page_tab_label_3: '默认库',
        term_index_page_tab_label_4: '我的库',
        term_index_page_search_input_placeholder: '全量搜索',
        term_index_page_search_select_1_placeholder: '源语言',
        term_index_page_search_select_2_placeholder: '目标语言',
        term_index_page_search_select_3_placeholder: '所属团队',
        term_index_page_search_select_placeholder_4: '创建人',
        term_index_page_search_select_placeholder_5: '创建时间',
        term_index_page_search_select_placeholder_6: '是否合并',
        term_index_page_tips_1: '切换',
        term_index_page_tips_2: '列表',
        term_index_page_tips_3: '卡片',
        term_index_page_tips_4: '视图',
        term_index_page_item_tips_1: '术语库名称：',
        term_index_page_item_tips_2: '所属团队：',
        term_index_page_item_tips_3: '创建人：',
        term_index_page_item_tips_4: '条',
        term_index_page_item_tips_5: '创建时间：',
        term_index_page_item_tips_6: '最近更新人：',
        term_index_page_item_tips_7: '最近更新时间：',
        term_index_page_item_dropdown_label_1: '查看',
        term_index_page_item_dropdown_label_2: '下载Excel',
        term_index_page_item_dropdown_label_3: '下载TBX',
        term_index_page_item_dropdown_label_4: '重命名',
        term_index_page_item_dropdown_label_5: '删除',
        term_index_page_empty_message_1: '没有找到术语库～',
        term_index_page_empty_message_2: '还没有术语库，去新建一个术语库吧～',
        term_index_page_dialog_1_title: '重命名术语库',
        term_index_page_dialog_1_form_item_label_1: '名称',
        term_index_page_dialog_1_form_item_placeholder_1: '输入术语库名称',
        term_index_page_dialog_1_btn_label_1: '取消',
        term_index_page_dialog_1_btn_label_2: '保存',
        term_index_page_dialog_2_title: '合并术语库',
        term_index_page_dialog_2_form_item_label_1: '术语库名称',
        term_index_page_dialog_2_form_item_placeholder_1: '输入术语库名称',
        term_index_page_dialog_2_form_item_checkbox_label_1: '合并后删除原术语库',
        term_index_page_dialog_2_form_item_label_2: '设置',
        term_index_page_dialog_2_form_item_radio_label_1: '覆盖现有的术语',
        term_index_page_dialog_2_form_item_radio_label_2: '保留新旧术语',
        term_index_page_dialog_2_tips_1: '对于原文相同译文不同的术语：',
        term_index_page_dialog_2_btn_label_1: '取消',
        term_index_page_dialog_2_btn_label_2: '保存',
        term_index_page_alertInfo_message: '确定要删除术语库吗？',
        term_index_page_alertInfo_buttonName: '确认删除',
        term_index_page_mergeOptions_name_1: '未合并',
        term_index_page_mergeOptions_name_2: '已合并',
        term_index_page_validation_message_1: '暂无权限',
        term_index_page_validation_message_2: '术语库名称必须填写',
        term_index_page_validation_message_3: '重命名术语库成功',
        term_index_page_validation_message_4: '先选中两个或多个同语言方向的术语库再合并',
        term_index_page_validation_message_5: '请选择语言方向相同的术语库进行合并',
        term_index_page_validation_message_6: '术语库名称不能为空',
        term_index_page_validation_message_7: '术语库已合并',
        term_index_page_validation_message_8: '术语库已删除',
        term_index_page_validation_message_9: '请选择术语库',
        
        term_index_page_table_column_item_label_1: '术语库名称',
        term_index_page_table_column_item_label_2: '语言方向',
        term_index_page_table_column_item_label_3: '条数',
        term_index_page_table_column_item_label_4: '创建人',
        term_index_page_table_column_item_label_5: '创建时间',
        term_index_page_table_column_item_label_6: '操作',
        
        term_detail_page_more_info_form_item_label_1: '语言方向',
        term_detail_page_more_info_form_item_label_2: '条数',
        term_detail_page_more_info_form_item_label_2_1: '条',
        term_detail_page_more_info_form_item_label_3: '创建时间',
        term_detail_page_search_input_placeholder: '输入术语',
        term_detail_page_search_btn_label_1: '删除',
        term_detail_page_search_btn_label_2: '上传术语表',
        term_detail_page_search_btn_label_3: '下载',
        term_detail_page_search_btn_label_4: '下载Excel',
        term_detail_page_search_btn_label_5: '下载TBX',
        term_detail_page_table_colum_label_1: '序号',
        term_detail_page_table_colum_label_2: '原文（{value}）',
        term_detail_page_table_colum_label_3: '译文（{value}）',
        term_detail_page_table_colum_label_4: '备注',
        term_detail_page_table_colum_label_5: '操作',
        term_detail_page_table_colum_input_placeholder_1: '输入术语原文',
        term_detail_page_table_colum_input_placeholder_2: '输入术语译文',
        term_detail_page_table_colum_input_placeholder_3: '输入备注',
        term_detail_page_table_colum_btn_tips_1: '保存',
        term_detail_page_table_colum_btn_tips_2: '删除',
        term_detail_page_table_colum_btn_tips_3: '编辑',
        term_detail_page_table_colum_tips_1: '创建时间：',
        term_detail_page_table_colum_tips_2: '创建人：',
        term_detail_page_table_colum_tips_3: '最近更新时间：',
        term_detail_page_table_colum_tips_4: '最近更新人：',
        term_detail_page_dialog_title_1: '上传术语库',
        term_detail_page_dialog_message_1: '支持{value}，点击下载模版：',
        term_detail_page_dialog_1_btn_1: '取消',
        term_detail_page_dialog_1_btn_2: '确定',
        term_detail_page_alertInfo_message: '确定要删除这些术语吗？',
        term_detail_page_alertInfo_buttonName: '确认删除',
        term_detail_page_downloadTemplate_message: '下载中...',
        term_detail_page_validation_message_1: '术语原文不能为空',
        term_detail_page_validation_message_2: '术语译文不能为空',
        term_detail_page_validation_message_3: '保存术语成功',
        term_detail_page_validation_message_4: '术语原文不能为空',
        term_detail_page_validation_message_5: '术语译文不能为空',
        term_detail_page_validation_message_6: '保存术语成功',
        term_detail_page_validation_message_7: '术语库名称必须填写',
        term_detail_page_validation_message_8: '重命名术语库成功',
        term_detail_page_validation_message_9: '术语已删除',
        term_detail_page_validation_message_10: '获取下载地址失败',
        term_detail_page_validation_message_11: '请确认已上传文件并上传成功',
        term_detail_page_validation_message_12: '上传成功，共发现 {totalCount} 条记录，成功导入 {successCount} 条，丢弃 {errorCount} 条（过长、重复或语种不匹配）。',
        
        component_FulltextSearch_dialog_title_1: '记忆库的全量搜索',
        component_FulltextSearch_dialog_title_2: '术语库的全量搜索',
        component_FulltextSearch_search_input_placeholder: '输入关键词',
        component_FulltextSearch_search_select_placeholder: '请选择',
        component_FulltextSearch_search_select_option_1: '按标题搜索',
        component_FulltextSearch_search_select_option_2: '按内容搜索',
        component_FulltextSearch_search_btn_label: '开始搜索',
        component_FulltextSearch_search_result_total: '查找结果{total}条',
        component_FulltextSearch_search_result_param_name_1: '所属团队：',
        component_FulltextSearch_search_result_param_name_2: '创建人：',
        component_FulltextSearch_search_result_param_name_3: '语向：',
        component_FulltextSearch_search_result_param_name_4: '修改时间：',
        component_FulltextSearch_search_result_param_label_1: '条',
        component_FulltextSearch_search_result_param_label_2: '标题：',
        component_FulltextSearch_search_result_param_label_3: '原文：',
        component_FulltextSearch_search_result_param_label_4: '译文：',
        component_FulltextSearch_search_result_message_1: '加载中...',
        component_FulltextSearch_search_result_message_2: '已经展示全部结果',
        component_FulltextSearch_validation_message_1: '请输入搜索内容',

        component_Tabs_tab_name_1: '记忆库',
        component_Tabs_tab_name_2: '术语库',

        component_CreateMemory_dialog_title: '新建记忆库',
        component_CreateMemory_form_item_label_1: '名称',
        component_CreateMemory_form_item_placeholder_1: '输入记忆库名称',
        component_CreateMemory_form_item_label_2: '语言对',
        component_CreateMemory_form_item_placeholder_2: '源语言',
        component_CreateMemory_form_item_placeholder_3: '目标语言',
        component_CreateMemory_form_item_label_3: '所属团队',
        component_CreateMemory_form_item_placeholder_4: '选择团队',
        component_CreateMemory_form_item_label_4: '上传记忆库',
        component_CreateMemory_form_item_message_1: '支持{type}，最大{size}M。点击下载模版：',
        component_CreateMemory_dialog_btn_label_1: '取消',
        component_CreateMemory_dialog_btn_label_2: '保存',
        component_CreateMemory_downloadTemplate_message: '下载中...',
        component_CreateMemory_validation_message_1: '获取下载地址失败',
        component_CreateMemory_validation_message_2: '记忆库名称必须填写',
        component_CreateMemory_validation_message_3: '语言对的源语言和目标语言都必须选择',
        component_CreateMemory_validation_message_4: '记忆库创建成功',

        component_CreateTerm_dialog_title: '新建术语库',
        component_CreateTerm_form_item_label_1: '名称',
        component_CreateTerm_form_item_placeholder_1: '输入术语库名称',
        component_CreateTerm_form_item_label_2: '语言对',
        component_CreateTerm_form_item_placeholder_2: '源语言',
        component_CreateTerm_form_item_placeholder_3: '目标语言',
        component_CreateTerm_form_item_label_3: '所属团队',
        component_CreateTerm_form_item_placeholder_4: '选择团队',
        component_CreateTerm_form_item_label_4: '上传术语',
        component_CreateTerm_form_item_message_1: '支持{type}，最大{size}M。点击下载模版：',
        component_CreateTerm_dialog_btn_label_1: '取消',
        component_CreateTerm_dialog_btn_label_2: '保存',
        component_CreateTerm_downloadTemplate_message: '下载中...',
        component_CreateTerm_validation_message_1: '获取下载地址失败',
        component_CreateTerm_validation_message_2: '术语库名称必须填写',
        component_CreateTerm_validation_message_3: '语言对的源语言和目标语言都必须选择',
        component_CreateTerm_validation_message_4: '术语库创建成功',


    },
    tools: {
        tools_page_methods_initList_list_1_name: 'AI 润色',
        tools_page_methods_initList_list_1_desc: '基于生成式AI，你的随身母语润色专家',
        tools_page_methods_initList_list_2_name: 'AI 翻译评分',
        tools_page_methods_initList_list_2_desc: '机翻译文智能评分，Al为你推荐参考翻译模型',
        tools_page_methods_initList_list_3_name: '机翻检测',
        tools_page_methods_initList_list_3_desc: '智能标记机翻痕迹，有效识别译文质量风险',
        tools_page_methods_initList_list_4_name: '语料对齐',
        tools_page_methods_initList_list_4_desc: '业内领先的对齐算法，拖拽式对齐体验，AI让语料对齐更简单',
        tools_page_methods_initList_list_5_name: 'AI 译配',
        tools_page_methods_initList_list_5_desc: '一键翻译和配音，瞬间切换语言的AI魔法',
        tools_page_methods_initList_list_5_free: '免费试用开启',
        tools_page_methods_initList_list_6_name: 'QA 检查',
        tools_page_methods_initList_list_6_desc: '不止基于规则的QA，更基于语义理解的智能检查',
        tools_page_methods_initList_list_7_name: '术语提取',
        tools_page_methods_initList_list_7_desc: '智能提取批量文件术语，快速修改即可制作术语库',
        tools_page_methods_initList_list_8_name: '大模型智能体翻译',
        tools_page_methods_initList_list_8_desc: '集合多个智能体的本地化流程协作，更专业更精准',
        tools_page_methods_initList_list_9_name: '历史',
        tools_page_methods_initList_list_9_desc: '查看和管理翻译历史记录',
        tools_page_methods_goTo_message_1: '请升级到对应的版本后使用。',
        
        tools_alignIndex_page_btn_1: '语料对齐',
        tools_alignIndex_page_btn_2: '刷新',
        tools_alignIndex_page_btn_3: '语料对齐',
        tools_alignIndex_page_input_placeholder_1: '输入名称',
        tools_alignIndex_page_select_placeholder_1: '排序方式',
        tools_alignIndex_page_select_option_1: '按时间排序',
        tools_alignIndex_page_tips_1: '没有找到任务～',
        tools_alignIndex_page_tips_2: '业内领先的对齐算法，全新拖拽式对齐体验',
        tools_alignIndex_page_dialog_1_title_1: '语料对齐',
        tools_alignIndex_page_dialog_1_title_2: '确认信息',
        tools_alignIndex_page_dialog_1_tips_1: '支持{type}格式，单个文件最大{size}MB',
        tools_alignIndex_page_dialog_1_tips_2: '上传',
        tools_alignIndex_page_dialog_1_tips_3: '原文',
        tools_alignIndex_page_dialog_1_tips_4: '文档',
        tools_alignIndex_page_dialog_1_tips_5: '上传译文',
        tools_alignIndex_page_dialog_1_tips_6: '语言方向',
        tools_alignIndex_page_dialog_1_tips_7: '点击切换',
        tools_alignIndex_page_dialog_1_tips_8: '译文',

        tools_alignIndex_page_dialog_1_btn_1: '取消',
        tools_alignIndex_page_dialog_1_btn_2: '下一步',
        tools_alignIndex_page_dialog_1_btn_3: '上一步',
        tools_alignIndex_page_dialog_1_btn_4: '开始对齐',
        tools_alignIndex_page_data_alertInfo_message: '确定要删除这个任务吗？',
        tools_alignIndex_page_data_alertInfo_buttonName: '确认删除',
        tools_alignIndex_page_data_languageDict_zh_name: '中文',
        tools_alignIndex_page_data_languageDict_zh_shortName: '中',
        tools_alignIndex_page_data_languageDict_en_name: '英语',
        tools_alignIndex_page_data_languageDict_en_shortName: '英',
        tools_alignIndex_page_data_languageDict_ru_name: '俄语',
        tools_alignIndex_page_data_languageDict_ru_shortName: '俄',
        tools_alignIndex_page_data_languageDict_fr_name: '法语',
        tools_alignIndex_page_data_languageDict_fr_shortName: '法',
        tools_alignIndex_page_data_languageDict_de_name: '德语',
        tools_alignIndex_page_data_languageDict_de_shortName: '德',
        tools_alignIndex_page_data_languageDict_es_name: '西班牙语',
        tools_alignIndex_page_data_languageDict_es_shortName: '西',
        tools_alignIndex_page_data_languageDict_pt_name: '葡萄牙语',
        tools_alignIndex_page_data_languageDict_pt_shortName: '葡',
        tools_alignIndex_page_data_languageDict_ar_name: '阿拉伯语',
        tools_alignIndex_page_data_languageDict_ar_shortName: '阿',
        tools_alignIndex_page_data_languageDict_ja_name: '日语',
        tools_alignIndex_page_data_languageDict_ja_shortName: '日',
        tools_alignIndex_page_data_languageDict_ko_name: '韩语',
        tools_alignIndex_page_data_languageDict_ko_shortName: '韩',
        tools_alignIndex_page_data_languageDict_th_name: '泰语',
        tools_alignIndex_page_data_languageDict_th_shortName: '泰',
        tools_alignIndex_page_data_languageDict_vi_name: '泰语',
        tools_alignIndex_page_data_languageDict_vi_shortName: '泰',
        tools_alignIndex_page_data_languageDict_ms_name: '马来语',
        tools_alignIndex_page_data_languageDict_ms_shortName: '马',
        tools_alignIndex_page_data_languageDict_id_name: '印尼语',
        tools_alignIndex_page_data_languageDict_id_shortName: '印尼',
        tools_alignIndex_page_data_languageDict_it_name: '意大利语',
        tools_alignIndex_page_data_languageDict_it_shortName: '意语',
        tools_alignIndex_page_data_languageDict_da_name: '丹麦语',
        tools_alignIndex_page_data_languageDict_da_shortName: '丹麦',
        tools_alignIndex_page_data_languageDict_nl_name: '荷兰语',
        tools_alignIndex_page_data_languageDict_nl_shortName: '荷',
        tools_alignIndex_page_data_languageDict_no_name: '挪威语',
        tools_alignIndex_page_data_languageDict_no_shortName: '挪威语',
        tools_alignIndex_page_data_languageDict_sv_name: '瑞典语',
        tools_alignIndex_page_data_languageDict_sv_shortName: '瑞语',
        tools_alignIndex_page_data_typeRadioOptions_name_1: '双文档对齐',
        tools_alignIndex_page_data_typeRadioOptions_name_2: '单文档对齐',
        tools_alignIndex_page_method_comfirmTaskEvent_message_1: '请上传原文',
        tools_alignIndex_page_method_comfirmTaskEvent_message_2: '请上传译文',
        tools_alignIndex_page_method_startTaskEvent_message_1: '请上传原文',
        tools_alignIndex_page_method_startTaskEvent_message_2: '请上传译文',
        tools_alignIndex_page_method_startTaskEvent_message_3: '任务已开始执行',
        tools_alignIndex_page_method_executeAction_message_1: '暂无权限',
        tools_alignIndex_page_method_deleteTask_message_1: '任务已删除',
        tools_alignDetail_page_form_item_label_1: '语言方向',
        tools_alignDetail_page_form_item_label_2: '创建时间',
        tools_alignDetail_page_tips_1: 'AI 对齐版',
        tools_alignDetail_page_tips_2: '规则对齐版',
        tools_alignDetail_page_tips_3: 'AI对齐：适用于较复杂或文档对应不规范的文件，由AI对齐，手动调整不整体上/下移',
        tools_alignDetail_page_tips_4: '规则对齐：适用于文档对应较规范的文件，按照句段切分规则对齐，手动对齐时整体上/下移',
        tools_alignDetail_page_tips_5: '下载',
        tools_alignDetail_page_tips_6: '下载Word',
        tools_alignDetail_page_tips_7: '下载Excel',
        tools_alignDetail_page_tips_8: '下载TMX',
        tools_alignDetail_page_tips_9: 'Ctrl/⌘ + Z',
        tools_alignDetail_page_tips_10: 'Ctrl/⌘ + Y',
        tools_alignDetail_page_tips_11: 'Ctrl/⌘ + I',
        tools_alignDetail_page_tips_12: 'Ctrl/⌘ + E',
        tools_alignDetail_page_tips_13: '双击进入编辑状态后再拆分 Ctrl/⌘ + Enter',
        tools_alignDetail_page_tips_14: 'Ctrl/⌘ + M',
        tools_alignDetail_page_tips_15: 'Ctrl/⌘ + Delete',
        tools_alignDetail_page_tips_16: 'Ctrl/⌘ + F',
        tools_alignDetail_page_tips_17: '点击',
        tools_alignDetail_page_tips_18: '拖动以调整句段位置；<kbd>Ctrl</kbd> / <kbd>⌘</kbd> + 点选可批量选中',
        tools_alignDetail_page_tips_19: '序号',
        tools_alignDetail_page_tips_20: '标记',
        tools_alignDetail_page_tips_21: '原文（{lang}）',
        tools_alignDetail_page_tips_21: '译文（{lang}）',
        tools_alignDetail_page_tips_22: '取消标记',
        tools_alignDetail_page_tips_23: '标为待处理',
        tools_alignDetail_page_tips_24: '双击编辑',
        tools_alignDetail_page_tips_25: '列表无结果',

        tools_alignDetail_page_btn_1: '保存到记忆库',
        tools_alignDetail_page_btn_2: '撤销',
        tools_alignDetail_page_btn_3: '恢复',
        tools_alignDetail_page_btn_4: '插入',
        tools_alignDetail_page_btn_5: '编辑',
        tools_alignDetail_page_btn_6: '拆分',
        tools_alignDetail_page_btn_7: '合并',
        tools_alignDetail_page_btn_8: '删除',
        tools_alignDetail_page_btn_9: '快捷键',
        tools_alignDetail_page_btn_10: '查找替换',
        tools_alignDetail_page_btn_11: '清洗',

        tools_alignDetail_page_select_placeholder_1: '语料筛选和清洗',

        tools_alignDetail_page_input_placeholder_1: '输入原文',
        tools_alignDetail_page_input_placeholder_2: '输入译文',

        tools_alignDetail_page_hotkeyTable_columns_1: '功能',
        tools_alignDetail_page_hotkeyTable_columns_2: '快捷键',

        tools_alignDetail_page_dialog_1_title: '保存到记忆库',
        tools_alignDetail_page_dialog_1_tips_1: '对齐结果只能保存一次，请确认全部对齐后再保存',
        tools_alignDetail_page_dialog_1_form_item_1: '记忆库名称',
        tools_alignDetail_page_dialog_1_form_item_2: '选择团队',
        tools_alignDetail_page_dialog_1_input_placeholder_1: '输入新记忆库名或选择已有记忆库',
        tools_alignDetail_page_dialog_1_select_placeholder_1: '选择团队',
        tools_alignDetail_page_dialog_1_btn_1: '取消',
        tools_alignDetail_page_dialog_1_btn_2: '保存',

        tools_alignDetail_page_dialog_2_title: '插入',
        tools_alignDetail_page_dialog_2_form_item_1: '原文（{lang}）',
        tools_alignDetail_page_dialog_2_input_placeholder_1: '输入原文',
        tools_alignDetail_page_dialog_2_form_item_2: '译文（{lang}）',
        tools_alignDetail_page_dialog_2_input_placeholder_2: '输入译文',
        tools_alignDetail_page_dialog_2_btn_1: '取消',
        tools_alignDetail_page_dialog_2_btn_2: '插入',

        tools_alignDetail_page_dialog_3_title: '查找替换',
        tools_alignDetail_page_dialog_3_tips_1: '查找',
        tools_alignDetail_page_dialog_3_tips_2: '替换为',
        tools_alignDetail_page_dialog_3_tips_3: '当前页{number}/{count}，共{size}个',
        tools_alignDetail_page_dialog_3_input_placeholder_1: '输入查找的内容',
        tools_alignDetail_page_dialog_3_input_placeholder_2: '输入替换的内容',
        tools_alignDetail_page_dialog_3_checkbox_label_1: 'Aa区分大小写',
        tools_alignDetail_page_dialog_3_btn_1: '上一个',
        tools_alignDetail_page_dialog_3_btn_2: '下一个',
        tools_alignDetail_page_dialog_3_btn_3: '替换',
        tools_alignDetail_page_dialog_3_btn_4: '全部替换',

        tools_alignDetail_page_data_hotkeyList_name_1: '撤销',
        tools_alignDetail_page_data_hotkeyList_name_2: '恢复',
        tools_alignDetail_page_data_hotkeyList_name_3: '编辑',
        tools_alignDetail_page_data_hotkeyList_name_4: '插入',
        tools_alignDetail_page_data_hotkeyList_name_5: '拆分',
        tools_alignDetail_page_data_hotkeyList_name_6: '合并',
        tools_alignDetail_page_data_hotkeyList_name_7: '删除',
        tools_alignDetail_page_data_hotkeyList_name_8: '查找替换',
        tools_alignDetail_page_data_hotkeyList_name_9: '跨行选中',
        tools_alignDetail_page_data_hotkeyList_name_10: '批量选中',
        tools_alignDetail_page_data_hotkeyList_key_tips_1: '点选',
        tools_alignDetail_page_data_alertInfo_message: '确定要删除语料吗？',
        tools_alignDetail_page_data_alertInfo_buttonName: '确认删除',
        tools_alignDetail_page_data_cleanUnAlignDialog_buttonName: '确认清洗',
        tools_alignDetail_page_data_submitAllDialog_message: '是否一键将所有句段确认为对齐状态？缺原文或译文的语料不会包括在内',
        tools_alignDetail_page_data_submitAllDialog_buttonName: '确认',
        tools_alignDetail_page_data_sortOptions_value_1: '有警示色（未对齐）',
        tools_alignDetail_page_data_sortOptions_value_2: '缺少原文或译文',
        tools_alignDetail_page_data_sortOptions_value_3: '原文或译文重复',
        tools_alignDetail_page_data_sortOptions_value_4: '原文译文相同',
        tools_alignDetail_page_method_initPage_message_1: '没有查找到对应的记录',
        tools_alignDetail_page_method_saveEditEvent_message_1: '保存成功',
        tools_alignDetail_page_method_saveAddEvent_message_1: '原文不能为空',
        tools_alignDetail_page_method_saveAddEvent_message_2: '译文不能为空',
        tools_alignDetail_page_method_saveAddEvent_message_3: '保存成功',
        tools_alignDetail_page_method_deleteUnAlignBtnEvent_message_1: '已删除未对齐数据',
        tools_alignDetail_page_method_repealBtnEvent_message_1: '已撤销',
        tools_alignDetail_page_method_recoverBtnEvent_message_1: '已恢复',
        tools_alignDetail_page_method_splitColEvent_message_1: '原文/译文必须是编辑状态才能拆分，双击单元格进行编辑。',
        tools_alignDetail_page_method_splitColEvent_message_2: '不支持光标在句首或者句尾拆分',
        tools_alignDetail_page_method_splitColEvent_message_3: '已拆分',
        tools_alignDetail_page_method_mergeColEvent_message_1: '不能合并原文和译文',
        tools_alignDetail_page_method_mergeColEvent_message_2: '已合并',
        tools_alignDetail_page_method_exchangeColEvent_message_1: '对调成功',
        tools_alignDetail_page_method_aligningColEvent_message_1: '原文和译文都不能为空',
        tools_alignDetail_page_method_aligningColEvent_message_2: '已对齐',
        tools_alignDetail_page_method_submitRowAlignBtnEvent_message_1: '原文和译文都不能为空',
        tools_alignDetail_page_method_submitRowAlignBtnEvent_message_2: '已确认对齐',
        tools_alignDetail_page_method_deleteBtnEvent_message_1: '请选择句段',
        tools_alignDetail_page_method_deleteConfirmEvent_message_1: '请选择句段',
        tools_alignDetail_page_method_deleteConfirmEvent_message_2: '已删除',
        tools_alignDetail_page_method_saveToMemEvent_message_1: '请输入或选择记忆库名称',
        tools_alignDetail_page_method_saveToMemEvent_message_2: '已保存到记忆库',
        tools_alignDetail_page_method_submitAllBtnEvent_message_1: '已确认对齐',
        tools_alignDetail_page_method_onContextmenu_item_label_1: '插入 (Ctrl/⌘ + I)',
        tools_alignDetail_page_method_onContextmenu_item_label_2: '编辑 (Ctrl/⌘ + E)',
        tools_alignDetail_page_method_onContextmenu_item_label_3: '合并 (Ctrl/⌘ + M)',
        tools_alignDetail_page_method_onContextmenu_item_label_4: '删除 (Ctrl/⌘ + Delete)',
        tools_alignDetail_page_method_clearFilterAlignResultBtnEvent_message_1: '确定清洗{name}的语料',
        tools_alignDetail_page_method_clearFilterAlignResultBtnEvent_message_2: '仅保留第一条',
        tools_alignDetail_page_method_clearFilterAlignResultBtnEvent_message_3: '？',
        tools_alignDetail_page_method_submitClearFilterAlignResult_message_1: '数据已清理',
        tools_alignDetail_page_method_prevBtnEvent_message_1: '没有查找到对应的记录',
        tools_alignDetail_page_method_prevBtnEvent_message_2: '当前已经是第一条',
        tools_alignDetail_page_method_nextBtnEvent_message_1: '没有查找到对应的记录',
        tools_alignDetail_page_method_nextBtnEvent_message_2: '当前已经是最后一条',
        tools_alignDetail_page_method_replaceBtnEvent_message_1: '当前已替换到最后一个',
        tools_alignDetail_page_method_replaceAllBtnEvent_message_1: '成功替换{count1}行记录，${count2}处文本',
        tools_alignDetail_page_method_saveEditTitleEvent_message_1: '重命名成功',

        tools_alignTiled_page_form_item_label_1: '语言方向',
        tools_alignTiled_page_form_item_label_2: '创建时间',
        tools_alignTiled_page_tips_1: 'AI 对齐版',
        tools_alignTiled_page_tips_2: '规则对齐版',
        tools_alignTiled_page_tips_3: 'AI对齐：适用于较复杂或文档对应不规范的文件，由AI对齐，手动调整不整体上/下移',
        tools_alignTiled_page_tips_4: '规则对齐：适用于文档对应较规范的文件，按照句段切分规则对齐，手动对齐时整体上/下移',
        tools_alignTiled_page_tips_5: '下载Word',
        tools_alignTiled_page_tips_6: '下载Excel',
        tools_alignTiled_page_tips_7: '下载TMX',
        tools_alignTiled_page_tips_8: 'Ctrl/⌘ + Z',
        tools_alignTiled_page_tips_9: 'Ctrl/⌘ + Y',
        tools_alignTiled_page_tips_10: 'Ctrl/⌘ + I',
        tools_alignTiled_page_tips_11: 'Ctrl/⌘ + E',
        tools_alignTiled_page_tips_12: '双击进入编辑状态后再拆分 Ctrl/⌘ + Enter',
        tools_alignTiled_page_tips_13: 'Ctrl/⌘ + M',
        tools_alignTiled_page_tips_14: 'Ctrl/⌘ + Delete',
        tools_alignTiled_page_tips_15: 'Ctrl/⌘ + F',
        tools_alignTiled_page_tips_16: '点击',
        tools_alignTiled_page_tips_17: '拖动以调整句段位置；<kbd>Ctrl</kbd> / <kbd>⌘</kbd> + 点选可批量选中',
        tools_alignTiled_page_tips_18: '序号',
        tools_alignTiled_page_tips_19: '原文（{lang}）',
        tools_alignTiled_page_tips_20: '译文（{lang}）',
        tools_alignTiled_page_tips_21: '取消标记',
        tools_alignTiled_page_tips_22: '标为待处理',
        tools_alignTiled_page_tips_23: '双击编辑',
        tools_alignTiled_page_tips_24: '列表无结果',

        tools_alignTiled_page_btn_1: '保存到记忆库',
        tools_alignTiled_page_btn_2: '下载',
        tools_alignTiled_page_btn_3: '撤销',
        tools_alignTiled_page_btn_4: '恢复',
        tools_alignTiled_page_btn_5: '插入',
        tools_alignTiled_page_btn_6: '编辑',
        tools_alignTiled_page_btn_7: '拆分',
        tools_alignTiled_page_btn_8: '合并',
        tools_alignTiled_page_btn_9: '删除',
        tools_alignTiled_page_btn_10: '快捷键',
        tools_alignTiled_page_btn_11: '查找替换',
        tools_alignTiled_page_btn_12: '清洗',

        tools_alignTiled_page_hotkeyListTable_item_label_1: '功能',
        tools_alignTiled_page_hotkeyListTable_item_label_2: '快捷键',

        tools_alignTiled_page_select_placeholder_1: '语料筛选和清洗',
        tools_alignTiled_page_input_placeholder_1: '输入原文',
        tools_alignTiled_page_input_placeholder_2: '输入译文',

        tools_alignTiled_page_dialog_1_title: '保存到记忆库',
        tools_alignTiled_page_dialog_1_tips_1: '对齐结果只能保存一次，请确认全部对齐后再保存',
        tools_alignTiled_page_dialog_1_form_item_label_1: '记忆库名称',
        tools_alignTiled_page_dialog_1_form_item_placeholder_1: '输入新记忆库名或选择已有记忆库',
        tools_alignTiled_page_dialog_1_form_item_label_2: '选择团队',
        tools_alignTiled_page_dialog_1_form_item_placeholder_2: '选择团队',
        tools_alignTiled_page_dialog_1_btn_1: '取消',
        tools_alignTiled_page_dialog_1_btn_2: '保存',
        tools_alignTiled_page_dialog_2_title: '插入',
        tools_alignTiled_page_dialog_2_form_item_label_1: '原文（{lang}）',
        tools_alignTiled_page_dialog_2_form_item_placeholder_1: '输入原文',
        tools_alignTiled_page_dialog_2_form_item_label_2: '译文（{lang}）',
        tools_alignTiled_page_dialog_2_form_item_placeholder_2: '输入译文',
        tools_alignTiled_page_dialog_2_btn_1: '取消',
        tools_alignTiled_page_dialog_2_btn_2: '插入',
        tools_alignTiled_page_dialog_3_title: '查找替换',
        tools_alignTiled_page_dialog_3_tips_1: '查找',
        tools_alignTiled_page_dialog_3_tips_2: '替换为',
        tools_alignTiled_page_dialog_3_tips_3: '当前页{number}/{size1}，共{size2}个',

        tools_alignTiled_page_dialog_3_input_placeholder_1: '输入查找的内容',
        tools_alignTiled_page_dialog_3_input_placeholder_2: '输入替换的内容',
        tools_alignTiled_page_dialog_3_checkbox_1: 'Aa区分大小写',
        tools_alignTiled_page_dialog_3_btn_1: '上一个',
        tools_alignTiled_page_dialog_3_btn_2: '下一个',
        tools_alignTiled_page_dialog_3_btn_3: '替换',
        tools_alignTiled_page_dialog_3_btn_4: '全部替换',

        tools_alignTiled_page_data_hotkeyList_name_1: '撤销',
        tools_alignTiled_page_data_hotkeyList_name_2: '恢复',
        tools_alignTiled_page_data_hotkeyList_name_3: '编辑',
        tools_alignTiled_page_data_hotkeyList_name_4: '插入',
        tools_alignTiled_page_data_hotkeyList_name_5: '拆分',
        tools_alignTiled_page_data_hotkeyList_name_6: '合并',
        tools_alignTiled_page_data_hotkeyList_name_7: '删除',
        tools_alignTiled_page_data_hotkeyList_name_8: '查找替换',
        tools_alignTiled_page_data_hotkeyList_name_9: '跨行选中',
        tools_alignTiled_page_data_hotkeyList_name_10: '批量选中',
        tools_alignTiled_page_data_hotkeyList_key_tips_1: '点选',
        tools_alignTiled_page_data_alertInfo_message: '确定要删除语料吗？',
        tools_alignTiled_page_data_alertInfo_buttonName: '确认删除',
        tools_alignTiled_page_data_cleanUnAlignDialog_buttonName: '确认清洗',
        tools_alignTiled_page_data_submitAllDialog_message: '是否一键将所有句段确认为对齐状态？缺原文或译文的语料不会包括在内',
        tools_alignTiled_page_data_submitAllDialog_buttonName: '确认',
        tools_alignTiled_page_data_sortOptions_value_1: '缺少原文或译文',
        tools_alignTiled_page_data_sortOptions_value_2: '原文或译文重复',
        tools_alignTiled_page_data_sortOptions_value_3: '原文译文相同',
        tools_alignTiled_page_method_saveEditEvent_message_1: '保存成功',
        tools_alignTiled_page_method_saveAddEvent_message_1: '原文不能为空',
        tools_alignTiled_page_method_saveAddEvent_message_2: '译文不能为空',
        tools_alignTiled_page_method_saveAddEvent_message_3: '保存成功',
        tools_alignTiled_page_method_deleteUnAlignBtnEvent_message_1: '已删除未对齐数据',
        tools_alignTiled_page_method_repealBtnEvent_message_1: '已撤销',
        tools_alignTiled_page_method_recoverBtnEvent_message_1: '已恢复',
        tools_alignTiled_page_method_splitColEvent_message_1: '原文/译文必须是编辑状态才能拆分，双击单元格进行编辑。',
        tools_alignTiled_page_method_splitColEvent_message_2: '不支持光标在句首或者句尾拆分',
        tools_alignTiled_page_method_splitColEvent_message_3: '已拆分',
        tools_alignTiled_page_method_mergeColEvent_message_1: '不能合并原文和译文',
        tools_alignTiled_page_method_mergeColEvent_message_2: '已合并',
        tools_alignTiled_page_method_exchangeColEvent_message_1: '对调成功',
        tools_alignTiled_page_method_aligningColEvent_message_1: '原文和译文都不能为空',
        tools_alignTiled_page_method_aligningColEvent_message_2: '已对齐',
        tools_alignTiled_page_method_submitRowAlignBtnEvent_message_1: '原文和译文都不能为空',
        tools_alignTiled_page_method_submitRowAlignBtnEvent_message_2: '已确认对齐',
        tools_alignTiled_page_method_deleteBtnEvent_message_1: '请选择句段',
        tools_alignTiled_page_method_deleteConfirmEvent_message_1: '请选择句段',
        tools_alignTiled_page_method_deleteConfirmEvent_message_2: '已删除',
        tools_alignTiled_page_method_saveToMemEvent_message_1: '请输入或选择记忆库名称',
        tools_alignTiled_page_method_saveToMemEvent_message_2: '已保存到记忆库',
        tools_alignTiled_page_method_submitAllBtnEvent_message_1: '已确认对齐',
        tools_alignTiled_page_method_onContextmenu_item_label_1: '插入 (Ctrl/⌘ + I)',
        tools_alignTiled_page_method_onContextmenu_item_label_2: '编辑 (Ctrl/⌘ + E)',
        tools_alignTiled_page_method_onContextmenu_item_label_3: '合并 (Ctrl/⌘ + M)',
        tools_alignTiled_page_method_onContextmenu_item_label_4: '删除 (Ctrl/⌘ + Delete)',
        tools_alignTiled_page_method_clearFilterAlignResultBtnEvent_message_1: '确定清洗{name}的语料',
        tools_alignTiled_page_method_clearFilterAlignResultBtnEvent_message_2: '仅保留第一条',
        tools_alignTiled_page_method_clearFilterAlignResultBtnEvent_message_3: '？',
        tools_alignTiled_page_method_submitClearFilterAlignResult_message_1: '数据已清理',
        tools_alignTiled_page_method_initFindReplaceData_message_1: '没有查找到对应的记录',
        tools_alignTiled_page_method_prevBtnEvent_message_1: '没有查找到对应的记录',
        tools_alignTiled_page_method_prevBtnEvent_message_2: '当前已经是第一条',
        tools_alignTiled_page_method_nextBtnEvent_message_1: '没有查找到对应的记录',
        tools_alignTiled_page_method_nextBtnEvent_message_2: '当前已经是最后一条',
        tools_alignTiled_page_method_replaceBtnEvent_message_1: '当前已替换到最后一个',
        tools_alignTiled_page_method_replaceAllBtnEvent_message_1: '成功替换{count1}行原文，{count2}行译文，${count3}处文本',
        tools_alignTiled_page_method_saveEditTitleEvent_message_1: '重命名成功',

        tools_detectorIndex_page_btn_1: '双文档',
        tools_detectorIndex_page_btn_2: '单文档',
        tools_detectorIndex_page_btn_3: '刷新',
        tools_detectorIndex_page_input_placeholder_1: '输入名称',
        tools_detectorIndex_page_select_placeholder_1: '排序方式',
        tools_detectorIndex_page_select_option_label_1: '按时间排序',

        tools_detectorIndex_page_tips_1: '没有找到任务～',
        tools_detectorIndex_page_tips_2: '智能标记机翻痕迹，快速识别译文质量风险',
        tools_detectorIndex_page_tips_3: '支持已经对齐的文档，{type}及外部审校格式(docx/doc)',
        tools_detectorIndex_page_tips_4: '查看格式示例',
        tools_detectorIndex_page_tips_5: '，不超过{size}MB',
        tools_detectorIndex_page_tips_6: '按照原文字符消耗流量。如上传双文档，按照原文文档计；如上传段段对照单文档，按照单文档字符计。总字符=原文字符 x 抽样率（0.1~1）x 模型个数',
        tools_detectorIndex_page_tips_7: '流量扣费规则',
        tools_detectorIndex_page_tips_8: '支持尚未对齐的文档，{type}格式，不超过{size}MB',
        tools_detectorIndex_page_tips_9: '按照原文字符消耗流量。如上传双文档，按照原文文档计；如上传段段对照单文档，按照单文档字符计。总字符=原文字符 x 抽样率（0.1~1）x 模型个数',
        tools_detectorIndex_page_tips_10: '上传文档',
        tools_detectorIndex_page_tips_11: '上传原文',
        tools_detectorIndex_page_tips_12: '上传译文',
        tools_detectorIndex_page_tips_13: '点击切换',
        tools_detectorIndex_page_tips_14: '检测设置',
        tools_detectorIndex_page_dialog_1_title: '机翻检测',
        tools_detectorIndex_page_dialog_1_form_item_label_1: '抽检量',
        tools_detectorIndex_page_dialog_1_select_placeholder_1: '选择抽检量',
        tools_detectorIndex_page_dialog_1_form_item_label_2: '过滤短句',
        tools_detectorIndex_page_dialog_1_select_placeholder_2: '选择过滤项',
        tools_detectorIndex_page_dialog_1_option_label_1: '{size}个字以下',
        tools_detectorIndex_page_dialog_1_tips_1: '随机抽取的句段数',
        tools_detectorIndex_page_dialog_1_tips_2: '过滤原文过短的句段',
        tools_detectorIndex_page_dialog_1_btn_1: '取消',
        tools_detectorIndex_page_dialog_1_btn_2: '检测',
        tools_detectorIndex_page_data_alertInfo_message: '确定要删除这个任务吗？',
        tools_detectorIndex_page_data_alertInfo_buttonName: '确认删除',
        tools_detectorIndex_page_data_typeRadioOptions_name_1: '已对齐',
        tools_detectorIndex_page_data_typeRadioOptions_name_2: '未对齐',
        tools_detectorIndex_page_method_startTaskEvent_message_1: '请上传文档',
        tools_detectorIndex_page_method_startTaskEvent_message_2: '请上传原文',
        tools_detectorIndex_page_method_startTaskEvent_message_3: '请上传译文',
        tools_detectorIndex_page_method_startTaskEvent_message_4: '请选择模型',
        tools_detectorIndex_page_method_startTaskEvent_message_5: '任务已开始执行',
        tools_detectorIndex_page_method_deleteTask_message_1: '任务已删除',

        tools_detectorDetail_page_tips_1: '相似度',
        tools_detectorDetail_page_tips_2: '重试',
        tools_detectorDetail_page_select_placeholder_1: '请选择',
        tools_detectorDetail_page_btn_1: '下载报告',
        tools_detectorDetail_page_table_column_label_1: '序号',
        tools_detectorDetail_page_table_column_label_2: '原文（{lang}）',
        tools_detectorDetail_page_table_column_label_3: '译文（{lang}）',
        tools_detectorDetail_page_table_column_label_4: '相似度',
        tools_detectorDetail_page_table_column_label_5: '{name}翻译',
        tools_detectorDetail_page_data_filterOptions_name_1: '79%以下',
        tools_detectorDetail_page_data_filterOptions_name_2: '80%-89%',
        tools_detectorDetail_page_data_filterOptions_name_3: '90%-99%',
        tools_detectorDetail_page_data_filterOptions_name_4: '100%',
        tools_detectorDetail_page_method_engineItemClick_message_1: '当前模型检测失败',
        tools_detectorDetail_page_method_engineItemClick_message_2: '当前模型检测中，请稍后',
        tools_detectorDetail_page_method_retryBtnClick_message_1: '已重试',

        tools_gptTranslate_page_tips_1: '项目历史',
        tools_gptTranslate_page_tips_2: '基于大模型非译元素处理/术语统一/低错检查的智能体本地化协作流程',
        tools_gptTranslate_page_tips_3: '共',
        tools_gptTranslate_page_tips_4: '个文件，',
        tools_gptTranslate_page_tips_5: '字',
        tools_gptTranslate_page_tips_6: '预计消耗',
        tools_gptTranslate_page_tips_7: 'token，点击开始翻译，智能体就开工啦',
        tools_gptTranslate_page_tips_8: 'Token 统计中，请稍后',
        tools_gptTranslate_page_tips_9: '拖拽或点击上传文件',
        tools_gptTranslate_page_tips_10: '智能体使用前请购买Token',
        tools_gptTranslate_page_tips_11: '去购买',
        tools_gptTranslate_page_tips_12: '源语言',
        tools_gptTranslate_page_tips_13: '目标语言',
        tools_gptTranslate_page_tips_14: '术语表',
        tools_gptTranslate_page_tips_15: '清除术语表',
        tools_gptTranslate_page_tips_16: '{size} 文件',
        tools_gptTranslate_page_tips_17: '{size} 字',
        tools_gptTranslate_page_tips_18: '进度',
        tools_gptTranslate_page_tips_19: '下载译文',
        tools_gptTranslate_page_tips_20: '下载双语',
        tools_gptTranslate_page_tips_21: '删除',
        tools_gptTranslate_page_tips_22: '重试',
        tools_gptTranslate_page_tips_23: '充值',
        tools_gptTranslate_page_tips_24: '当前文件：',
        tools_gptTranslate_page_tips_25: '可输入关键词搜索',
        tools_gptTranslate_page_tips_26: '交换源语言和目标语言',

        tools_gptTranslate_page_dialog_1_title: '上传术语表',
        tools_gptTranslate_page_dialog_1_tips_1: '支持{type}，最多10个文件，单文件最大{size}M。下载模版：',
        tools_gptTranslate_page_dialog_1_btn_1: '取消',
        tools_gptTranslate_page_dialog_1_btn_2: '确定',

        tools_gptTranslate_page_dialog_2_title: '上传记忆库',
        tools_gptTranslate_page_dialog_2_tips_1: '支持{type}，最多10个文件，单文件最大{size}M。下载模版：',
        tools_gptTranslate_page_dialog_2_btn_1: '取消',
        tools_gptTranslate_page_dialog_2_btn_2: '确定',

        tools_gptTranslate_page_select_placeholder_1: '选择语言',
        tools_gptTranslate_page_btn_1: '上传术语表',
        tools_gptTranslate_page_btn_2: '继续上传文件',
        tools_gptTranslate_page_btn_3: '上一步',
        tools_gptTranslate_page_btn_4: '下一步',
        tools_gptTranslate_page_btn_5: '开始翻译',

        tools_gptTranslate_page_data_uploadFileMessage: '支持{type}格式的文件',
        tools_gptTranslate_page_data_alertInfo_cancelButtonName: '取消',
        tools_gptTranslate_page_method_nextBtnEvent_message_1: '请上传文件',
        tools_gptTranslate_page_method_initTaskList_message_1: 'token不足，请充值后重试',
        tools_gptTranslate_page_method_createTask_message_1: '请上传文件',
        tools_gptTranslate_page_method_pollingTaskTokenInfo_message_1: '文件解析失败，请重新上传',
        tools_gptTranslate_page_method_deleteTask_message_1: '确定删除该任务吗？',
        tools_gptTranslate_page_method_deleteTaskEvent_message_1: '删除成功',

        tools_gptTranslateHistory_page_tips_1: '项目历史',
        tools_gptTranslateHistory_page_tips_2: '下载译文',
        tools_gptTranslateHistory_page_tips_3: '下载双语',
        tools_gptTranslateHistory_page_tips_4: '批量删除',
        tools_gptTranslateHistory_page_tips_5: '下载译文',
        tools_gptTranslateHistory_page_tips_6: '下载双语',
        tools_gptTranslateHistory_page_tips_7: '重试',
        tools_gptTranslateHistory_page_tips_8: '删除文件',
        tools_gptTranslateHistory_page_btn_1: '刷新',
        tools_gptTranslateHistory_page_btn_2: '充值',

        tools_gptTranslateHistory_page_input_placeholder_1: '输入文件名',
        tools_gptTranslateHistory_page_table_column_1: '文件名',
        tools_gptTranslateHistory_page_table_column_2: '文件数',
        tools_gptTranslateHistory_page_table_column_3: '语言方向',
        tools_gptTranslateHistory_page_table_column_4: 'Token数',
        tools_gptTranslateHistory_page_table_column_5: '状态',
        tools_gptTranslateHistory_page_table_column_6: '进度',
        tools_gptTranslateHistory_page_table_column_7: '上传时间',
        tools_gptTranslateHistory_page_table_column_8: '操作',

        tools_gptTranslateHistory_page_data_alertInfo_message: '确定要删除文件吗？',
        tools_gptTranslateHistory_page_data_alertInfo_cancelButtonName: '确认删除',
        tools_gptTranslateHistory_page_method_handleFileReset_message_1: 'token不足，请充值后重试',
        tools_gptTranslateHistory_page_method_batchDownloadBtnEvent_message_1: '请先选择要下载的项目',
        tools_gptTranslateHistory_page_method_batchDownloadBtnEvent_message_2: '项目导出{size}个',
        tools_gptTranslateHistory_page_method_batchDeleteBtnEvent_message_1: '请先选择要删除的项目',
        tools_gptTranslateHistory_page_method_deleteProject_message_1: '删除成功',

        tools_polishIndex_page_tips_1: '文本',
        tools_polishIndex_page_tips_2: '文档',
        tools_polishIndex_page_tips_3: '粘贴文本',
        tools_polishIndex_page_tips_4: '{size1}/{size2}字符',
        tools_polishIndex_page_tips_5: '润色单语文档',
        tools_polishIndex_page_tips_5_1: '可上传doc/docx/ppt/pptx文件，大小20M以内',
        tools_polishIndex_page_tips_6: '上传文件',
        tools_polishIndex_page_tips_7: '流量不足',
        tools_polishIndex_page_tips_8: '已终止',
        tools_polishIndex_page_tips_9: '润色失败',
        tools_polishIndex_page_tips_10: '润色完成',
        tools_polishIndex_page_tips_11: '任务已终止，流量不扣除',
        tools_polishIndex_page_tips_12: '流量已扣除，请耐心等待，勿刷新页面',
        tools_polishIndex_page_tips_13: '润色完成后自动下载，如未自动下载，请',
        tools_polishIndex_page_tips_14: '手动下载',
        tools_polishIndex_page_tips_15: '润色语言',
        tools_polishIndex_page_tips_16: '检测到{name}',
        tools_polishIndex_page_tips_17: '自动识别',
        tools_polishIndex_page_tips_18: '润色模型',
        tools_polishIndex_page_tips_19: '文本长度',
        tools_polishIndex_page_tips_20: '润色风格',
        tools_polishIndex_page_tips_21: '自定义要求',
        tools_polishIndex_page_tips_22: 'AI 润色',
        tools_polishIndex_page_tips_23: '收起列表',
        tools_polishIndex_page_tips_24: '展开列表',
        tools_polishIndex_page_tips_25: '润色成功',
        tools_polishIndex_page_tips_26: '润色失败',
        tools_polishIndex_page_tips_27: '去购买',
        tools_polishIndex_page_tips_28: '流量不足',
        tools_polishIndex_page_tips_29: '下载',
        tools_polishIndex_page_tips_30: '删除',
        tools_polishIndex_page_btn_1: '开始润色',
        tools_polishIndex_page_btn_2: '购买字符包',
        tools_polishIndex_page_btn_3: '重试',
        tools_polishIndex_page_btn_4: '终止',
        tools_polishIndex_page_btn_5: '重新润色',
        tools_polishIndex_page_btn_6: '复制',
        tools_polishIndex_page_input_placeholder_1: '粘贴需要润色的文本',
        tools_polishIndex_page_select_placeholder_2: '选择润色语言',
        tools_polishIndex_page_select_placeholder_3: '选择模型',
        tools_polishIndex_page_select_placeholder_4: '选择文本长度',
        tools_polishIndex_page_select_placeholder_5: '选择润色风格',
        tools_polishIndex_page_input_placeholder_1: '+新增自定义，回车确认',
        tools_polishIndex_page_data_form_customStyle_1: '母语化表达',
        tools_polishIndex_page_data_systemStyleOptions_1: '母语化表达',
        tools_polishIndex_page_data_systemStyleOptions_2: '游戏领域',
        tools_polishIndex_page_data_systemStyleOptions_3: '学术论文',
        tools_polishIndex_page_data_systemStyleOptions_4: '正式邮件',
        tools_polishIndex_page_data_systemStyleOptions_5: '时政外宣',
        tools_polishIndex_page_data_systemStyleOptions_6: '法律法规（合同）',
        tools_polishIndex_page_data_btnName: '润色一下',
        tools_polishIndex_page_data_alertInfo_cancelButtonName: '再等等',
        tools_polishIndex_page_created_languageList_name_1: '英语',
        tools_polishIndex_page_created_languageList_shortName_1: '英',
        tools_polishIndex_page_created_languageList_name_2: '中文（简体）',
        tools_polishIndex_page_created_languageList_shortName_2: '中',
        tools_polishIndex_page_created_languageList_name_3: '俄语',
        tools_polishIndex_page_created_languageList_shortName_3: '俄',
        tools_polishIndex_page_created_languageList_name_4: '法语',
        tools_polishIndex_page_created_languageList_shortName_4: '法',
        tools_polishIndex_page_created_languageList_name_5: '德语',
        tools_polishIndex_page_created_languageList_shortName_5: '德',
        tools_polishIndex_page_created_languageList_name_6: '西班牙语',
        tools_polishIndex_page_created_languageList_shortName_6: '西',
        tools_polishIndex_page_created_languageList_name_7: '葡萄牙语',
        tools_polishIndex_page_created_languageList_shortName_7: '葡',
        tools_polishIndex_page_created_languageList_name_8: '阿拉伯语',
        tools_polishIndex_page_created_languageList_shortName_8: '阿',
        tools_polishIndex_page_created_languageList_name_9: '日语',
        tools_polishIndex_page_created_languageList_shortName_9: '日',
        tools_polishIndex_page_created_languageList_name_10: '韩语',
        tools_polishIndex_page_created_languageList_shortName_10: '韩',
        tools_polishIndex_page_created_languageList_name_11: '印尼语',
        tools_polishIndex_page_created_languageList_shortName_11: '印尼',
        tools_polishIndex_page_method_createPolishTask_message_1: '请输入要润色的文本',
        tools_polishIndex_page_method_createPolishTask_message_2: '文本长度不能小于10个字符',
        tools_polishIndex_page_method_pollingTxtPolishResult_message_1: '流量不足，<a href="/account/vip?view=char" target="_blank">去购买</a>',
        tools_polishIndex_page_method_clearTextInput_btnName: '润色一下',
        tools_polishIndex_page_method_addStyle_message_1: '自定义风格已存在',
        tools_polishIndex_page_method_copyResult_message_1: '已复制到剪切板',
        tools_polishIndex_page_method_copyResult_message_2: '复制到剪切板失败，请重试',
        tools_polishIndex_page_method_closeUploadDocumentBtnEvent_message_1: '确定要取消正在润色中的文档吗？',
        tools_polishIndex_page_method_closeUploadDocumentBtnEvent_message_2: '确定要取消正在润色中的文档吗？任务已发送给AI，取消后流量不返还。',
        tools_polishIndex_page_method_stopFilePolishBtnEvent_message_1: '确定要终止正在润色中的文档吗？',
        tools_polishIndex_page_method_stopFilePolish_message_1: '润色已终止',
        tools_polishIndex_page_method_restartFilePolish_message_1: '重试成功',
        tools_polishIndex_page_method_deleteTask_message_1: '确定删除该任务吗？',
        tools_polishIndex_page_method_deleteTask_cancelButtonName_1: '取消',
        tools_polishIndex_page_method_deleteTaskEvent_message_1: '删除成功',
        tools_polishIndex_page_method_beforeRouteLeave_message_1: '确认离开吗？现在离开当前润色任务将终止。如需访问其他功能请返回原标签页。',
        tools_polishIndex_page_method_beforeRouteLeave_message_2: '提示',
        tools_polishIndex_page_method_beforeRouteLeave_confirmButtonText: '离开',
        tools_polishIndex_page_method_beforeRouteLeave_cancelButtonText: '取消',

        tools_qaIndex_page_btn_1: '双文档',
        tools_qaIndex_page_btn_2: '单文档',
        tools_qaIndex_page_btn_3: '刷新',
        tools_qaIndex_page_input_placeholder_1: '输入名称',
        tools_qaIndex_page_select_placeholder_2: '排序方式',
        tools_qaIndex_page_select_option_label_1: '按时间排序',

        tools_qaIndex_page_tips_1: '没有找到任务～',
        tools_qaIndex_page_tips_2: '不止于规则，更有基于语义理解的智能检查',
        tools_qaIndex_page_dialog_1_title: 'QA检查',
        tools_qaIndex_page_dialog_1_tips_1: '支持已经对齐的文档，{type}及外部审校格式(docx/doc)',
        tools_qaIndex_page_dialog_1_tips_2: '查看格式示例',
        tools_qaIndex_page_dialog_1_tips_3: '，不超过{size}MB',
        tools_qaIndex_page_dialog_1_tips_4: '按照原文字符消耗流量。如上传双文档，按照原文文档计；如上传段段对照单文档，按照单文档字符计。',
        tools_qaIndex_page_dialog_1_tips_5: '流量扣费规则',
        tools_qaIndex_page_dialog_1_tips_6: '支持尚未对齐的文档，{type}格式，不超过{size}MB',
        tools_qaIndex_page_dialog_1_tips_7: '上传文档',
        tools_qaIndex_page_dialog_1_tips_8: '上传原文',
        tools_qaIndex_page_dialog_1_tips_9: '上传译文',
        tools_qaIndex_page_dialog_1_tips_10: '点击切换',
        tools_qaIndex_page_dialog_1_tips_11: '若想检查术语不一致，上传术语表(支持{type}格式)',
        tools_qaIndex_page_dialog_1_tips_12: 'QA设置',
        tools_qaIndex_page_dialog_1_tips_13: '规则QA设置',
        tools_qaIndex_page_dialog_1_tips_14: '智能QA设置',
        
        tools_qaIndex_page_dialog_1_checkbox_1: '全选',
        
        tools_qaIndex_page_dialog_1_btn_1: '上传术语表',
        tools_qaIndex_page_dialog_1_btn_2: '取消',
        tools_qaIndex_page_dialog_1_btn_3: 'QA检查',
        tools_qaIndex_page_data_alertInfo_message: '确定要删除这个任务吗？',
        tools_qaIndex_page_data_alertInfo_buttonName: '确认删除',
        tools_qaIndex_page_data_typeRadioOptions_name_1: '已对齐',
        tools_qaIndex_page_data_typeRadioOptions_name_2: '未对齐',
        tools_qaIndex_page_method_startTaskEvent_message_1: '请上传文档',
        tools_qaIndex_page_method_startTaskEvent_message_2: '请上传原文',
        tools_qaIndex_page_method_startTaskEvent_message_3: '请上传译文',
        tools_qaIndex_page_method_startTaskEvent_message_4: '请选择检查项',
        tools_qaIndex_page_method_startTaskEvent_message_5: '任务已开始执行',
        tools_qaIndex_page_method_deleteTask_message_1: '任务已删除',

        tools_qaDetail_page_form_item_label_1: '语言方向',
        tools_qaDetail_page_form_item_label_2: '条数',
        tools_qaDetail_page_form_item_label_3: '创建时间',
        tools_qaDetail_page_tips_1: '条',
        tools_qaDetail_page_tips_2: '共检查出',
        tools_qaDetail_page_tips_3: '处疑似错误',
        tools_qaDetail_page_tips_4: 'QA报告只展示有质量问题的句段',
        tools_qaDetail_page_input_placeholder_1: '输入关键词',
        tools_qaDetail_page_btn_1: '下载',
        tools_qaDetail_page_table_column_label_1: '序号',
        tools_qaDetail_page_table_column_label_2: '原文（{lang}）',
        tools_qaDetail_page_table_column_label_3: '译文（{lang}）',
        tools_qaDetail_page_table_column_label_4: 'QA结果',

        tools_qaDetailNew_page_form_item_label_1: '语言方向',
        tools_qaDetailNew_page_form_item_label_2: '问题数',
        tools_qaDetailNew_page_form_item_label_3: '创建时间',
        tools_qaDetailNew_page_tips_1: '处',
        tools_qaDetailNew_page_tips_2: '导出全部',
        tools_qaDetailNew_page_tips_3: '仅标记部分',
        tools_qaDetailNew_page_tips_4: '仅无标记部分',
        tools_qaDetailNew_page_tips_5: '共检查出',
        tools_qaDetailNew_page_tips_6: '处疑似错误，QA报告只展示有质量问题的句段',
        tools_qaDetailNew_page_tips_7: '规则检查失败',
        tools_qaDetailNew_page_tips_8: '智能检查失败',
        tools_qaDetailNew_page_tips_9: '全部标记',
        tools_qaDetailNew_page_tips_10: '全部取消标记',
        tools_qaDetailNew_page_tips_11: '暂无错误信息',
        tools_qaDetailNew_page_table_column_label_1: '原句段位置',
        tools_qaDetailNew_page_table_column_label_2: '原文（{lang}）',
        tools_qaDetailNew_page_table_column_label_3: '译文（{lang}）',
        tools_qaDetailNew_page_table_column_label_4: 'QA',
        tools_qaDetailNew_page_table_column_label_5: '标记',
        tools_qaDetailNew_page_table_column_label_6: '原句段位置',
        tools_qaDetailNew_page_table_column_label_7: '原文(中文)',
        tools_qaDetailNew_page_table_column_label_8: '译文(英文)',
        tools_qaDetailNew_page_table_column_label_9: 'QA',
        tools_qaDetailNew_page_table_column_label_10: '标记',
        tools_qaDetailNew_page_select_placeholder_1: '选择筛选条件',
        tools_qaDetailNew_page_select_option_lable_1: '仅显示标记句段',
        tools_qaDetailNew_page_select_option_lable_2: '仅显示无标记句段',
        tools_qaDetailNew_page_btn_1: '导出报告',

        tools_termExtractionIndex_page_btn_1: '双语文档',
        tools_termExtractionIndex_page_btn_2: '单语文档',
        tools_termExtractionIndex_page_btn_3: '刷新',
        tools_termExtractionIndex_page_input_placeholder_1: '输入名称',
        tools_termExtractionIndex_page_select_placeholder_1: '排序方式',
        tools_termExtractionIndex_page_select_option_1: '按时间排序',
        tools_termExtractionIndex_page_tips_1: '没有找到任务～',
        tools_termExtractionIndex_page_tips_2: '一键智能提取术语，并提供初始翻译',
        tools_termExtractionIndex_page_dialog_1_title: '{type}术语提取',
        tools_termExtractionIndex_page_dialog_1_tips_1: '支持{name}{type}格式，单个文件最大{size}MB',
        tools_termExtractionIndex_page_dialog_1_tips_2: '按照原文字符消耗流量。如上传双文档，按照原文文档计；如上传段段对照单文档，按照单文档字符计。',
        tools_termExtractionIndex_page_dialog_1_tips_3: '流量扣费规则',
        tools_termExtractionIndex_page_dialog_1_tips_4: '上传原文',
        tools_termExtractionIndex_page_dialog_1_tips_5: '上传文档',
        tools_termExtractionIndex_page_dialog_1_tips_6: '上传译文',
        tools_termExtractionIndex_page_dialog_1_btn_1: '取消',
        tools_termExtractionIndex_page_dialog_1_btn_2: '术语提取',
        tools_termExtractionIndex_page_data_alertInfo_message: '确定要删除这个任务吗？',
        tools_termExtractionIndex_page_data_alertInfo_buttonName: '确认删除',
        tools_termExtractionIndex_page_data_typeRadioOptions_name_1: '双文档',
        tools_termExtractionIndex_page_data_typeRadioOptions_name_2: '单文档',
        tools_termExtractionIndex_page_method_startTaskEvent_message_1: '请上传原文',
        tools_termExtractionIndex_page_method_startTaskEvent_message_2: '请上传文档',
        tools_termExtractionIndex_page_method_startTaskEvent_message_3: '请上传译文',
        tools_termExtractionIndex_page_method_startTaskEvent_message_4: '任务已开始执行',
        tools_termExtractionIndex_page_method_deleteTask_message_1: '任务已删除',

        tools_termExtractionDetail_page_form_item_label_1: '语言方向',
        tools_termExtractionDetail_page_form_item_label_2: '条数',
        tools_termExtractionDetail_page_form_item_label_3: '创建时间',
        tools_termExtractionDetail_page_input_placeholder_1: '输入关键词',
        tools_termExtractionDetail_page_input_placeholder_2: '输入原文',
        tools_termExtractionDetail_page_input_placeholder_3: '输入译文',
        tools_termExtractionDetail_page_input_placeholder_4: '输入备注',

        tools_termExtractionDetail_page_tips_1: '条',
        tools_termExtractionDetail_page_tips_2: '下载Excel',
        tools_termExtractionDetail_page_tips_3: '下载TBX',
        tools_termExtractionDetail_page_tips_4: '提取到 {count} 个术语，请修改和确认',
        tools_termExtractionDetail_page_tips_5: '术语在原文中出现的频率',
        tools_termExtractionDetail_page_tips_6: '确认',
        tools_termExtractionDetail_page_tips_7: '删除',
        tools_termExtractionDetail_page_tips_8: '编辑',
        tools_termExtractionDetail_page_tips_9: '保存',

        tools_termExtractionDetail_page_btn_1: '批量确认',
        tools_termExtractionDetail_page_btn_2: '删除',
        tools_termExtractionDetail_page_btn_3: '保存到术语库',
        tools_termExtractionDetail_page_btn_4: '下载',

        tools_termExtractionDetail_page_table_column_label_1: '序号',
        tools_termExtractionDetail_page_table_column_label_2: '词频',
        tools_termExtractionDetail_page_table_column_label_3: '原文（{lang}）',
        tools_termExtractionDetail_page_table_column_label_4: '译文（{lang}）',
        tools_termExtractionDetail_page_table_column_label_5: '备注',
        tools_termExtractionDetail_page_table_column_label_6: '操作',
        tools_termExtractionDetail_page_dialog_1_title: '保存到术语库',
        tools_termExtractionDetail_page_dialog_1_tips_1: '该操作只保存已确认的术语',
        tools_termExtractionDetail_page_dialog_1_form_item_label_1: '术语库名称',
        tools_termExtractionDetail_page_dialog_1_form_item_label_2: '选择团队',
        tools_termExtractionDetail_page_dialog_1_input_placeholder_1: '输入新术语库名或选择已有术语库',
        tools_termExtractionDetail_page_dialog_1_input_placeholder_2: '选择团队',
        tools_termExtractionDetail_page_dialog_1_btn_1: '取消',
        tools_termExtractionDetail_page_dialog_1_btn_2: '保存',
        tools_termExtractionDetail_page_data_alertInfo_message: '确定要删除术语吗？',
        tools_termExtractionDetail_page_data_alertInfo_buttonName: '确认删除',
        tools_termExtractionDetail_page_data_batchAlertInfo_message: '是否确认本页全部术语？确认后你仍可以单个编辑修改',
        tools_termExtractionDetail_page_data_batchAlertInfo_buttonName: '确认',
        tools_termExtractionDetail_page_method_saveEditEvent_message_1: '原文不能为空',
        tools_termExtractionDetail_page_method_saveEditEvent_message_2: '译文不能为空',
        tools_termExtractionDetail_page_method_saveEditEvent_message_3: '保存成功',
        tools_termExtractionDetail_page_method_saveAddEvent_message_1: '原文不能为空',
        tools_termExtractionDetail_page_method_saveAddEvent_message_2: '译文不能为空',
        tools_termExtractionDetail_page_method_saveAddEvent_message_3: '保存成功',
        tools_termExtractionDetail_page_method_bathSaveEvent_message_1: '已批量确认本页术语',
        tools_termExtractionDetail_page_method_deleteConfirmEvent_message_1: '已删除',
        tools_termExtractionDetail_page_method_saveToTermEvent_message_1: '请输入或选择术语库名称',
        tools_termExtractionDetail_page_method_saveToTermEvent_message_2: '已保存到术语库',

        tools_translationScoreIndex_page_tips_1: '术语定制',
        tools_translationScoreIndex_page_tips_2: '你可以配置自己的常用模型',
        tools_translationScoreIndex_page_tips_3: '批量翻译',
        tools_translationScoreIndex_page_tips_4: '查看模型详情',
        tools_translationScoreIndex_page_tips_5: '粘贴一段文字，快速对比不同模型翻译结果，每次最多2000字',
        tools_translationScoreIndex_page_tips_6: '换一换',
        tools_translationScoreIndex_page_tips_7: '试一试样例',
        tools_translationScoreIndex_page_tips_8: 'AI质量评估',
        tools_translationScoreIndex_page_tips_9: '展示差异',
        tools_translationScoreIndex_page_tips_10: '清空历史记录',
        tools_translationScoreIndex_page_tips_11: '{score}分',
        tools_translationScoreIndex_page_tips_12: '再次润色',
        tools_translationScoreIndex_page_tips_13: '润色',
        tools_translationScoreIndex_page_tips_14: '翻译中，请稍等',
        tools_translationScoreIndex_page_tips_15: '润色',

        tools_translationScoreIndex_page_btn_1: '关闭',
        tools_translationScoreIndex_page_btn_2: '开始配置',
        tools_translationScoreIndex_page_btn_3: '配置模型',
        tools_translationScoreIndex_page_btn_4: '复制',

        tools_translationScoreIndex_page_data_domainList_name_1: '常用模型',
        tools_translationScoreIndex_page_data_domainList_name_2: '大模型翻译',
        tools_translationScoreIndex_page_data_domainList_name_3: 'NMT机器翻译',
        tools_translationScoreIndex_page_data_domainList_name_4: '个性化机器翻译',

        tools_translationScoreIndex_page_method_startTranslateText_message_1: '请选择翻译模型',
        tools_translationScoreIndex_page_method_startTranslateText_message_2: '流量不足，<a href="/account/vip?view=char" target="_blank">去购买</a>',
        tools_translationScoreIndex_page_method_showTermSettingEvent_message_1: '请选择源语言',
        tools_translationScoreIndex_page_method_setUserConfig_message_1: '术语定制已开启',
        tools_translationScoreIndex_page_method_setUserConfig_message_2: '术语定制已关闭',
        tools_translationScoreIndex_page_method_engineClickEvent_message_1: '个性模型因会员到期已下架，续订后会恢复服务~',
        tools_translationScoreIndex_page_method_engineClickEvent_message_2: 'Pro版专属模型，升级为Pro版可用。<a href="/account/vip">去升级</a>',
        tools_translationScoreIndex_page_method_polishHistoryItem_message_1: '最多润色{count}次',
        tools_translationScoreIndex_page_method_copyHistoryItem_message_1: '已复制到剪切板',
        tools_translationScoreIndex_page_method_copyHistoryItem_message_2: '复制到剪切板失败，请重试',

        tools_videoTranslateIndex_page_tips_1: '视频时长：{duration}',
        tools_videoTranslateIndex_page_tips_2: '上传视频进行一键多语种翻译及重新配音，剩余点数：{size}',
        tools_videoTranslateIndex_page_tips_3: '请确保视频没有侵犯他人肖像权，使用者承诺承担法律责任。',
        tools_videoTranslateIndex_page_tips_4: '进入校对',
        tools_videoTranslateIndex_page_tips_5: '唇形同步已开启',
        tools_videoTranslateIndex_page_tips_6: ' 唇形同步已关闭',
        tools_videoTranslateIndex_page_tips_7: '翻译成功',
        tools_videoTranslateIndex_page_tips_8: '翻译失败',
        tools_videoTranslateIndex_page_tips_9: '待校对',
        tools_videoTranslateIndex_page_tips_10: '下载',
        tools_videoTranslateIndex_page_tips_11: '删除',

        tools_videoTranslateIndex_page_btn_1: '开始翻译',
        tools_videoTranslateIndex_page_btn_2: '上传视频',
        tools_videoTranslateIndex_page_btn_3: '收起列表',
        tools_videoTranslateIndex_page_btn_4: '展开列表',

        tools_videoTranslateIndex_page_dialog_1_title: 'AI译配',
        tools_videoTranslateIndex_page_dialog_1_tips_1: '可对照原文，选择多语言AI大模型对译文进行编辑、修改、润色，使翻译文本更加精准！',
        tools_videoTranslateIndex_page_dialog_1_tips_2: '*额外消耗1点数',
        tools_videoTranslateIndex_page_dialog_1_tips_3: '上传视频',
        tools_videoTranslateIndex_page_dialog_1_tips_4: '支持MP4格式，{minute}分钟，{size}MB以内',
        tools_videoTranslateIndex_page_dialog_1_tips_5: '源语言',
        tools_videoTranslateIndex_page_dialog_1_tips_6: '目标语言',
        tools_videoTranslateIndex_page_dialog_1_tips_7: '唇形同步',
        tools_videoTranslateIndex_page_dialog_1_tips_8: '开启唇形同步后，说话人的唇形会替换为目标语的唇形，适用于解说或画面人物较大的镜头，处理时间约为非唇形模式的2倍。',
        tools_videoTranslateIndex_page_dialog_1_tips_9: '*额外消耗1次次数',
        tools_videoTranslateIndex_page_dialog_1_tips_10: '译后字幕',
        tools_videoTranslateIndex_page_dialog_1_tips_11: '模型选择',
        tools_videoTranslateIndex_page_dialog_1_tips_12: '共消耗点数：',
        tools_videoTranslateIndex_page_dialog_1_tips_13: '当前剩余点数：{size}',
        tools_videoTranslateIndex_page_dialog_1_select_placeholder_1: '选择润色语言',
        tools_videoTranslateIndex_page_dialog_1_btn_1: '取消',
        tools_videoTranslateIndex_page_dialog_1_btn_2: '开始翻译',
        tools_videoTranslateIndex_page_dialog_2_btn_1: '下载',
        tools_videoTranslateIndex_page_data_alertInfo_cancelButtonName: '取消',
        tools_videoTranslateIndex_page_data_typeRadioOptions_name_1: 'AI一键翻译',
        tools_videoTranslateIndex_page_data_typeRadioOptions_name_2: '人工校对翻译',
        tools_videoTranslateIndex_page_method_createTask_message_1: '请上传视频文件',
        tools_videoTranslateIndex_page_method_uploadFileSuccess_message_1: '视频时长超过限制',
        tools_videoTranslateIndex_page_method_deleteTask_message_1: '确定删除该任务吗？',
        tools_videoTranslateIndex_page_method_deleteTaskEvent_message_1: '删除成功',

        tools_videoEditer_page_tips_1: '自动保存中',
        tools_videoEditer_page_tips_2: '已保存',
        tools_videoEditer_page_tips_3: '序号',
        tools_videoEditer_page_tips_4: '原文（{lang}）',
        tools_videoEditer_page_tips_5: '译文（{lang}）',
        tools_videoEditer_page_tips_6: '译文可进行编辑，编辑文本需根据时间段长度修改字数，<br/>过长或过短会导致生成视频的配音或快或过慢。',
        tools_videoEditer_page_tips_7: '原视频',
        tools_videoEditer_page_tips_8: '确认已完成文本校对，开始配音和合成视频？',
        tools_videoEditer_page_tips_9: '合成视频',
        tools_videoEditer_page_method_startTranslation_message_1: '确认译文成功，1s后返回列表页',
        tools_videoEditer_page_method_cancelTranslation_message_1: '取消翻译操作',


        tools_videoEditer_page_btn_1: '合成视频',



        component_AccountTypes_tips_1: '企业版',
        component_Tabs_tab_name_1: '语料对齐',
        component_Tabs_tab_name_2: '术语提取',
        component_Tabs_tab_name_3: 'QA检查',
        component_Tabs_tab_name_4: '机翻检测器',

        component_EngineConfig_dialog_title: '添加常用模型',
        component_EngineConfig_dialog_tips_1: '最多支持{size}个常用模型',
        component_EngineConfig_dialog_btn_1: '取消',
        component_EngineConfig_dialog_btn_2: '确定',
        component_EngineConfig_method_selectEngine_message_1: '最多支持{size}个常用模型',
        component_EngineConfig_method_submitBtnEvent_message_1: '请选择常用模型',
        component_EngineConfig_method_submitBtnEvent_message_2:  '最多支持{size}个常用模型',
        component_EngineConfig_method_submitBtnEvent_message_3: '保存成功',
        component_CardList_tips_1: '查看',
        component_CardList_tips_2: '下载Excel',
        component_CardList_tips_3: '下载TMX',
        component_CardList_tips_4: '重命名',
        component_CardList_tips_5: '删除',
        component_CardList_tips_6: '下载TBX',
        component_CardList_tips_7: '任务失败：检测到流量不足',
        component_CardList_tips_8: '原文和译文的段落差异较大',
        component_CardList_tips_9: '建议检查文档再开始对齐',
        component_CardList_tips_10: '任务中止',
        component_CardList_tips_11: '删除',
        component_CardList_tips_12: '继续',
        component_CardList_tips_13: '购买字符包',
        component_CardList_tips_14: '重试',
        component_CardList_tips_15: '单份文件句段数不超过{size1}句,原文件总计句段{ {size2} }句,建议手动拆分为{ {size3} }份再上传',
        component_CardList_tips_16: '购买成功后，回到此页面点击重试',
        component_CardList_tips_17: '详情',
        component_CardList_tips_18: '任务失败',
        component_CardList_dialog_1_title: '重命名',
        component_CardList_dialog_1_form_item_1: '名称',
        component_CardList_dialog_1_input_placeholder_1: '输入名称',
        component_CardList_dialog_1_btn_1: '取消',
        component_CardList_dialog_1_btn_2: '保存',
        component_CardList_method_restartBtnEvent_message_1: '重试成功',
        component_CardList_method_saveRenameBtnEvent_message_1: '请输入名称',
        component_CardList_method_saveRenameBtnEvent_message_2: '重命名成功',

    },
    system: {
        slogan: '多模态多智能体平台',

        basic_left_tagline_1: 'Y魔方：丰富的多语言本地化工具集',
        basic_left_tagline_2: '视频智能体：一键翻译视频和配音的魔法',
        basic_left_tagline_3: '文档智能体：大模型驱动的文档本地化流程',

        login_page_service_terms: '服务协议',
        login_page_privacy_policy: '隐私政策',

        login_page_title: '用户登录',
        login_page_form_title: 'LOGIN',
        login_page_tab_phone: '手机号',
        login_page_tab_account: '邮箱/用户名',
        login_page_form_phone_placeholder: '手机号',
        login_page_form_account_placeholder: '邮箱/用户名',
        login_page_form_password_placeholder: '密码',
        login_page_form_button: '登录',
        login_page_link_forgot: '忘记密码',
        login_page_link_signup: '注册',
        login_page_link_password: '密码登录',
        login_page_link_login: '登录',
        login_page_wechat: '微信登录',
        login_page_wechat_title: '微信登录',
        login_page_wechat_subtitle: '打开微信扫一扫登录',
        login_page_wechat_reload: '点击刷新',
        login_page_wechat_qrcode_overdue: '二维码已过期',
        login_page_bindphone_title: '绑定手机号',
        login_page_bindphone_form_phone_placeholder: '请输入手机号',
        login_page_bindphone_form_captcha_placeholder: '输入验证码',
        login_page_bindphone_form_send_captcha: '发送验证码',
        login_page_bindphone_form_send_captcha_seconds: 's后可发送',
        login_page_form_verification_message_1: '账号和密码不能为空',
        login_page_form_verification_message_2: '请填写手机号',
        login_page_form_verification_message_3: '手机号格式不正确',
        login_page_form_verification_message_4: '手机号和密码不能为空',
        login_page_form_sent_captcha_message: '验证码已发送，请注意查收',
        login_page_bindphone_form_verification_message_1: '请输入手机号',
        login_page_bindphone_form_verification_message_2: '手机号格式不正确',
        login_page_bindphone_form_verification_message_3: '请输入验证码',

        forget_page_title: '忘记密码',
        forget_page_form_title: '忘记密码',
        forget_page_form_phone_placeholder: '输入手机号',
        forget_page_form_captcha_placeholder: '输入验证码',
        forget_page_form_password_placeholder: '输入新密码',
        forget_page_form_button: '确定',
        forget_page_form_verification_message_1: '请输入手机号',
        forget_page_form_verification_message_2: '手机号格式不正确',
        forget_page_form_verification_message_3: '请输入验证码',
        forget_page_form_verification_message_4: '请输入密码',
        forget_page_form_verification_message_5: '密码必须包含小写字母和数字，长度6-20位',
        forget_page_form_submit_success: '密码修改成功, 1s后自动跳转到登录页面。',
        forget_page_form_sent_captcha_message: '验证码已发送，请注意查收',

        signup_page_title: '用户注册',
        signup_page_form_title: '手机号注册',
        signup_page_form_title_2: '邮箱注册',
        signup_page_form_phone_placeholder: '输入手机号',
        signup_page_form_email_placeholder: '输入邮箱',
        signup_page_form_captcha_placeholder: '输入验证码',
        signup_page_form_password_placeholder: '输入密码',
        signup_page_form_invite_code_placeholder: '输入邀请码（选填）',
        signup_page_form_send_captcha: '发送验证码',
        signup_page_form_send_captcha_seconds: 's后可发送',
        signup_page_form_send_captcha_tip_1: '收不到验证码？',
        signup_page_form_clause_prefix: '注册即代表同意',
        signup_page_form_button: '注册',
        signup_page_form_verification_message_1: '请输入手机号',
        signup_page_form_verification_message_2: '手机号格式不正确',
        signup_page_form_verification_message_3: '请输入验证码',
        signup_page_form_verification_message_4: '请输入密码',
        signup_page_form_verification_message_5: '密码必须包含小写字母和数字，长度6-20位',
        signup_page_form_verification_message_6: '请输入邮箱',
        signup_page_form_verification_message_7: '邮箱格式不正确',
        signup_page_form_submit_success: '注册成功,2s后自动进入系统',
        signup_page_form_sent_captcha_message: '验证码已发送，请注意查收',

        check_page_title: '切换组织',
        check_page_switch_header: '切换组织',
        check_page_switch_message_1: '当前正在登录',
        check_page_switch_message_2: '是否要切换至',
        check_page_switch_message_3: '组织？',
        check_page_switch_button_1: '取消',
        check_page_switch_button_2: '确定',
        project_index_page_title: '我的项目',
        project_list_page_title: '项目详情',
        project_template_page_title: '项目模板',
        project_templateDetail_page_title: '项目模版详情',
        project_templateNew_page_title: '新建项目模版',
        project_taskStatistics_page_title: '项目任务统计',
        project_create_page_title: '新建项目',
        task_list_index_page_title: '我的任务',
        task_statistics_index_page_title: '任务统计',
        workbench_editer_page_title: '编辑器',
        asset_term_index_page_title: '术语库',
        asset_term_detail_page_title: '术语库详情',
        asset_memory_index_page_title: '记忆库',
        asset_memory_detail_page_title: '记忆库详情',
        tools_page_title: 'Y魔方',
        tools_align_index_page_title: '语料对齐',
        tools_align_detail_page_title: '语料对齐详情（AI）',
        tools_align_tiled_page_title: '语料对齐详情（规则）',
        tools_termExtraction_index_page_title: '术语提取',
        tools_termExtraction_detail_page_title: '术语提取详情',
        tools_qa_index_page_title: 'QA检查',
        tools_qa_detail_page_title: 'QA检查详情',
        tools_detector_index_page_title: '机翻检测器',
        tools_detector_detail_page_title: '机翻检测结果',
        tools_polish_index_page_title: 'AI润色',
        tools_videoTranslate_index_page_title: 'AI译配',
        tools_videoTranslate_editer_page_title: 'AI译配 - 字幕编辑',
        tools_gptTranslate_index_page_title: '文档智能体',
        tools_gptTranslate_history_page_title: '文档智能体历史',
        tools_translationScore_index_page_title: 'AI翻译评分',
        engine_index_page_title: '我的翻译模型',
        engine_quickCreate_page_title: '快速训练',
        engine_configNew_page_title: '翻译模型',
        engine_detail_page_title: '模型详情',
        engine_share_page_title: '模型分享',
        team_index_page_title: '团队管理',
        team_invite_page_title: '邀请加入团队',
        account_page_title: '个人中心',
        account_index_page_title: '我的账户',
        account_vip_page_title: '我的会员',
        account_orders_page_title: '我的订单',
        account_invite_page_title: '邀请好友',
        account_chars_page_title: '流量列表',
        account_charHistory_page_title: '流量监测',
        account_orgInfo_page_title: '企业信息',
        account_agentToken_page_title: '智能体Token',
    },
    account: {
        component_ChangeEmail_dialog_title: '绑定/更改邮箱',
        component_ChangeEmail_dialog_placeholder_1: '输入邮箱',
        component_ChangeEmail_dialog_placeholder_2: '输入验证码',
        component_ChangeEmail_dialog_tips_1: '{second}后可发送',
        component_ChangeEmail_dialog_tips_2: '发送验证码',
        component_ChangeEmail_dialog_btn_1: '取消',
        component_ChangeEmail_dialog_btn_2: '确认修改',
        component_ChangeEmail_data_message_1: '请输入邮箱',
        component_ChangeEmail_data_message_2: '邮箱格式不正确',
        component_ChangeEmail_data_formRules_captcha_message: '请输入验证码',
        component_ChangeEmail_method_getCaptcha_message_1: '请填写邮箱',
        component_ChangeEmail_method_getCaptcha_message_2: '邮箱格式不正确',
        component_ChangeEmail_method_getCaptcha_message_3: '验证码已发送，请注意查收',
        component_ChangeEmail_method_submitChangeEmail_message_1: '绑定/更改邮箱成功',
        component_ChangeNickname_dialog_title: '修改昵称',
        component_ChangeNickname_dialog_placeholder_1: '输入昵称',
        component_ChangeNickname_dialog_btn_1: '确认修改',
        component_ChangeNickname_data_formRules_message: '请输入昵称',
        component_ChangeNickname_method_submitChangeNickname_message: '昵称修改成功',

        component_ChangePassword_dialog_title: '更改密码',
        component_ChangePassword_dialog_placeholder_1: '输入旧密码',
        component_ChangePassword_dialog_placeholder_2: '输入新密码',
        component_ChangePassword_dialog_placeholder_3: '再次输入新密码',
        component_ChangePassword_dialog_btn_1: '取消',
        component_ChangePassword_dialog_btn_2: '确认修改',
        component_ChangePassword_data_message_1: '请输入新密码',
        component_ChangePassword_data_message_2: '新密码必须是6-20位大小写英文字母和数字',
        component_ChangePassword_data_message_3: '请再次输入新密码',
        component_ChangePassword_data_message_4: '两次输入密码不一致',
        component_ChangePassword_data_formRules_message: '请输入旧密码',
        component_ChangePassword_method_submitChangePassword_message_1: '密码已修改',

        component_ChangePhone_dialog_title: '绑定/更改手机号',
        component_ChangePhone_dialog_placeholder_1: '输入新手机号',
        component_ChangePhone_dialog_placeholder_2: '输入验证码',
        component_ChangePhone_dialog_tips_1: '{second}后可发送',
        component_ChangePhone_dialog_tips_2: '发送验证码',
        component_ChangePhone_dialog_btn_1: '取消',
        component_ChangePhone_dialog_btn_2: '确认修改',
        component_ChangePhone_data_message_1: '请输入新手机号',
        component_ChangePhone_data_formRules_message_1: '请输入手机验证码',
        component_ChangePhone_method_getCaptcha_message_1: '请填写手机号',
        component_ChangePhone_method_getCaptcha_message_2: '验证码已发送，请注意查收',
        component_ChangePhone_method_submitChangePhone_message_1: '绑定/更改手机号成功',

        AccountRouter_page_created_navList_1_name: '我的会员',
        AccountRouter_page_created_navList_2_name: '我的账户',
        AccountRouter_page_created_navList_3_name: '企业信息',
        AccountRouter_page_created_navList_4_name: '智能体Token',
        AccountRouter_page_created_navList_5_name: '我的订单',
        AccountRouter_page_created_navList_6_name: '流量监测',
        AccountRouter_page_created_navList_7_name: '邀请好友',

        AgentToken_page_tips_1: '智能体Token',
        AgentToken_page_tips_2: 'Token流量：',
        AgentToken_page_tips_3: '智能体服务不可用字符包/会员消费，需要充值Token流量才可使用',
        AgentToken_page_tips_4: '剩',
        AgentToken_page_tips_5: '1 token≈1 中文字/外文单词',
        AgentToken_page_tips_6: '￥{price}元',
        AgentToken_page_tips_7: '立即购买',
        AgentToken_page_tips_8: '更多Token',
        AgentToken_page_tips_9: '联系我们',

        CharHistory_page_tips_1: '流量监测',
        CharHistory_page_table_column_1: '成员',
        CharHistory_page_table_column_2: '角色',
        CharHistory_page_table_column_3: '模块',
        CharHistory_page_table_column_4: '字符数',
        CharHistory_page_table_column_5: '日期',

        Chars_page_tips_1: '我的流量',
        Chars_page_tips_2: '剩{remain}字符 / 总{total}字符',
        Chars_page_btn_1: '字符包',
        Chars_page_table_column_1: '生效时间',
        Chars_page_table_column_2: '到期时间',
        Chars_page_table_column_3: '余量',

        Index_page_tips_1: '基础信息',
        Index_page_tips_2: '头像',
        Index_page_tips_3: '昵称',
        Index_page_tips_4: '无昵称',
        Index_page_tips_5: '账户管理',
        Index_page_tips_6: '手机号码',
        Index_page_tips_7: '未绑定，绑定后获得更好体验',
        Index_page_tips_8: '更改',
        Index_page_tips_9: '绑定',
        Index_page_tips_10: '已绑定，可通过微信扫码登录',
        Index_page_tips_11: '微信',
        Index_page_tips_12: '解绑',
        Index_page_tips_13: '邮箱',
        Index_page_tips_14: '账户密码',
        Index_page_tips_15: '已设置，可通过账号密码登录',
        Index_page_alertDialog_message: '确定要解除绑定吗？',
        Index_page_alertDialog_buttonName: '确定',
        Index_page_method_changeBindEvent_message_1: '请先绑定手机号',
        Index_page_method_unbindWechatConfirmEvent_message_1: '解绑成功',

        Invite_page_tips_1: '邀请好友，赢字符包',
        Invite_page_tips_2: '好友成功注册后，你和好友都可获得1万字符',
        Invite_page_tips_3: '我的邀请记录',
        Invite_page_tips_4: '你最多可获得20万字符奖励',
        Invite_page_tips_5: '已成功邀请{person}人，已获得{traffics}字符奖励',
        Invite_page_tips_6: '使用 {code} 邀请码成功注册',
        Invite_page_tips_7: '暂无邀请记录',
        Invite_page_tips_8: '{name}邀请你来注册LanguageX，点击我的专属链接注册，可以获得1万字符：{link}；邀请码：{code}',
        Invite_page_tips_9: '已复制到剪切板',
        Invite_page_tips_10: '复制到剪切板失败，请重试',
        Invite_page_btn_1: '复制邀请链接',
        Invite_page_btn_2: '立即邀请',
        Orders_page_tips_1: '我的订单',
        Orders_page_btn_1: '申请开票',
        Orders_page_table_column_1: '订单号',
        Orders_page_table_column_2: '订单生成日期',
        Orders_page_table_column_3: '购买商品',
        Orders_page_table_column_4: '支付类型',
        Orders_page_table_column_5: '支付金额',
        Orders_page_table_column_6: '订单状态',
        OrgInfo_page_tips_1: '基本信息',
        OrgInfo_page_tips_2: '版本信息',
        OrgInfo_page_tips_3: 'AI翻译系统MT V1.7',
        OrgInfo_page_tips_4: 'AI辅助翻译项目管理系统TMS V1.3',
        OrgInfo_page_tips_5: 'AI独立工具 Agen V1.5',
        OrgInfo_page_tips_6: '头像',
        OrgInfo_page_tips_7: '公司名称',
        OrgInfo_page_tips_8: '公司邮箱',
        OrgInfo_page_tips_9: '联系人',
        OrgInfo_page_tips_10: '联系电话',
        OrgInfo_page_tips_11: '公司简介',
        OrgInfo_page_tips_12: '还未填写公司简介',
        OrgInfo_page_btn_1: '修改信息',
        OrgInfo_page_dialog_1_title: '修改信息',
        OrgInfo_page_dialog_1_form_item_1_label: '头像',
        OrgInfo_page_dialog_1_form_item_2_label: '企业名称',
        OrgInfo_page_dialog_1_form_item_3_label: '企业邮箱',
        OrgInfo_page_dialog_1_form_item_4_label: '联系人',
        OrgInfo_page_dialog_1_form_item_5_label: '联系手机',
        OrgInfo_page_dialog_1_form_item_6_label: '公司简介',
        OrgInfo_page_dialog_1_placeholder_1: '请输入企业名称',
        OrgInfo_page_dialog_1_placeholder_2: '请输入企业邮箱',
        OrgInfo_page_dialog_1_placeholder_3: '请输入联系人',
        OrgInfo_page_dialog_1_placeholder_4: '请输入联系手机',
        OrgInfo_page_dialog_1_placeholder_5: '请输入公司简介',
        OrgInfo_page_dialog_1_btn_1: '取消',
        OrgInfo_page_dialog_1_btn_2: '确定',
        OrgInfo_page_method_submitForm_message_1: '请填写企业名称',
        OrgInfo_page_method_submitForm_message_2: '请填写联系人',
        OrgInfo_page_method_submitForm_message_3: '请填写正确的手机号',
        OrgInfo_page_method_submitForm_message_4: '请填写联系手机',
        OrgInfo_page_method_submitForm_message_5: '请填写正确的邮箱',
        OrgInfo_page_method_submitForm_message_6: '修改成功',

        Vip_page_tips_1: '{date}到期',
        Vip_page_tips_2: '已到期',
        Vip_page_tips_3: '账户升级享受更多权益',
        Vip_page_tips_4: '总流量字符',
        Vip_page_tips_5: '{type}流量字符+购买的字符包',
        Vip_page_tips_6: '查看详情',
        Vip_page_tips_7: '不限字符',
        Vip_page_tips_8: '剩{surplus}字符',
        Vip_page_tips_9: '总{total}字符',
        Vip_page_tips_10: '字符包',
        Vip_page_tips_11: '会员',
        Vip_page_tips_12: '字符包',
        Vip_page_tips_13: '申请试用',
        Vip_page_tips_14: '审核中',
        Vip_page_tips_15: '立即购买',
        Vip_page_tips_16: '立即续费',
        Vip_page_tips_17: '联系我们',
        Vip_page_tips_18: '{number}万字符',
        Vip_page_tips_19: '￥{price}元',
        Vip_page_tips_20: '相当于{price}元/万字符',
        Vip_page_tips_21: '立即购买',
        Vip_page_tips_22: '联系我们',
        Vip_page_tips_23: '1亿字以上',
        Vip_page_tips_24: '*文档翻译、文本翻译、AI工具箱均按照原文字符数消耗流量。会员服务：自购买日起一个自然月（年）内，会员权益生效。系统赠送给用户的流量字符每月更新，不结转，用户单独购买的字符包为一年有效期（',
        Vip_page_tips_25: '查看流量字符说明',
        Vip_page_tips_26: '）。活动解释权归LanguageX所有。',
        Vip_page_tips_27: '当前账号未绑定手机号，请绑定后再继续操作',
        Vip_page_tips_28: '去绑定',
        Vip_page_tips_29: '查看详细权益对比',
        Vip_page_dialog_1_title: '试用Pro版',
        Vip_page_dialog_1_tips_1: '你可以试用7天，试用期间或结束后可以随时续订，到期后未续订，会回退到Free版。',
        Vip_page_dialog_1_btn_1: '取消',
        Vip_page_dialog_1_btn_2: '免费试用',
        Vip_page_dialog_2_title: '申请信息',
        Vip_page_dialog_2_tips_1: '已成功提交申请',
        Vip_page_dialog_2_tips_2: '通过审核后会为您创建组织，请注意查看',
        Vip_page_dialog_2_tips_3: '请扫码添加微信，备注姓名+企业/高校名称+手机号',
        Vip_page_dialog_2_tips_4: '仅用于联系您使用，请放心填写！',
        Vip_page_dialog_2_tips_5: '请上传申请表附件',
        Vip_page_dialog_2_tips_6: '下载申请表样例',
        Vip_page_dialog_2_tips_7: '点击上传附件',
        Vip_page_dialog_2_form_item_1_label: '联系人',
        Vip_page_dialog_2_form_item_2_label: '职务',
        Vip_page_dialog_2_form_item_3_label: '联系手机',
        Vip_page_dialog_2_form_item_4_label: '邮箱',
        Vip_page_dialog_2_form_item_5_label_1: '机构名称',
        Vip_page_dialog_2_form_item_5_label_2: '高校名称',
        Vip_page_dialog_2_form_item_6_label: '所授课程',
        Vip_page_dialog_2_form_item_7_label: '成员人数',
        Vip_page_dialog_2_form_item_8_label: '使用LanguageX的主要场景',
        Vip_page_dialog_2_placeholder_1: '请输入联系人',
        Vip_page_dialog_2_placeholder_2: '请输入职务',
        Vip_page_dialog_2_placeholder_3: '请输入联系手机',
        Vip_page_dialog_2_placeholder_4_1: '请输入企业邮箱',
        Vip_page_dialog_2_placeholder_4_2: '请输入高校邮箱',
        Vip_page_dialog_2_placeholder_5_1: '请输入机构名称',
        Vip_page_dialog_2_placeholder_5_2: '请输入高校名称',
        Vip_page_dialog_2_placeholder_6: '请输入所授课程',
        Vip_page_dialog_2_placeholder_7: '请输入成员人数',
        Vip_page_dialog_2_placeholder_8: '请输入使用LanguageX的主要场景',
        Vip_page_dialog_2_btn_1: '确定',
        Vip_page_dialog_2_btn_2: '取消',
        Vip_page_dialog_3_title: '申请信息',
        Vip_page_dialog_3_tips_1: '已成功提交企业版试用申请',
        Vip_page_dialog_3_tips_2: '联系我们加急处理',
        Vip_page_dialog_3_btn_1: '确定',

        Vip_page_method_submitTrialBtnEvent_message_1: '申请成功',
        Vip_page_method_submitContactsForm_message_1: '请填写联系人',
        Vip_page_method_submitContactsForm_message_2: '请填写联系手机',
        Vip_page_method_submitContactsForm_message_3: '请填正确的手机号',
        Vip_page_method_submitContactsForm_message_4: '请填写邮箱',
        Vip_page_method_submitContactsForm_message_5: '请填正确的邮箱',
        Vip_page_method_submitContactsForm_message_6: '请填写机构名称',
        Vip_page_method_submitContactsForm_message_7: '请选择成员人数',
        Vip_page_method_submitContactsForm_message_8: '请填写使用LanguageX的主要场景',
        Vip_page_method_submitContactsForm_message_9: '请填写职务',
        Vip_page_method_submitContactsForm_message_10: '请填写所授课程',
        Vip_page_method_submitContactsForm_message_11: '请上传申请表附件',





    },
    workbench: {
        editer_page_dialog_1_title: '筛选句段',
        editer_page_dialog_1_search_input_label: '关键词',
        editer_page_dialog_1_search_input_placeholder: '输入关键词',
        editer_page_dialog_1_group_1_title: '确认',
        editer_page_dialog_1_group_1_item_1_label: '全部',
        editer_page_dialog_1_group_1_item_2_label: '未确认',
        editer_page_dialog_1_group_1_item_3_label: '已确认',
        editer_page_dialog_1_group_2_title: '锁定',
        editer_page_dialog_1_group_2_item_1_label: '全部',
        editer_page_dialog_1_group_2_item_2_label: '未锁定',
        editer_page_dialog_1_group_2_item_3_label: '已锁定',
        editer_page_dialog_1_group_3_title: '译文来源',
        editer_page_dialog_1_group_3_item_1_label: '全部',
        editer_page_dialog_1_group_3_item_2_label: '翻译记忆',
        editer_page_dialog_1_group_3_item_3_label: '机器翻译',
        editer_page_dialog_1_group_4_title: 'QA',
        editer_page_dialog_1_group_4_item_1_label: '全部',
        editer_page_dialog_1_group_4_item_2_label: '无QA错误',
        editer_page_dialog_1_group_4_item_3_label: '有QA错误',
        editer_page_dialog_1_group_5_title: '批注',
        editer_page_dialog_1_group_5_item_1_label: '全部',
        editer_page_dialog_1_group_5_item_2_label: '无批注',
        editer_page_dialog_1_group_5_item_3_label: '有批注',
        editer_page_dialog_1_group_6_title: '自动评分',
        editer_page_dialog_1_group_6_item_1_label: '全部',
        editer_page_dialog_1_group_6_item_2_label: '低风险',
        editer_page_dialog_1_group_6_item_3_label: '高风险',
        editer_page_dialog_1_group_7_title: '句段属性',
        editer_page_dialog_1_group_7_item_1_label: '自动替换',
        editer_page_dialog_1_group_7_item_2_label: '项目内重复',
        editer_page_dialog_1_group_7_item_3_label: '非译元素',
        editer_page_dialog_1_group_7_item_4_label: '全部',
        
        editer_page_dialog_1_btn_1_label: '重置',
        editer_page_dialog_1_btn_2_label: '确认',
        editer_page_dialog_2_title: '提示',
        editer_page_dialog_2_btn_1_label: '取消',
        editer_page_dialog_2_btn_2_label: '返回',
        editer_page_data_loadingText: '加载中…',
        editer_page_methods_initPage_editorPermissionMessage_message: '暂无编辑权限',
        editer_page_methods_saveDocuments_success_message: '保存成功',
        editer_page_methods_applyJargon_error_message: '当前句段为锁定状态，不可应用术语',
        editer_page_methods_applyTranslate_error_message: '当前句段为锁定状态，不可应用机器翻译',
        editer_page_methods_applyMemory_error_message: '当前句段为锁定状态，不可应用翻译记忆',
        editer_page_methods_reTranslate_loadingText: '正在重译所有包含该术语的句段…',
        editer_page_methods_reTranslate_success_message_1: '已重译该条术语所在的 {size} 个句段',
        editer_page_methods_reTranslate_success_message_2: '没有找到需要重译的术语',
        editer_page_methods_setQAProblemFlag_message_1: '当前句段已锁定，请先解锁再操作',
        editer_page_methods_repealOrRecoverBtnEvent_success_message_1: '已撤销',
        editer_page_methods_repealOrRecoverBtnEvent_success_message_2: '已恢复',
        editer_page_methods_setSentencesStyle_error_message: '仅支持{types}格式设置样式',
        editer_page_methods_setSplitMode_error_message: '请选择句段',
        editer_page_methods_setSplitMode_info_message: '当前句段已进入拆分模式，确定光标位置即可拆分',
        editer_page_methods_submitSplit_error_message: '不支持光标在句首或者句尾拆分',
        editer_page_methods_submitSplit_success_message: '句段拆分成功',
        editer_page_methods_submitMarge_error_message: '当前已是本页最后一条，无法合并下一句',
        editer_page_methods_submitMarge_error_message_1: '请选择句段',
        editer_page_methods_submitMarge_success_message: '句段已合并',
        editer_page_methods_saveEditSource_success_message: '原文已保存',
        editer_page_methods_qaApplyReferenceEvent_error_message: '暂无编辑权限',
        editer_page_methods_startFillTags_success_message: '已对所有有译文的句段填充{size}句标签',
        editer_page_methods_startFillTags_loadingText_1: 'AI标签填充中，请稍后',
        editer_page_methods_startFillSentenceTags_error_message: '译文不可为空',
        editer_page_methods_startFillSentenceTags_info_message: '正在提取原文标签并插入到译文对应位置中',
        editer_page_methods_setTaskStatus_success_message: '提交成功',
        editer_page_methods_setTaskStatus_loadingText: '提交中，请稍后',
        editer_page_methods_quickSubmit_success_message: '一键确认成功',
        editer_page_methods_quickSubmit_loadingText: '一键确认中，请稍后',
        editer_page_methods_downloadStyleGuide_file_title: '风格指南',
        editer_page_methods_getMTScoreEvent_message_1: '自动评分进行中，请稍后刷新页面查看',
        editer_page_methods_executeAction_message_1: '选择句段后再编辑原文',
        editer_page_methods_executeAction_message_2: '当前句段已进入原文模式，点击原文即可编辑',
        editer_page_methods_executeAction_message_3: 'Pro版专属功能，升级为Pro版可用。',
        editer_page_methods_executeAction_message_3_1: '去升级',
        editer_page_methods_executeAction_message_4: '暂不支持csv、txt、srt等类型的文件填充标签',
        editer_page_methods_beforeRouteLeave_warning_message: '自动保存中，请稍后',

        component_Tools_pageTitle_form_item_label_1: '语言方向',
        component_Tools_pageTitle_engine_name_1: '{name}提供基础翻译',
        component_Tools_pageTitle_engine_name_2: 'LanguageX提供交互式翻译',
        component_Tools_pageTitle_save_tips_1: '保存中...',
        component_Tools_pageTitle_save_tips_2: '已保存',
        component_Tools_pageTitle_progress_tips: '{type}进度：{value}%',
        component_Tools_pageTitle_changeInteractiveMode_select_placeholder: '切换编辑模式',
        component_Tools_pageTitle_changeInteractiveMode_select_option_1: '交互式翻译',
        component_Tools_pageTitle_changeInteractiveMode_select_option_2: '译后编辑',
        component_Tools_pageTitle_submitTask_btn_label: '提交',
        component_Tools_pageTitle_rollbackTask_btn_label: '退回',
        component_Tools_pageTitle_download_btn_label_1: '下载',
        component_Tools_pageTitle_download_btn_label_2: '译文',
        component_Tools_pageTitle_download_btn_label_3: '原/译对照',
        component_Tools_pageTitle_download_btn_label_4: '原文',
        component_Tools_pageTitle_download_btn_label_5: 'TMX',
        component_Tools_pageTitle_download_btn_label_6: '译/原对照',
        component_Tools_actionContent_btn_label_1: '保存',
        component_Tools_actionContent_btn_label_2: '撤销',
        component_Tools_actionContent_btn_label_3: '恢复',
        component_Tools_actionContent_btn_label_4: '查找替换',
        component_Tools_actionContent_btn_label_5: '搜索记忆库',
        component_Tools_actionContent_btn_label_6: '术语定制',
        component_Tools_actionContent_btn_label_7: '填充标签',
        component_Tools_actionContent_btn_label_8: '一键确认',
        component_Tools_actionContent_btn_label_9: '拆分',
        component_Tools_actionContent_btn_label_10: '合并',
        component_Tools_actionContent_btn_label_10_title: '合并下一句到当前句',
        component_Tools_actionContent_btn_label_11: '编辑原文',
        component_Tools_actionContent_btn_label_12: '复制原文',
        component_Tools_actionContent_btn_label_12_title: '将当前句段原文内容填充到译文',
        component_Tools_actionContent_btn_label_13: '复制标签',
        component_Tools_actionContent_btn_label_13_title: '将当前句段原文标签填充到译文',
        component_Tools_actionContent_btn_label_14: '获取机翻',
        component_Tools_actionContent_btn_label_15: '锁定',
        component_Tools_actionContent_btn_label_16: '加粗',
        component_Tools_actionContent_btn_label_17: '斜体',
        component_Tools_actionContent_btn_label_18: '下划线',
        component_Tools_actionContent_btn_label_19: '上标',
        component_Tools_actionContent_btn_label_20: '下标',
        component_Tools_actionContent_btn_label_21: '批注',
        component_Tools_actionContent_btn_label_22: '筛选',
        component_Tools_actionContent_btn_label_23: 'QA',
        component_Tools_actionContent_btn_label_24: '风格指南',
        component_Tools_actionContent_btn_label_24_title: '下载风格指南',
        component_Tools_actionContent_btn_label_25: '更多设置',
        component_Tools_actionContent_btn_label_26: '字号',
        component_Tools_actionContent_btn_label_27: '快捷键',
        component_Tools_actionContent_btn_label_28: '编辑痕迹',
        component_Tools_actionContent_btn_label_29: '收起',
        component_Tools_actionContent_btn_label_30: '展开',
        component_Tools_actionContent_btn_label_31: '显示空格',
        component_Tools_actionContent_btn_label_32: '隐藏空格',
        component_Tools_actionContent_btn_label_33: '自动评分',
        component_Tools_actionContent_btn_label_34: '分',
        component_Tools_dialog_1_title: '任务列表',
        component_Tools_dialog_1_table_column_1: '负责人',
        component_Tools_dialog_1_table_column_2: '任务类型',
        component_Tools_dialog_1_table_column_3: '进度',
        component_Tools_dialog_1_table_column_4: '状态',
        component_Tools_dialog_1_table_column_5: '退回记录',
        component_Tools_dialog_1_table_message_1: '被退回{size}次',
        component_Tools_dialog_2_title: '退回任务',
        component_Tools_dialog_2_message_1: '任务将退回至',
        component_Tools_dialog_2_message_2: '阶段',
        component_Tools_dialog_2_form_item_label_1: '退回原因',
        component_Tools_dialog_2_form_item_placeholder_1: '填写退回原因',
        component_Tools_dialog_2_btn_1: '取消',
        component_Tools_dialog_2_btn_2: '确定',
        component_Tools_dialog_3_title: '字号',
        component_Tools_dialog_3_message_1: '文字大小',
        component_Tools_dialog_3_message_2: '小',
        component_Tools_dialog_3_message_3: '大',
        component_Tools_dialog_4_title: '快捷键',
        component_Tools_dialog_4_table_column_1: '功能',
        component_Tools_dialog_4_table_column_2: '快捷键',
        component_Tools_data_alertInfo_message_1: '切换回交互式翻译模式时，已确认句段会保留，未确认句段会清空，是否继续？',
        component_Tools_data_alertInfo_message_2: '切换回交互式翻译模式时，已确认句段会保留，未确认句段会清空，是否继续？',
        component_Tools_data_alertInfo_message_3: '确定提交吗？',
        component_Tools_data_alertInfo_message_4: '是否把所有句段改为已确认状态？空句段会自动填充机翻译文',
        component_Tools_data_alertInfo_buttonName_1: '确定',
        component_Tools_data_hotkeyList_name_1: '候选片段选择',
        component_Tools_data_hotkeyList_name_2: '整句应用机翻',
        component_Tools_data_hotkeyList_name_3: '译文确认',
        component_Tools_data_hotkeyList_name_4: '快速添加术语',
        component_Tools_data_hotkeyList_name_5: '搜索记忆库',
        component_Tools_method_progressFormat_message: '译者翻译进度：{percentage}%',
        component_Tools_method_jargonSettingEvent_message_1: 'Pro版专属功能，升级为Pro版可用。',
        component_Tools_method_jargonSettingEvent_message_2: '去升级',
        component_Tools_method_addEditFontSize_message: '已经是最大了',
        component_Tools_method_shrinkEditFontSize_message: '已经是最小了',
        component_Tools_method_getMTResult_message_1: '人工翻译，不可获取机翻',
        component_Tools_method_getMTResult_message_2: '请选择句段',
        component_Tools_method_rejectBtnEvent_message: '当前阶段不可退回',
        component_Tools_method_submitRejectEvent_message_1: '请填写退回原因',
        component_Tools_method_submitRejectEvent_message_2: '退回成功',
        component_BasicEditerV3_tips_1: '点击解锁',
        component_BasicEditerV3_tips_2: '点击锁定',
        component_BasicEditerV3_tips_3: '批注',
        component_BasicEditerV3_tips_4: '确定拆分',
        component_BasicEditerV3_tips_5: '退出拆分模式',
        component_BasicEditerV3_tips_6: '保存原文',
        component_BasicEditerV3_tips_7: '退出原文编辑模式',
        component_BasicEditerV3_tips_8: '查看QA检查结果',
        component_BasicEditerV3_tips_9: '确认（Enter）',
        component_BasicEditerV3_tips_10: '确认',
        component_BasicEditerV3_tips_11: '机翻译文疑似有风险',
        component_BasicEditerV3_tips_12: 'LanguageX提供交互式翻译',
        component_BasicEditerV3_tips_13: '{name}翻译',
        component_BasicEditerV3_dialog_1_title: '快速添加术语',
        component_BasicEditerV3_dialog_1_form_item_label_1: '原文',
        component_BasicEditerV3_dialog_1_form_item_placeholder_1: '请选择或输入原文',
        component_BasicEditerV3_dialog_1_form_item_label_2: '译文',
        component_BasicEditerV3_dialog_1_form_item_placeholder_2: '请选择或输入译文',
        component_BasicEditerV3_dialog_1_form_item_label_3: '备注',
        component_BasicEditerV3_dialog_1_form_item_placeholder_3: '请输入备注',
        component_BasicEditerV3_dialog_1_btn_1: '取消',
        component_BasicEditerV3_dialog_1_btn_2: '确定',
        component_BasicEditerV3_data_previewTypeList_name_1: '译文',
        component_BasicEditerV3_data_previewTypeList_name_2: '双语',
        component_BasicEditerV3_data_previewTypeList_name_3: '原文',
        component_BasicEditerV3_data_previewTypeList_name_4: '预览',
        component_BasicEditerV3_method_sourceTagEvent_message_1: '光标必须在译文输入框中',
        component_BasicEditerV3_method_sourceTagEvent_message_2: '当前复制的原文标签和译文输入框不匹配',
        component_BasicEditerV3_method_sourceTagEvent_message_3: '译文不可为空',
        component_BasicEditerV3_method_saveQuicklyAddTermEvent_message_1: '术语原文不能为空',
        component_BasicEditerV3_method_saveQuicklyAddTermEvent_message_2: '术语译文不能为空',
        component_BasicEditerV3_method_saveQuicklyAddTermEvent_message_3: '保存术语成功',
        component_BasicEditerV3_method_getSentSourceText_message_1: '重复句段',
        component_BasicEditerV3_method_getSentSourceText_message_2: '记忆库',
        component_BasicEditerV3_method_getSentSourceText_message_3: 'MT {score} ',
        component_BasicEditerV3_method_getSentSourceText_message_4: '非译元素',
        component_BasicEditerV3_method_getSentSourceText_message_5: '来源于{names}',
        component_BasicEditerV3_method_getSentSourceText_message_6: '分',
        component_BasicEditerV3_method_previewHtmlBtnEvent_message_1: '获取预览地址失败',
        component_BasicEditerV3_method_showQAPanel_message_1: '暂无编辑权限',
        component_CommentRight_title: '批注',
        component_CommentRight_tips_1: '关闭',
        component_CommentRight_empty_message: '暂无批注',
        component_CommentRight_input_placeholder: '输入批注',
        component_CommentRight_btn_1: '取消',
        component_CommentRight_btn_2: '提交',
        component_CommentRight_tips_2: '回车发送',
        component_CommentRight_data_alertInfo_message: '确定要删除这个批注吗？',
        component_CommentRight_data_alertInfo_buttonName: '确定',
        component_CommentRight_method_sendNewMessageEvent_message_1: '请选择句段后再提交批注',
        component_CommentRight_method_sendNewMessageEvent_message_2: '请输入批注内容',
        component_CommentRight_method_submitDeleteBtnEvent_message_1: '已删除批注',
        component_EditerRight_tips_1: '在我的所有记忆库/术语库中搜索',
        component_EditerRight_tips_2: '查询中...',
        component_EditerRight_tips_3: '点击插入到译文光标位置',
        component_EditerRight_tips_4: '备注：',
        component_EditerRight_tips_5: '记忆库名称：',
        component_EditerRight_tips_6: '创建人：',
        component_EditerRight_tips_7: '创建时间：',
        component_EditerRight_tips_8: '{name}翻译',
        component_EditerRight_tips_9: '翻译中...',
        component_EditerRight_tips_10: '最近更新时间：',
        component_EditerRight_tips_11: '最近更新人：',
        component_EditerRight_tips_12: '术语库名称：',
        component_EditerRight_tips_13: '创建人：',
        component_EditerRight_tips_14: '创建时间：',
        component_EditerRight_tips_15: '最近更新时间：',
        component_EditerRight_tips_16: '最近更新人：',
        component_EditerRight_tips_17: '来源文件名：',
        component_EditerRight_tips_18: '来源项目名：',
        component_EditerRight_tips_19: '来源文件：',
        component_EditerRight_tips_20: '更新人：',

        component_EditerRight_btn_1: '应用',
        component_EditerRight_chunk_title_1: '术语库',
        component_EditerRight_chunk_title_2: '翻译记忆',
        component_EditerRight_chunk_title_3: '机器翻译',
        component_EditerRight_chunk_title_4: '参考模型',
        component_EditerRight_chunk_title_5: '自动评分',
        component_EditerRight_chunk_empty_message_1: '没有找到相关术语',
        component_EditerRight_chunk_empty_message_2: '段落拆分模式不支持查询翻译记忆',
        component_EditerRight_chunk_empty_message_3: '没有找到相关翻译记忆',
        component_EditerRight_chunk_empty_message_4: '段落拆分模式不支持查询机器翻译',
        component_EditerRight_chunk_empty_message_5: '没有找到其他机器翻译结果',
        component_EditerRight_chunk_empty_message_6: '暂无自动评分结果',
        component_EditerRight_chunk_empty_message_7: 'AI对译文的评分，仅供参考',
        component_EditerRight_chunk_empty_message_8: '{score}分；扣分原因：',
        component_EditerRight_chunk_empty_message_9: '无',
        component_EditerRight_chunk_empty_message_10: '{type}：{reason}因此扣{score}分。',
        
        component_EditRecordRight_title: '编辑痕迹',
        component_EditRecordRight_tips_1: '刷新',
        component_EditRecordRight_tips_2: '关闭',
        component_EditRecordRight_empty_message: '没有留下任何编辑痕迹呢~',

        component_FindMTRight_search_input_placeholder: '在我的所有记忆库/术语库中搜索',
        component_FindMTRight_tabs_item_1: '记忆库',
        component_FindMTRight_tabs_item_2: '术语库',
        component_FindMTRight_tips_1: '复制译文',
        component_FindMTRight_empty_message_1: '暂无内容',
        component_FindMTRight_method_copyEvent_message_1: '已复制到剪切板',
        component_FindMTRight_method_copyEvent_message_2: '复制到剪切板失败，请重试',
        
        component_FindReplaceRight_title: '查找替换',
        component_FindReplaceRight_tips_1: '关闭',
        component_FindReplaceRight_tips_2: '点击定位',
        component_FindReplaceRight_tips_3: '句段',
        component_FindReplaceRight_tips_4: '点击替换',
        component_FindReplaceRight_form_item_1_label: '查找',
        component_FindReplaceRight_form_item_1_input_placeholder: '输入查找的原文或译文',
        component_FindReplaceRight_form_item_2_label: '替换为',
        component_FindReplaceRight_form_item_2_input_placeholder: '输入替换的内容，只能替换译文',
        component_FindReplaceRight_form_checkbox_label: 'Aa区分大小写',
        component_FindReplaceRight_btn_1: '查找',
        component_FindReplaceRight_btn_2: '全部替换',
        component_FindReplaceRight_btn_3: '撤销替换',
        component_FindReplaceRight_empty_message: '暂无内容',

        component_MenuActions_data_actionList_tip_1: '添加术语',
        component_MenuActions_data_actionList_tip_2: '搜索记忆库',
        component_MenuActions_data_actionList_tip_3: '批注',
        component_MenuActions_data_actionList_tip_4: '加粗',
        component_MenuActions_data_actionList_tip_5: '斜体',
        component_MenuActions_data_actionList_tip_6: '下划线',
        component_MenuActions_data_actionList_tip_7: '删除线',
        component_MenuActions_data_actionList_tip_8: '上标',
        component_MenuActions_data_actionList_tip_9: '下标',

        component_PreviewExcel_tips_1: '*预览格式可能和下载后的最终格式不同',
        component_PreviewPPT_tips_1: 'PPT暂不支持预览',
        component_PreviewWord_tips_1: '*预览格式可能和下载后的最终格式不同',
        
        component_QARight_title: 'QA检查',
        component_QARight_tips_1: '关闭',
        component_QARight_tips_2: 'QA设置',
        component_QARight_tips_3: '下载检查结果',
        component_QARight_tips_4: '忽略',
        component_QARight_tips_5:  '操作人：',
        component_QARight_tips_6: '取消忽略',
        component_QARight_tips_7: '复制建议',
        component_QARight_tips_8: '刷新',
        component_QARight_tabs_item_1: '全部',
        component_QARight_tabs_item_2: '查看QA忽略历史',
        component_QARight_empty_message_1: '再接再厉~已确认的句段没有检查出质量问题',
        component_QARight_empty_message_2: '暂无忽略的质量问题',
        component_QARight_method_downloadQAResult_title: '{name}QA报告',
        component_QARight_method_copyQASuggestBtnEvent_message_1: '已复制到剪切板',
        component_QARight_method_copyQASuggestBtnEvent_message_2: '复制到剪切板失败，请重试',

        component_ReferenceEngine_dialog_title: '更换参考模型',
        component_ReferenceEngine_dialog_btn_1: '取消',
        component_ReferenceEngine_dialog_btn_2: '确定',



    },
    config: {
        DOC_SETTING_OPTS_1_name: 'Word设置',
        DOC_SETTING_OPTS_1_options_1_label: '翻译隐藏内容',
        DOC_SETTING_OPTS_1_options_2_label: '翻译页眉、页脚',
        DOC_SETTING_OPTS_1_options_3_label: '翻译批注',
        DOC_SETTING_OPTS_1_options_4_label: '按照Tab分句',
        DOC_SETTING_OPTS_2_name: 'Excel设置',
        DOC_SETTING_OPTS_2_options_1_label: '翻译隐藏内容',
        DOC_SETTING_OPTS_2_options_2_label: '按照段落拆分',
        DOC_SETTING_OPTS_2_options_3_label: '多列解析',
        DOC_SETTING_OPTS_3_name: 'PPT设置',
        DOC_SETTING_OPTS_3_options_1_label: '翻译隐藏内容',

        FILE_ANALYSIS_SETTING_OPTS_1_name: '跨文件重复',
        FILE_ANALYSIS_SETTING_OPTS_2_name: '内部重复',
        FILE_ANALYSIS_SETTING_OPTS_3_name: '非译元素',
        FILE_ANALYSIS_SETTING_OPTS_4_name: '100%',
        FILE_ANALYSIS_SETTING_OPTS_5_name: '101%',
        FILE_ANALYSIS_SETTING_OPTS_6_name: '102%',
        FILE_ANALYSIS_SETTING_OPTS_7_name: '自动替换',
        FILE_ANALYSIS_SETTING_OPTS_8_name: '低风险句段',

        AUTO_REPLACE_OPTS_1_name: '数字',
        AUTO_REPLACE_OPTS_2_name: '时间',
        AUTO_REPLACE_OPTS_3_name: '日期',
        AUTO_REPLACE_OPTS_4_name: '度量单位',
        AUTO_REPLACE_OPTS_5_name: '字符串',

        TASK_IMPORT_ERROR_OPTS_TASK_NOT_EXIST: '任务信息不存在',
        TASK_IMPORT_ERROR_OPTS_TASK_STATUS_ABNORMAL: '任务状态异常',
        TASK_IMPORT_ERROR_OPTS_IMPORT_FILE_NON_EMPTY: '导入文件解析数据不能为空',
        TASK_IMPORT_ERROR_OPTS_FILE_TYPE_NOT_SUPPORTS: '不支持的文件类型',
        TASK_IMPORT_ERROR_OPTS_FILE_UPLOAD_FAILURE: '文件上传失败',
        TASK_IMPORT_ERROR_OPTS_FILE_DOES_NOT_EXIST: '解压文件不存在',
        TASK_IMPORT_ERROR_OPTS_NO_AVAILABLE_DATA: '无可执行有效导入数据',
        TASK_IMPORT_ERROR_OPTS_PARSE_TERM_FILE_HAS_ERROR: '解析文件有误',
        TASK_IMPORT_ERROR_OPTS_OPERATION_FAILURE: '操作失败',
    },
    team: {
        IndexInside_page_btn_1: '刷新',
        IndexInside_page_btn_2: '查看联系方式',
        IndexInside_page_placeholder_1: '输入姓名/手机号/邮箱',
        IndexInside_page_placeholder_2: '源语言',
        IndexInside_page_placeholder_3: '目标语言',
        IndexInside_page_placeholder_4: '按团队筛选',
        IndexInside_page_placeholder_5: '按角色筛选',
        IndexInside_page_table_column_1: '序号',
        IndexInside_page_table_column_2: '姓名',
        IndexInside_page_table_column_3: '角色',
        IndexInside_page_table_column_4: '语言',
        IndexInside_page_table_column_5: '团队',
        IndexInside_page_table_column_6: '系统编码',
        IndexInside_page_table_column_7: '操作',
        IndexInside_page_dialog_1_title: '联系方式',
        IndexInside_page_tips_1: '复制',
        IndexInside_page_method_copyText_message_1: '已复制到剪切板',
        IndexInside_page_method_copyText_message_2: '复制到剪切板失败，请重试',

        IndexNew_page_tab_1: '团队',
        IndexNew_page_tab_2: '成员',
        IndexNew_page_tab_3: '成员报价',
        IndexNew_page_tab_4: '成员审核',
        IndexNew_page_btn_1: '新建团队',
        IndexNew_page_btn_2: '刷新',
        IndexNew_page_btn_3: '新增报价',
        IndexNew_page_btn_4: '批量导入',
        IndexNew_page_btn_5: '邀请成员',
        IndexNew_page_placeholder_1: '输入关键词',
        IndexNew_page_placeholder_2: '搜索团队',
        IndexNew_page_placeholder_3: '搜索角色',
        IndexNew_page_placeholder_4: '角色',
        IndexNew_page_placeholder_5: '任务类型',
        IndexNew_page_placeholder_6: '源语言',
        IndexNew_page_placeholder_7: '目标语言',
        IndexNew_page_placeholder_8: '价格区间',
        IndexNew_page_table_column_1: '姓名',
        IndexNew_page_table_column_2: '角色',
        IndexNew_page_table_column_3: '语言方向',
        IndexNew_page_table_column_4: '任务类型',
        IndexNew_page_table_column_5: '任务单价',
        IndexNew_page_table_column_6: '币种',
        IndexNew_page_table_column_7: '计价单位',
        IndexNew_page_table_column_8: '添加时间',
        IndexNew_page_table_column_9: '操作',
        IndexNew_page_tips_1: '编辑',
        IndexNew_page_tips_2: '联系方式',
        IndexNew_page_tips_3: '删除',
        IndexNew_page_tips_4: '团队人数：',
        IndexNew_page_tips_5: '创建时间：',
        IndexNew_page_tips_6: '审核',
        IndexNew_page_tips_7: '查看联系方式',
        IndexNew_page_tips_8: '编辑信息',
        IndexNew_page_tips_9: '移交',
        IndexNew_page_tips_10: '查看',
        IndexNew_page_tips_11: '编辑',
        IndexNew_page_tips_12: '没有找到内容～',
        IndexNew_page_tips_13: '暂无内容～',
        IndexNew_page_tips_14: '确定要删除吗？',
        IndexNew_page_tips_15: '确认删除',
        IndexNew_page_dialog_1_title: '编辑成员',
        IndexNew_page_dialog_1_form_label_1: '姓名',
        IndexNew_page_dialog_1_form_placeholder_1: '请输入姓名',
        IndexNew_page_dialog_1_form_label_2: '角色',
        IndexNew_page_dialog_1_form_placeholder_2: '请选择角色',
        IndexNew_page_dialog_1_form_label_3: '手机号',
        IndexNew_page_dialog_1_form_placeholder_3: '请输入手机号',
        IndexNew_page_dialog_1_form_label_4: '邮箱',
        IndexNew_page_dialog_1_form_placeholder_4: '请输入邮箱',
        IndexNew_page_dialog_1_form_label_5: '所属团队',
        IndexNew_page_dialog_1_form_placeholder_5: '请选择团队',
        IndexNew_page_dialog_1_btn_1: '取消',
        IndexNew_page_dialog_1_btn_2: '保存',
        IndexNew_page_dialog_2_title: '邀请成员',
        IndexNew_page_dialog_2_tips_1: '其他用户可通过邀请链接申请加入团队',
        IndexNew_page_dialog_2_tips_2: '审核通过后成为正式成员',
        IndexNew_page_dialog_2_placeholder_1: '请输入内容',
        IndexNew_page_dialog_2_btn_1: '复制链接',
        IndexNew_page_dialog_3_title: '身份移交',
        IndexNew_page_dialog_3_tips_1: '权限变更成功',
        IndexNew_page_dialog_3_tips_2: '一个组织内只存在一个超级管理员，请谨慎操作',
        IndexNew_page_dialog_3_form_item_1: '管理员移交至',
        IndexNew_page_dialog_3_form_item_2: '您的角色变更为',
        IndexNew_page_dialog_3_placeholder_1: '请输入关键词搜索',
        IndexNew_page_dialog_3_placeholder_2: '请选择角色',
        IndexNew_page_dialog_3_btn_1: '确定',
        IndexNew_page_dialog_3_btn_2: '取消',
        IndexNew_page_dialog_1_btn_3: '移交',
        IndexNew_page_dialog_4_title: '审核人员',
        IndexNew_page_dialog_4_form_item_1: '角色',
        IndexNew_page_dialog_4_form_item_2: '姓名',
        IndexNew_page_dialog_4_form_item_3: '手机号',
        IndexNew_page_dialog_4_form_item_4: '邮箱',
        IndexNew_page_dialog_4_form_item_5: '所属团队',
        IndexNew_page_dialog_4_placeholder_1: '选择角色',
        IndexNew_page_dialog_4_placeholder_2: '请输入姓名',
        IndexNew_page_dialog_4_placeholder_3: '请输入手机号',
        IndexNew_page_dialog_4_placeholder_4: '输入邮箱',
        IndexNew_page_dialog_4_placeholder_5: '选择团队',
        IndexNew_page_dialog_4_btn_1: '拒绝',
        IndexNew_page_dialog_4_btn_2: '通过',
        IndexNew_page_dialog_5_title: '联系方式',
        IndexNew_page_dialog_5_tips_1: '复制',
        IndexNew_page_dialog_6_title_1: '编辑团队',
        IndexNew_page_dialog_6_title_2: '新建团队',
        IndexNew_page_dialog_6_form_item_1: '团队名称',
        IndexNew_page_dialog_6_placeholder_1: '请输入团队名称',
        IndexNew_page_dialog_6_btn_1: '取消',
        IndexNew_page_dialog_6_btn_2: '保存',
        IndexNew_page_dialog_7_title_1: '编辑成员报价',
        IndexNew_page_dialog_7_title_2: '新增成员报价',
        IndexNew_page_dialog_7_form_item_1: '选择成员',
        IndexNew_page_dialog_7_form_item_2: '手机号',
        IndexNew_page_dialog_7_form_item_3: '邮箱',
        IndexNew_page_dialog_7_form_item_4: '角色',
        IndexNew_page_dialog_7_form_item_5: '任务类型',
        IndexNew_page_dialog_7_form_item_6: '语言方向',
        IndexNew_page_dialog_7_form_item_7: '任务单价',
        IndexNew_page_dialog_7_form_item_8: '币种',
        IndexNew_page_dialog_7_form_item_9: '计价单位',
        IndexNew_page_dialog_7_placeholder_1: '选择成员后自动填充',
        IndexNew_page_dialog_7_placeholder_2: '任务类型',
        IndexNew_page_dialog_7_placeholder_3: '源语言',
        IndexNew_page_dialog_7_placeholder_4: '目标语言',
        IndexNew_page_dialog_7_placeholder_5: '输入单价',
        IndexNew_page_dialog_7_placeholder_6: '币种',
        IndexNew_page_dialog_7_placeholder_7: '计价单位',
        IndexNew_page_dialog_7_btn_1: '取消',
        IndexNew_page_dialog_7_btn_2: '确定',
        IndexNew_page_dialog_8_title: '批量导入',
        IndexNew_page_dialog_8_tips_1: '报价数据需按照模板格式提交，导入前请',
        IndexNew_page_dialog_8_tips_2: '下载模板',
        IndexNew_page_dialog_8_btn_1: '取消',
        IndexNew_page_dialog_8_btn_2: '确定',
        IndexNew_page_method_submitEditDialogForm_message_1: '请输入姓名',
        IndexNew_page_method_submitEditDialogForm_message_2: '请选择角色',
        IndexNew_page_method_submitEditDialogForm_message_3: '请输入手机号',
        IndexNew_page_method_submitEditDialogForm_message_4: '请输入正确的手机号',
        IndexNew_page_method_submitEditDialogForm_message_5: '请输入邮箱',
        IndexNew_page_method_submitEditDialogForm_message_6: '请输入正确的邮箱',
        IndexNew_page_method_submitEditDialogForm_message_7: '请选择所属团队',
        IndexNew_page_method_submitEditDialogForm_message_8: '修改成功',
        IndexNew_page_method_submitTransferDialogForm_message_1: '请选择管理员',
        IndexNew_page_method_submitTransferDialogForm_message_2: '请选择变更后的角色',
        IndexNew_page_method_submitDeleteEvent_message_1: '删除成功',
        IndexNew_page_method_copyText_message_1: '已复制到剪切板',
        IndexNew_page_method_copyText_message_2: '复制到剪切板失败，请重试',
        IndexNew_page_method_createTeamDialogForm_message_1: '请输入团队名称',
        IndexNew_page_method_createTeamDialogForm_message_2: '创建成功',
        IndexNew_page_method_copyShareLink_message_1: '{name}邀请你加入企业协作，快点击链接登录LanguageX平台，申请加入组织吧~\n{url}',
        IndexNew_page_method_copyShareLink_message_2: '已复制到剪切板',
        IndexNew_page_method_copyShareLink_message_3: '复制到剪切板失败，请重试',
        IndexNew_page_method_acceptApplyEvent_message_1: '请选择角色',
        IndexNew_page_method_acceptApplyEvent_message_2: '请选择团队',
        IndexNew_page_method_acceptApplyEvent_message_3: '已通过',
        IndexNew_page_method_refuseApplyEvent_message_1: '已拒绝',
        IndexNew_page_method_deleteMemberOfferBtnEvent_message_1: '删除成功',
        IndexNew_page_method_submitCreateMemberOfferDialogForm_message_1: '请选择成员',
        IndexNew_page_method_submitCreateMemberOfferDialogForm_message_2: '请选择任务类型',
        IndexNew_page_method_submitCreateMemberOfferDialogForm_message_3: '请选择源语言和目标语言',
        IndexNew_page_method_submitCreateMemberOfferDialogForm_message_4: '请选择币种',
        IndexNew_page_method_submitCreateMemberOfferDialogForm_message_5: '请选择计价单位',
        IndexNew_page_method_submitCreateMemberOfferDialogForm_message_6: '修改成功',
        IndexNew_page_method_submitCreateMemberOfferDialogForm_message_7: '创建成功',
        IndexNew_page_method_submitImportDialogEvent_message_1: '请确认已上传文件并上传成功',
        IndexNew_page_method_submitImportDialogEvent_message_2: '导入成功',

        Invite_page_tips_1: '个人信息',
        Invite_page_tips_2: '{name}邀请你加入企业团队，请填写个人信息后提交申请',
        Invite_page_form_item_label_1: '姓名',
        Invite_page_form_item_label_2: '手机号',
        Invite_page_form_item_label_3: '邮箱',

        Invite_page_placeholder_1: '输入姓名',
        Invite_page_placeholder_2: '输入手机号',
        Invite_page_placeholder_3: '输入邮箱',
        Invite_page_btn_1: '取消',
        Invite_page_btn_2: '申请加入',
        Invite_page_dialog_1_title: '提示',
        Invite_page_dialog_1_tips_1: '申请成功',
        Invite_page_dialog_1_tips_2: '您已申请加入{name}，',
        Invite_page_dialog_1_tips_3: '快去通知企业管理员审核吧！',
        Invite_page_dialog_1_btn_1: '好的',
        Invite_page_method_applyEvent_message_1: '请输入姓名',
        Invite_page_method_applyEvent_message_2: '请输入邮箱',
        Invite_page_method_applyEvent_message_3: '邮箱格式不合法',





    },
    
}


